/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: string;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: string;
  Upload: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: string;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
};

export type Queries = {
  __typename?: 'Queries';
  listCommunityInfo?: Maybe<CommunityOutput>;
  listPersonalCommunityInfo?: Maybe<CommunityOutput>;
  aggregatorsList?: Maybe<Array<Maybe<AggregatorOutput>>>;
  listCanaryNetworks?: Maybe<ListConfigurationOutput>;
  readTotalGlobalSimulationLocation?: Maybe<LocationTotalCount>;
  listGlobalSimulationLocation?: Maybe<Array<Maybe<LocationBoundaryOutput>>>;
  readGlobalSimulationLocation?: Maybe<SimulationLocationOutput>;
  listUserGlobalSimulationVisibility?: Maybe<Array<Maybe<SimulationLocationVisibilityOutput>>>;
  getUserGlobalLocationVisibility?: Maybe<Scalars['Boolean']>;
  listLiveEvents?: Maybe<Array<Maybe<LiveEventListOutput>>>;
  liveEventsRepresentation?: Maybe<LiveEventRepresentation>;
  areaSummary?: Maybe<Scalars['String']>;
  listCollaborations?: Maybe<ListConfigurationOutput>;
  availableMarkets?: Maybe<Array<Maybe<Scalars['String']>>>;
  listAvailableExternalConnection?: Maybe<Array<Maybe<ExternalConnectionConfigurationsOutput>>>;
  listApplicationStatus?: Maybe<Array<Maybe<ExternalConnectionApplicantOutput>>>;
  listAvailableExternalApplication?: Maybe<Array<Maybe<ExternalConnectionApplicantOutput>>>;
  availableUserRoles?: Maybe<AvailableUserRolesOutput>;
  readUserRole?: Maybe<UserRoleOutput>;
  listAdminStats?: Maybe<AdminStats>;
  listProjects?: Maybe<Array<Maybe<ProjectOutput>>>;
  readProject?: Maybe<ProjectOutput>;
  readLibrary?: Maybe<LibraryOutput>;
  listLibraries?: Maybe<ListLibraryOutput>;
  cloudCoverageProfiles?: Maybe<Scalars['String']>;
  readConfiguration?: Maybe<ConfigurationOutput>;
  listConfigurations?: Maybe<ListConfigurationOutput>;
  availableAreaTypes?: Maybe<AvailableAreaTypesOutput>;
  availableTargetDeviceKpis?: Maybe<Scalars['String']>;
  availableTargetMarketKpis?: Maybe<Scalars['String']>;
  simulationStatus?: Maybe<Scalars['JSONString']>;
  simulationResults?: Maybe<SimulationResultsData>;
  scoreboardResults?: Maybe<Scalars['JSONString']>;
  passwordResetEmail?: Maybe<Scalars['String']>;
  registeredUsers?: Maybe<Array<Maybe<UserOutput>>>;
};


export type QueriesListCanaryNetworksArgs = {
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueriesListGlobalSimulationLocationArgs = {
  minLat: Scalars['Float'];
  maxLat: Scalars['Float'];
  minLong: Scalars['Float'];
  maxLong: Scalars['Float'];
};


export type QueriesReadGlobalSimulationLocationArgs = {
  configUuid: Scalars['String'];
};


export type QueriesListLiveEventsArgs = {
  configUuid: Scalars['String'];
};


export type QueriesLiveEventsRepresentationArgs = {
  configUuid: Scalars['String'];
  time: Scalars['DateTime'];
};


export type QueriesAreaSummaryArgs = {
  configUuid: Scalars['String'];
};


export type QueriesListCollaborationsArgs = {
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueriesAvailableMarketsArgs = {
  configUuid: Scalars['String'];
};


export type QueriesListAvailableExternalConnectionArgs = {
  configUuid: Scalars['String'];
};


export type QueriesListApplicationStatusArgs = {
  configUuid: Scalars['String'];
};


export type QueriesListAvailableExternalApplicationArgs = {
  configUuid: Scalars['String'];
};


export type QueriesReadUserRoleArgs = {
  email?: Maybe<Scalars['String']>;
};


export type QueriesListAdminStatsArgs = {
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  userRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  emailSearch?: Maybe<Scalars['String']>;
};


export type QueriesListProjectsArgs = {
  search?: Maybe<Scalars['String']>;
  nrConfigs?: Maybe<Scalars['Int']>;
  private?: Maybe<Scalars['Boolean']>;
};


export type QueriesReadProjectArgs = {
  uuid: Scalars['String'];
};


export type QueriesReadLibraryArgs = {
  uuid: Scalars['String'];
};


export type QueriesListLibrariesArgs = {
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueriesReadConfigurationArgs = {
  uuid: Scalars['String'];
};


export type QueriesListConfigurationsArgs = {
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  projectUUID?: Maybe<Scalars['String']>;
};


export type QueriesSimulationStatusArgs = {
  jobId: Scalars['String'];
};


export type QueriesSimulationResultsArgs = {
  jobId: Scalars['String'];
  uuid: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  timeResolutionHrs?: Maybe<Scalars['Int']>;
};


export type QueriesScoreboardResultsArgs = {
  jobId: Scalars['String'];
};


export type QueriesPasswordResetEmailArgs = {
  email: Scalars['String'];
};

export type CommunityOutput = {
  __typename?: 'CommunityOutput';
  projects?: Maybe<Array<Maybe<CommunityProjectOutput>>>;
};

export type CommunityProjectOutput = {
  __typename?: 'CommunityProjectOutput';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  private?: Maybe<Scalars['Boolean']>;
  locationVisible?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  configurations?: Maybe<Array<Maybe<CommunityConfigurationOutput>>>;
};


export type CommunityConfigurationOutput = {
  __typename?: 'CommunityConfigurationOutput';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  type?: Maybe<ConfigType>;
  simulationId?: Maybe<Scalars['String']>;
  globalCumulativeNetEnergyFlow?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export enum ConfigType {
  Simulation = 'SIMULATION',
  Collaboration = 'COLLABORATION',
  CanaryNetwork = 'CANARY_NETWORK'
}

export type AggregatorOutput = {
  __typename?: 'AggregatorOutput';
  name: Scalars['String'];
  aggregatorUuid: Scalars['UUID'];
  configUuid: Scalars['UUID'];
  devicesList?: Maybe<Array<Maybe<DeviceOutput>>>;
};


export type DeviceOutput = {
  __typename?: 'DeviceOutput';
  deviceUuid: Scalars['UUID'];
  aggregatorUuid: Scalars['UUID'];
  configUuid: Scalars['UUID'];
  addedViaLiveEvent: Scalars['Boolean'];
};

export type ListConfigurationOutput = {
  __typename?: 'ListConfigurationOutput';
  totalCount?: Maybe<Scalars['Int']>;
  configurations?: Maybe<Array<Maybe<ConfigurationOutput>>>;
};

export type ConfigurationOutput = {
  __typename?: 'ConfigurationOutput';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  type?: Maybe<ConfigType>;
  cloudCoverageOptions?: Maybe<Scalars['JSONString']>;
  scenarioData?: Maybe<ScenarioOutput>;
  settingsData?: Maybe<SettingsOutput>;
  availableAreaTypes?: Maybe<AvailableAreaTypesOutput>;
  simulationResults?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  events?: Maybe<ConfigurationEvents>;
  timestamp?: Maybe<Scalars['DateTime']>;
  readOnly?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Project>;
  warnings?: Maybe<Scalars['String']>;
  areaSummary?: Maybe<ConfigurationDetails>;
  openForExternalApplications?: Maybe<Scalars['Boolean']>;
  resultsStatus?: Maybe<Scalars['String']>;
  resultsProgressInfo?: Maybe<ProgressInfo>;
  private?: Maybe<Scalars['Boolean']>;
  deviceAggregatorMapping?: Maybe<Scalars['JSONString']>;
};


export type ScenarioOutput = {
  __typename?: 'ScenarioOutput';
  representation?: Maybe<AreaOutput>;
  latest?: Maybe<AreaOutput>;
  initialDeviceCount?: Maybe<Scalars['JSONString']>;
  deviceCount?: Maybe<Scalars['JSONString']>;
  deviceCountNumber?: Maybe<Scalars['Int']>;
  forecastStreamAreaMapping?: Maybe<Scalars['JSONString']>;
  homeInfo?: Maybe<HomeInformationOutput>;
};

export type AreaOutput = {
  __typename?: 'AreaOutput';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  children?: Maybe<Array<Maybe<DeviceTypes>>>;
  gridFeePercentage?: Maybe<Scalars['Float']>;
  gridFeeConstant?: Maybe<Scalars['Float']>;
  importCapacityKva?: Maybe<Scalars['Float']>;
  exportCapacityKva?: Maybe<Scalars['Float']>;
  targetMarketKpi?: Maybe<Scalars['Int']>;
  baselinePeakEnergyImportKwh?: Maybe<Scalars['Float']>;
  baselinePeakEnergyExportKwh?: Maybe<Scalars['Float']>;
  fitAreaBoundary?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DeviceTypes = Pv | Storage | Load | SmartMeter | FiniteDieselGenerator | MarketMaker | InfiniteBus | AreaOutput;

export type Pv = {
  __typename?: 'PV';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  panelCount?: Maybe<Scalars['Int']>;
  initialSellingRate?: Maybe<Scalars['Float']>;
  finalSellingRate?: Maybe<Scalars['Float']>;
  fitToLimit?: Maybe<Scalars['Boolean']>;
  updateInterval?: Maybe<Scalars['Int']>;
  energyRateDecreasePerUpdate?: Maybe<Scalars['Float']>;
  maxPanelPowerW?: Maybe<Scalars['Float']>;
  capacityKw?: Maybe<Scalars['Float']>;
  cloudCoverage?: Maybe<Scalars['Int']>;
  powerProfile?: Maybe<Scalars['String']>;
  powerProfileUuid?: Maybe<Scalars['String']>;
  useMarketMakerRate?: Maybe<Scalars['Boolean']>;
  targetDeviceKpi?: Maybe<Scalars['Int']>;
  forecastStreamEnabled?: Maybe<Scalars['Boolean']>;
  azimuth?: Maybe<Scalars['Float']>;
  tilt?: Maybe<Scalars['Float']>;
};

export type Storage = {
  __typename?: 'Storage';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  initialSoc?: Maybe<Scalars['Float']>;
  minAllowedSoc?: Maybe<Scalars['Float']>;
  batteryCapacityKwh?: Maybe<Scalars['Float']>;
  maxAbsBatteryPowerKw?: Maybe<Scalars['Float']>;
  capPriceStrategy?: Maybe<Scalars['Boolean']>;
  initialSellingRate?: Maybe<Scalars['Float']>;
  finalSellingRate?: Maybe<Scalars['Float']>;
  initialBuyingRate?: Maybe<Scalars['Float']>;
  finalBuyingRate?: Maybe<Scalars['Float']>;
  fitToLimit?: Maybe<Scalars['Boolean']>;
  energyRateIncreasePerUpdate?: Maybe<Scalars['Float']>;
  energyRateDecreasePerUpdate?: Maybe<Scalars['Float']>;
  updateInterval?: Maybe<Scalars['Int']>;
  targetDeviceKpi?: Maybe<Scalars['Int']>;
};

export type Load = {
  __typename?: 'Load';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  avgPowerW?: Maybe<Scalars['Float']>;
  hrsPerDay?: Maybe<Scalars['Int']>;
  hrsOfDay?: Maybe<Array<Maybe<Scalars['Int']>>>;
  initialBuyingRate?: Maybe<Scalars['Int']>;
  finalBuyingRate?: Maybe<Scalars['Int']>;
  fitToLimit?: Maybe<Scalars['Boolean']>;
  updateInterval?: Maybe<Scalars['Int']>;
  energyRateIncreasePerUpdate?: Maybe<Scalars['Float']>;
  dailyLoadProfile?: Maybe<Scalars['String']>;
  dailyLoadProfileUuid?: Maybe<Scalars['String']>;
  useMarketMakerRate?: Maybe<Scalars['Boolean']>;
  targetDeviceKpi?: Maybe<Scalars['Int']>;
  forecastStreamEnabled?: Maybe<Scalars['Boolean']>;
};

/** Class representing the GraphQL output for a Smart Meter device. */
export type SmartMeter = {
  __typename?: 'SmartMeter';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  smartMeterProfile?: Maybe<Scalars['String']>;
  smartMeterProfileUuid?: Maybe<Scalars['String']>;
  initialSellingRate?: Maybe<Scalars['Float']>;
  finalSellingRate?: Maybe<Scalars['Float']>;
  energyRateDecreasePerUpdate?: Maybe<Scalars['Float']>;
  initialBuyingRate?: Maybe<Scalars['Float']>;
  finalBuyingRate?: Maybe<Scalars['Float']>;
  energyRateIncreasePerUpdate?: Maybe<Scalars['Float']>;
  fitToLimit?: Maybe<Scalars['Boolean']>;
  updateInterval?: Maybe<Scalars['Int']>;
  useMarketMakerRate?: Maybe<Scalars['Boolean']>;
  targetDeviceKpi?: Maybe<Scalars['Int']>;
};

export type FiniteDieselGenerator = {
  __typename?: 'FiniteDieselGenerator';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  energyRate?: Maybe<Scalars['Float']>;
  maxAvailablePowerKw?: Maybe<Scalars['Float']>;
};

export type MarketMaker = {
  __typename?: 'MarketMaker';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  energyRate?: Maybe<Scalars['Float']>;
  energyRateProfile?: Maybe<Scalars['String']>;
  energyRateProfileUuid?: Maybe<Scalars['String']>;
  gridConnected?: Maybe<Scalars['Boolean']>;
};

export type InfiniteBus = {
  __typename?: 'InfiniteBus';
  name: Scalars['String'];
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  serialized: Scalars['String'];
  uuid: Scalars['String'];
  libraryUUID?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  energyRate?: Maybe<Scalars['Float']>;
  energyRateProfile?: Maybe<Scalars['String']>;
  energyRateProfileUuid?: Maybe<Scalars['String']>;
  energyBuyRate?: Maybe<Scalars['Float']>;
  buyingRateProfile?: Maybe<Scalars['String']>;
  buyingRateProfileUuid?: Maybe<Scalars['String']>;
};

export type HomeInformationOutput = {
  __typename?: 'HomeInformationOutput';
  homeUuids?: Maybe<Array<Maybe<Scalars['String']>>>;
  energyBills?: Maybe<Array<Maybe<HomeBillOutput>>>;
};

export type HomeBillOutput = {
  __typename?: 'HomeBillOutput';
  uuid: Scalars['String'];
  bill: Scalars['JSONString'];
};

export type SettingsOutput = {
  __typename?: 'SettingsOutput';
  durationDays?: Maybe<Scalars['Float']>;
  slotLengthMinutes?: Maybe<Scalars['Int']>;
  tickLengthSeconds?: Maybe<Scalars['Int']>;
  marketCount?: Maybe<Scalars['Int']>;
  slotLengthRealtimeSeconds?: Maybe<Scalars['Int']>;
  cloudCoverage?: Maybe<Scalars['Int']>;
  pvUserProfile?: Maybe<Scalars['Upload']>;
  maxPanelPowerW?: Maybe<Scalars['Float']>;
  capacityKw?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  spotMarketType?: Maybe<SpotMarketType>;
  bidOfferMatchAlgo?: Maybe<BidOfferMatchAlgo>;
  advancedSettings?: Maybe<Scalars['String']>;
  randomSeed?: Maybe<Scalars['Int']>;
  gridFeeType?: Maybe<GridFeeType>;
  externalConnectionEnabled?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Currencies>;
  settlementMarketEnabled?: Maybe<Scalars['Boolean']>;
  relativeStdFromForecastPercent?: Maybe<Scalars['Float']>;
};



export enum SpotMarketType {
  OneSided = 'ONE_SIDED',
  TwoSided = 'TWO_SIDED'
}

export enum BidOfferMatchAlgo {
  PayAsBid = 'PAY_AS_BID',
  PayAsClear = 'PAY_AS_CLEAR',
  External = 'EXTERNAL'
}

export enum GridFeeType {
  Constant = 'CONSTANT',
  Percentage = 'PERCENTAGE'
}

export enum Currencies {
  Eur = 'EUR',
  Usd = 'USD',
  Jpy = 'JPY',
  Gbp = 'GBP',
  Aud = 'AUD',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Cop = 'COP'
}

export type AvailableAreaTypesOutput = {
  __typename?: 'AvailableAreaTypesOutput';
  leafTypes?: Maybe<Array<Maybe<AreaDescription>>>;
  nodeTypes?: Maybe<Array<Maybe<AreaDescription>>>;
};

export type AreaDescription = {
  __typename?: 'AreaDescription';
  name: Scalars['String'];
  type: Scalars['String'];
  parameters?: Maybe<Array<Maybe<AreaParametersType>>>;
};

export type AreaParametersType = {
  __typename?: 'AreaParametersType';
  name?: Maybe<Scalars['String']>;
  verbose?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  minValue?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['String']>;
};

export type ConfigurationEvents = {
  __typename?: 'ConfigurationEvents';
  configurationUuid?: Maybe<Scalars['String']>;
  areaEvents?: Maybe<Array<Maybe<AreaEvents>>>;
  settingsEvents?: Maybe<Array<Maybe<SettingsEventOutput>>>;
};

export type AreaEvents = {
  __typename?: 'AreaEvents';
  areaUuid?: Maybe<Scalars['String']>;
  triggerEvents?: Maybe<Array<Maybe<AreaTriggerEvent>>>;
};

export type AreaTriggerEvent = {
  __typename?: 'AreaTriggerEvent';
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<EventType>;
};

export enum EventType {
  Disconnect = 'DISCONNECT',
  Connect = 'CONNECT',
  Disable = 'DISABLE',
  Enable = 'ENABLE'
}

export type SettingsEventOutput = {
  __typename?: 'SettingsEventOutput';
  time?: Maybe<Scalars['DateTime']>;
  cloudCoverage?: Maybe<Scalars['Int']>;
  pvUserProfile?: Maybe<Scalars['Upload']>;
  marketMakerRate?: Maybe<Scalars['Int']>;
  marketMakerRateFile?: Maybe<Scalars['Upload']>;
  spotMarketType?: Maybe<SpotMarketType>;
  bidOfferMatchAlgo?: Maybe<BidOfferMatchAlgo>;
  gridFeeType?: Maybe<GridFeeType>;
};

export type Project = {
  __typename?: 'Project';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
};

export type ConfigurationDetails = {
  __typename?: 'ConfigurationDetails';
  configuredDevices?: Maybe<Scalars['Int']>;
  configuredAreas?: Maybe<Scalars['Int']>;
  maxLimit?: Maybe<Scalars['Int']>;
};

export type ProgressInfo = {
  __typename?: 'ProgressInfo';
  etaSeconds?: Maybe<Scalars['Int']>;
  elapsedTimeSeconds?: Maybe<Scalars['Int']>;
  percentageCompleted?: Maybe<Scalars['Int']>;
};

export type LocationTotalCount = {
  __typename?: 'LocationTotalCount';
  totalMarkets?: Maybe<Scalars['Int']>;
  totalDevices?: Maybe<Scalars['Int']>;
};

export type LocationBoundaryOutput = {
  __typename?: 'LocationBoundaryOutput';
  totalMarkets?: Maybe<Scalars['Int']>;
  totalDevices?: Maybe<Scalars['Int']>;
  boundaryId?: Maybe<Scalars['String']>;
  simulationsInProgress?: Maybe<Scalars['Int']>;
};

export type SimulationLocationOutput = {
  __typename?: 'SimulationLocationOutput';
  boundaryId?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  visibility?: Maybe<Scalars['Boolean']>;
};

export type SimulationLocationVisibilityOutput = {
  __typename?: 'SimulationLocationVisibilityOutput';
  totalMarkets?: Maybe<Scalars['Int']>;
  totalDevices?: Maybe<Scalars['Int']>;
  boundaryId?: Maybe<Scalars['String']>;
  simulationsInProgress?: Maybe<Scalars['Int']>;
  configUuid?: Maybe<Scalars['String']>;
  projectUuid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['Boolean']>;
  type?: Maybe<ConfigType>;
};

export type LiveEventListOutput = {
  __typename?: 'LiveEventListOutput';
  eventType?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['JSONString']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  diff?: Maybe<Scalars['JSONString']>;
};

export type LiveEventRepresentation = {
  __typename?: 'LiveEventRepresentation';
  timeStamp?: Maybe<Scalars['DateTime']>;
  representation?: Maybe<AreaOutput>;
};

export type ExternalConnectionConfigurationsOutput = {
  __typename?: 'ExternalConnectionConfigurationsOutput';
  configuration?: Maybe<Array<Maybe<ExternalConnectionAreaOutput>>>;
};

export type ExternalConnectionAreaOutput = {
  __typename?: 'ExternalConnectionAreaOutput';
  configUuid?: Maybe<Scalars['String']>;
  openForExternalApplications?: Maybe<Scalars['Boolean']>;
  availableAreaUuids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ExternalConnectionApplicantOutput = {
  __typename?: 'ExternalConnectionApplicantOutput';
  username?: Maybe<Scalars['String']>;
  configUuid?: Maybe<Scalars['String']>;
  areaUuid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AvailableUserRolesOutput = {
  __typename?: 'AvailableUserRolesOutput';
  userRoles?: Maybe<Array<Maybe<UserRoleOutput>>>;
};

export type UserRoleOutput = {
  __typename?: 'UserRoleOutput';
  roleName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type AdminStats = {
  __typename?: 'AdminStats';
  userDetails?: Maybe<Array<Maybe<UserDetailOutput>>>;
  userActivity?: Maybe<ActivityDetailOutput>;
};

export type UserDetailOutput = {
  __typename?: 'UserDetailOutput';
  id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
  joinedDate?: Maybe<Scalars['DateTime']>;
  numberOfProjects?: Maybe<Scalars['Int']>;
  numberOfLogins?: Maybe<Scalars['Int']>;
  chosenRole?: Maybe<Scalars['String']>;
  numberOfSimulations?: Maybe<Scalars['Int']>;
  activeTimeInSeconds?: Maybe<Scalars['Float']>;
  numberOfConfiguredAgents?: Maybe<Scalars['Int']>;
  numberOfLibraries?: Maybe<Scalars['Int']>;
};

export type ActivityDetailOutput = {
  __typename?: 'ActivityDetailOutput';
  newRegistration?: Maybe<Array<Maybe<RegistrationOutput>>>;
  loginDetail?: Maybe<Array<Maybe<ActivityOutput>>>;
};

export type RegistrationOutput = {
  __typename?: 'RegistrationOutput';
  timestamp?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type ActivityOutput = {
  __typename?: 'ActivityOutput';
  timestamp?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
  durationMs?: Maybe<Scalars['Float']>;
};

export type ProjectOutput = {
  __typename?: 'ProjectOutput';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  private?: Maybe<Scalars['Boolean']>;
  locationVisible?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  configurations?: Maybe<Array<Maybe<ConfigurationOutput>>>;
};

export type LibraryOutput = {
  __typename?: 'LibraryOutput';
  name?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  scenarioData?: Maybe<ScenarioLibraryOutput>;
  user?: Maybe<Scalars['String']>;
  readOnly?: Maybe<Scalars['Boolean']>;
  private?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ScenarioLibraryOutput = {
  __typename?: 'ScenarioLibraryOutput';
  representation?: Maybe<DeviceTypes>;
  deviceCount?: Maybe<Scalars['JSONString']>;
  deviceCountNumber?: Maybe<Scalars['Int']>;
  areaCountNumber?: Maybe<Scalars['Int']>;
};

export type ListLibraryOutput = {
  __typename?: 'ListLibraryOutput';
  totalCount?: Maybe<Scalars['Int']>;
  libraries?: Maybe<Array<Maybe<LibraryOutput>>>;
};

export type SimulationResultsData = {
  __typename?: 'SimulationResultsData';
  simulationId: Scalars['String'];
  areaUuid?: Maybe<Scalars['String']>;
  currentMarket?: Maybe<Scalars['String']>;
  completedMarkets?: Maybe<Scalars['JSONString']>;
  status?: Maybe<Scalars['String']>;
  statusesEnum?: Maybe<SimulationStatusType>;
  progressInfo?: Maybe<ProgressInfo>;
  randomSeed?: Maybe<Scalars['String']>;
  unmatchedLoads?: Maybe<Scalars['JSONString']>;
  priceEnergyDay?: Maybe<Scalars['JSONString']>;
  cumulativeGridTrades?: Maybe<Scalars['JSONString']>;
  cumulativeNetEnergyFlow?: Maybe<Scalars['JSONString']>;
  assetsInfo?: Maybe<Scalars['JSONString']>;
  priceEnergyAreaBalance?: Maybe<Scalars['JSONString']>;
  cumulativeBills?: Maybe<Scalars['JSONString']>;
  deviceStatistics?: Maybe<Scalars['JSONString']>;
  energyTradeProfile?: Maybe<Scalars['JSONString']>;
  kpi?: Maybe<Scalars['JSONString']>;
  latestSavingsKpi?: Maybe<Scalars['JSONString']>;
  savingsKpiProfile?: Maybe<Scalars['JSONString']>;
  areaThroughput?: Maybe<Scalars['JSONString']>;
  marketSummary?: Maybe<Array<Maybe<MarketSummary>>>;
  energyTradesHighResolution?: Maybe<Scalars['JSONString']>;
  bidsOffersTrades?: Maybe<Scalars['JSONString']>;
  energyTradeProfileAreaThroughput?: Maybe<Scalars['JSONString']>;
  aggregatedBills?: Maybe<Scalars['JSONString']>;
};


export type SimulationResultsDataLatestSavingsKpiArgs = {
  duration?: Maybe<DataAggregationDuration>;
};


export type SimulationResultsDataSavingsKpiProfileArgs = {
  duration?: Maybe<DataAggregationDuration>;
};

export enum SimulationStatusType {
  Queued = 'QUEUED',
  Initializing = 'INITIALIZING',
  Running = 'RUNNING',
  Paused = 'PAUSED',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Finished = 'FINISHED',
  Failed = 'FAILED'
}

export enum DataAggregationDuration {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY'
}

export type MarketSummary = {
  __typename?: 'MarketSummary';
  tradedVolume: Scalars['Float'];
  externalTradedVolume: Scalars['Float'];
  averageEnergyRate?: Maybe<Scalars['Float']>;
  timestamp: Scalars['DateTime'];
};

export type UserOutput = {
  __typename?: 'UserOutput';
  username?: Maybe<Scalars['String']>;
  superuser?: Maybe<Scalars['Boolean']>;
  globalVisibility?: Maybe<Scalars['Boolean']>;
};

export type Mutations = {
  __typename?: 'Mutations';
  userContactForm?: Maybe<Scalars['String']>;
  moveCollaborationToCanaryNetwork?: Maybe<ConfigurationOutput>;
  duplicateCanaryNetwork?: Maybe<ConfigurationOutput>;
  setGlobalSimulationLocation?: Maybe<Scalars['String']>;
  toggleGlobalSimulationVisibility?: Maybe<SimulationLocationVisibilityOutput>;
  updateUserSimulationVisibility?: Maybe<UserSimulationLocationVisibility>;
  deleteGlobalSimulationLocation?: Maybe<Scalars['String']>;
  deleteAreaLiveEvent?: Maybe<LiveEventResponse>;
  updateAreaLiveEvent?: Maybe<LiveEventResponse>;
  createAreaLiveEvent?: Maybe<LiveEventResponse>;
  bulkAreaLiveEvent?: Maybe<BulkLiveEventOutput>;
  moveConfigurationToCollaboration?: Maybe<ConfigurationOutput>;
  duplicateCollaboration?: Maybe<ConfigurationOutput>;
  registerExternalConnection?: Maybe<RegistrationResponse>;
  batchRegisterExternalConnection?: Maybe<RegistrationResponse>;
  registerGridConnection?: Maybe<RegistrationResponse>;
  gridConfiguration?: Maybe<ConfigurationOutput>;
  exchangeOperatorConfiguration?: Maybe<ConfigurationOutput>;
  registerCollaboration?: Maybe<Scalars['String']>;
  respondExternalConnectionRequest?: Maybe<Scalars['String']>;
  batchResponseExternalConnectionRequest?: Maybe<Array<Maybe<Scalars['String']>>>;
  setUserRole?: Maybe<UserRoleOutput>;
  createProject?: Maybe<ProjectOutput>;
  updateProject?: Maybe<ProjectOutput>;
  deleteProject?: Maybe<Scalars['String']>;
  createLibrary?: Maybe<LibraryOutput>;
  updateLibrary?: Maybe<LibraryOutput>;
  deleteLibrary?: Maybe<Scalars['String']>;
  duplicateLibrary?: Maybe<LibraryOutput>;
  createConfiguration?: Maybe<ConfigurationOutput>;
  updateConfiguration?: Maybe<ConfigurationOutput>;
  updateConfigurationArea?: Maybe<ConfigurationOutput>;
  removeConfigurationArea?: Maybe<ConfigurationOutput>;
  createConfigurationArea?: Maybe<ConfigurationOutput>;
  deleteConfiguration?: Maybe<Scalars['String']>;
  partialUpdateConfiguration?: Maybe<ConfigurationOutput>;
  duplicateConfiguration?: Maybe<ConfigurationOutput>;
  createUpdateEvents?: Maybe<ConfigurationEvents>;
  deleteEvents?: Maybe<Scalars['String']>;
  pauseSimulation?: Maybe<Scalars['String']>;
  resumeSimulation?: Maybe<Scalars['String']>;
  stopSimulation?: Maybe<Scalars['String']>;
  launchSimulation?: Maybe<LaunchResponse>;
  launchSimulationFromState?: Maybe<LaunchResponse>;
  tokenAuth?: Maybe<AuthToken>;
  tokenVerify?: Maybe<Verify>;
  tokenRefresh?: Maybe<Refresh>;
  registerUser?: Maybe<SignupResponse>;
  confirmEmail?: Maybe<Scalars['String']>;
  confirmPasswordReset?: Maybe<Scalars['String']>;
  updateUser?: Maybe<UserInformationOutput>;
};


export type MutationsUserContactFormArgs = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};


export type MutationsMoveCollaborationToCanaryNetworkArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  private?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};


export type MutationsDuplicateCanaryNetworkArgs = {
  description?: Maybe<Scalars['String']>;
  incorporateLiveEvents?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationsSetGlobalSimulationLocationArgs = {
  boundaryId: Scalars['String'];
  centreCoordinates?: Maybe<Position>;
  configUuid: Scalars['String'];
  visibility: Scalars['Boolean'];
};


export type MutationsToggleGlobalSimulationVisibilityArgs = {
  configUuid: Scalars['String'];
};


export type MutationsUpdateUserSimulationVisibilityArgs = {
  visibility: Scalars['Boolean'];
};


export type MutationsDeleteGlobalSimulationLocationArgs = {
  configUuid: Scalars['String'];
};


export type MutationsDeleteAreaLiveEventArgs = {
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
};


export type MutationsUpdateAreaLiveEventArgs = {
  areaParams: AreaInput;
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
};


export type MutationsCreateAreaLiveEventArgs = {
  areaRepresentation?: Maybe<AreaInput>;
  configUuid: Scalars['String'];
  libraryUuid?: Maybe<Scalars['String']>;
  parentUuid: Scalars['String'];
};


export type MutationsBulkAreaLiveEventArgs = {
  configUuid: Scalars['String'];
  eventList?: Maybe<Array<Maybe<LiveEventInput>>>;
};


export type MutationsMoveConfigurationToCollaborationArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationsDuplicateCollaborationArgs = {
  description?: Maybe<Scalars['String']>;
  incorporateLiveEvents?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationsRegisterExternalConnectionArgs = {
  apply: Scalars['Boolean'];
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
};


export type MutationsBatchRegisterExternalConnectionArgs = {
  applicationMapping?: Maybe<Array<Maybe<AreaUuidApplyMapping>>>;
  configUuid: Scalars['String'];
};


export type MutationsRegisterGridConnectionArgs = {
  apply: Scalars['Boolean'];
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
};


export type MutationsGridConfigurationArgs = {
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
  configurationSettings?: Maybe<GridSettings>;
};


export type MutationsExchangeOperatorConfigurationArgs = {
  configUuid: Scalars['String'];
  setExternalConnection?: Maybe<Array<Maybe<ConnectionDetails>>>;
};


export type MutationsRegisterCollaborationArgs = {
  configUuid: Scalars['String'];
  openForExternalApplications: Scalars['Boolean'];
};


export type MutationsRespondExternalConnectionRequestArgs = {
  accept: Scalars['Boolean'];
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
  username: Scalars['String'];
};


export type MutationsBatchResponseExternalConnectionRequestArgs = {
  configUuid: Scalars['String'];
  responseList?: Maybe<Array<Maybe<InputRespondExternalConnectionRequest>>>;
};


export type MutationsSetUserRoleArgs = {
  email?: Maybe<Scalars['String']>;
  userRoleInt?: Maybe<Scalars['Int']>;
};


export type MutationsCreateProjectArgs = {
  centreCoordinates?: Maybe<Position>;
  description?: Maybe<Scalars['String']>;
  locationVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  private?: Maybe<Scalars['Boolean']>;
};


export type MutationsUpdateProjectArgs = {
  centreCoordinates?: Maybe<Position>;
  description?: Maybe<Scalars['String']>;
  locationVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};


export type MutationsDeleteProjectArgs = {
  uuid: Scalars['String'];
};


export type MutationsCreateLibraryArgs = {
  configUUID?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  scenarioData?: Maybe<ScenarioInput>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationsUpdateLibraryArgs = {
  description?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  scenarioData?: Maybe<ScenarioInput>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid: Scalars['String'];
};


export type MutationsDeleteLibraryArgs = {
  uuid: Scalars['String'];
};


export type MutationsDuplicateLibraryArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};


export type MutationsCreateConfigurationArgs = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projectUUID: Scalars['String'];
  scenarioData?: Maybe<ScenarioInput>;
  settingsData?: Maybe<SettingsInput>;
};


export type MutationsUpdateConfigurationArgs = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projectUUID?: Maybe<Scalars['String']>;
  scenarioData?: Maybe<ScenarioInput>;
  settingsData?: Maybe<SettingsInput>;
  uuid: Scalars['String'];
};


export type MutationsUpdateConfigurationAreaArgs = {
  areaParams: AreaInput;
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
};


export type MutationsRemoveConfigurationAreaArgs = {
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
};


export type MutationsCreateConfigurationAreaArgs = {
  areaRepresentation: AreaInput;
  configUuid: Scalars['String'];
  parentUuid: Scalars['String'];
};


export type MutationsDeleteConfigurationArgs = {
  uuid: Scalars['String'];
};


export type MutationsPartialUpdateConfigurationArgs = {
  partialScenario: AreaInput;
  uuid: Scalars['String'];
};


export type MutationsDuplicateConfigurationArgs = {
  description?: Maybe<Scalars['String']>;
  incorporateLiveEvents?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationsCreateUpdateEventsArgs = {
  areaEvents?: Maybe<Array<Maybe<AreaEventsInput>>>;
  settingsEvents?: Maybe<Array<Maybe<SettingsEventInput>>>;
  uuid?: Maybe<Scalars['String']>;
};


export type MutationsDeleteEventsArgs = {
  uuid?: Maybe<Scalars['String']>;
};


export type MutationsPauseSimulationArgs = {
  jobId: Scalars['String'];
};


export type MutationsResumeSimulationArgs = {
  jobId: Scalars['String'];
};


export type MutationsStopSimulationArgs = {
  jobId: Scalars['String'];
};


export type MutationsLaunchSimulationArgs = {
  uuid?: Maybe<Scalars['String']>;
};


export type MutationsLaunchSimulationFromStateArgs = {
  uuid?: Maybe<Scalars['String']>;
};


export type MutationsTokenAuthArgs = {
  username: Scalars['String'];
  password: Scalars['String'];
};


export type MutationsTokenVerifyArgs = {
  token: Scalars['String'];
};


export type MutationsTokenRefreshArgs = {
  token: Scalars['String'];
};


export type MutationsRegisterUserArgs = {
  email: Scalars['String'];
  interest?: Maybe<Scalars['String']>;
  interestedInCn?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organisation: Scalars['String'];
  password: Scalars['String'];
  passwordRepeat?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['Upload']>;
  username?: Maybe<Scalars['String']>;
};


export type MutationsConfirmEmailArgs = {
  confirmKey?: Maybe<Scalars['String']>;
};


export type MutationsConfirmPasswordResetArgs = {
  key: Scalars['String'];
  password: Scalars['String'];
  passwordRepeat: Scalars['String'];
  uid: Scalars['String'];
};


export type MutationsUpdateUserArgs = {
  interest?: Maybe<Scalars['String']>;
  interestedInCn?: Maybe<Scalars['Boolean']>;
  organisation?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['Upload']>;
};

export type Position = {
  longitude?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
};

export type UserSimulationLocationVisibility = {
  __typename?: 'UserSimulationLocationVisibility';
  username?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['Boolean']>;
};

export type LiveEventResponse = {
  __typename?: 'LiveEventResponse';
  eventType?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['JSONString']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  diff?: Maybe<Scalars['JSONString']>;
  latestConfig?: Maybe<ConfigurationOutput>;
};

export type AreaInput = {
  name?: Maybe<Scalars['String']>;
  gridFeePercentage?: Maybe<Scalars['Float']>;
  gridFeeConstant?: Maybe<Scalars['Float']>;
  importCapacityKva?: Maybe<Scalars['Float']>;
  exportCapacityKva?: Maybe<Scalars['Float']>;
  allowExternalConnection?: Maybe<Scalars['Boolean']>;
  forecastStreamEnabled?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
  libraryUUID?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<AreaInput>>>;
  type?: Maybe<Scalars['String']>;
  profileUUID?: Maybe<Scalars['String']>;
  targetDeviceKpi?: Maybe<Scalars['Int']>;
  targetMarketKpi?: Maybe<Scalars['Int']>;
  baselinePeakEnergyImportKwh?: Maybe<Scalars['Float']>;
  baselinePeakEnergyExportKwh?: Maybe<Scalars['Float']>;
  geoTagLocation?: Maybe<Array<Maybe<Scalars['Float']>>>;
  fitAreaBoundary?: Maybe<Scalars['Boolean']>;
  fitToLimit?: Maybe<Scalars['Boolean']>;
  energyRateDecreasePerUpdate?: Maybe<Scalars['Float']>;
  energyRateIncreasePerUpdate?: Maybe<Scalars['Float']>;
  updateInterval?: Maybe<Scalars['Int']>;
  initialBuyingRate?: Maybe<Scalars['Float']>;
  finalBuyingRate?: Maybe<Scalars['Float']>;
  initialSellingRate?: Maybe<Scalars['Float']>;
  finalSellingRate?: Maybe<Scalars['Float']>;
  cloudCoverage?: Maybe<Scalars['Int']>;
  energyRate?: Maybe<Scalars['Float']>;
  maxAvailablePowerKw?: Maybe<Scalars['Float']>;
  avgPowerW?: Maybe<Scalars['Int']>;
  hrsPerDay?: Maybe<Scalars['Int']>;
  hrsOfDay?: Maybe<Array<Maybe<Scalars['Int']>>>;
  dailyLoadProfile?: Maybe<Scalars['Upload']>;
  panelCount?: Maybe<Scalars['Int']>;
  powerProfile?: Maybe<Scalars['Upload']>;
  maxPanelPowerW?: Maybe<Scalars['Float']>;
  capacityKw?: Maybe<Scalars['Float']>;
  azimuth?: Maybe<Scalars['Float']>;
  tilt?: Maybe<Scalars['Float']>;
  initialSoc?: Maybe<Scalars['Float']>;
  minAllowedSoc?: Maybe<Scalars['Float']>;
  batteryCapacityKwh?: Maybe<Scalars['Float']>;
  maxAbsBatteryPowerKw?: Maybe<Scalars['Float']>;
  capPriceStrategy?: Maybe<Scalars['Boolean']>;
  smartMeterProfile?: Maybe<Scalars['Upload']>;
  energyRateProfile?: Maybe<Scalars['Upload']>;
  gridConnected?: Maybe<Scalars['Boolean']>;
  useMarketMakerRate?: Maybe<Scalars['Boolean']>;
  energyBuyRate?: Maybe<Scalars['Float']>;
  buyingRateProfile?: Maybe<Scalars['Upload']>;
};

export type BulkLiveEventOutput = {
  __typename?: 'BulkLiveEventOutput';
  latestConfig?: Maybe<ConfigurationOutput>;
  eventList?: Maybe<Array<Maybe<LiveEventListOutput>>>;
};

export type LiveEventInput = {
  eventType?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  parameters?: Maybe<AreaInput>;
};

export type RegistrationResponse = {
  __typename?: 'RegistrationResponse';
  response?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type AreaUuidApplyMapping = {
  areaUuid?: Maybe<Scalars['String']>;
  apply?: Maybe<Scalars['Boolean']>;
};

export type GridSettings = {
  gridFeePercentage?: Maybe<Scalars['Float']>;
  gridFeeConstant?: Maybe<Scalars['Float']>;
  importCapacityKva?: Maybe<Scalars['Float']>;
  exportCapacityKva?: Maybe<Scalars['Float']>;
};

export type ConnectionDetails = {
  areaUuid: Scalars['String'];
  allowExternalConnection: Scalars['Boolean'];
};

export type InputRespondExternalConnectionRequest = {
  username?: Maybe<Scalars['String']>;
  areaUuid?: Maybe<Scalars['String']>;
  accept?: Maybe<Scalars['Boolean']>;
};

export type ScenarioInput = {
  representation?: Maybe<AreaInput>;
};

export type SettingsInput = {
  durationDays?: Maybe<Scalars['Float']>;
  slotLengthMinutes?: Maybe<Scalars['Int']>;
  tickLengthSeconds?: Maybe<Scalars['Int']>;
  marketCount?: Maybe<Scalars['Int']>;
  slotLengthRealtimeSeconds?: Maybe<Scalars['Int']>;
  cloudCoverage?: Maybe<Scalars['Int']>;
  pvUserProfile?: Maybe<Scalars['Upload']>;
  maxPanelPowerW?: Maybe<Scalars['Float']>;
  capacityKw?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  spotMarketType?: Maybe<SpotMarketType>;
  bidOfferMatchAlgo?: Maybe<BidOfferMatchAlgo>;
  advancedSettings?: Maybe<Scalars['String']>;
  randomSeed?: Maybe<Scalars['Int']>;
  gridFeeType?: Maybe<GridFeeType>;
  externalConnectionEnabled?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Currencies>;
  settlementMarketEnabled?: Maybe<Scalars['Boolean']>;
  relativeStdFromForecastPercent?: Maybe<Scalars['Float']>;
};

export type AreaEventsInput = {
  areaUuid?: Maybe<Scalars['String']>;
  triggerEvents?: Maybe<Array<Maybe<AreaTriggerEventInput>>>;
};

export type AreaTriggerEventInput = {
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<EventType>;
};

export type SettingsEventInput = {
  time?: Maybe<Scalars['DateTime']>;
  cloudCoverage?: Maybe<Scalars['Int']>;
  pvUserProfile?: Maybe<Scalars['Upload']>;
  marketMakerRate?: Maybe<Scalars['Int']>;
  marketMakerRateFile?: Maybe<Scalars['Upload']>;
  spotMarketType?: Maybe<SpotMarketType>;
  bidOfferMatchAlgo?: Maybe<BidOfferMatchAlgo>;
  gridFeeType?: Maybe<GridFeeType>;
};

export type LaunchResponse = {
  __typename?: 'LaunchResponse';
  job?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  configUUID?: Maybe<Scalars['String']>;
};

export type AuthToken = {
  __typename?: 'AuthToken';
  username?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  userRole?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
};

export type Verify = {
  __typename?: 'Verify';
  payload?: Maybe<Scalars['GenericScalar']>;
};


export type Refresh = {
  __typename?: 'Refresh';
  token?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['GenericScalar']>;
};

export type SignupResponse = {
  __typename?: 'SignupResponse';
  response?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  authToken?: Maybe<AuthToken>;
};

export type UserInformationOutput = {
  __typename?: 'UserInformationOutput';
  organisation?: Maybe<Scalars['String']>;
  interest?: Maybe<Scalars['String']>;
  interestedInCn?: Maybe<Scalars['Boolean']>;
};

export type AuthTokenFieldsFragment = (
  { __typename?: 'AuthToken' }
  & Pick<AuthToken, 'email' | 'isAdmin' | 'userRole' | 'token' | 'username'>
  & { isSuperuser: AuthToken['isAdmin'] }
);

export type ConfigurationFieldsFragment = (
  { __typename?: 'ConfigurationOutput' }
  & Pick<ConfigurationOutput, 'uuid' | 'name' | 'description' | 'readOnly' | 'simulationResults' | 'resultsStatus' | 'timestamp' | 'warnings' | 'user' | 'openForExternalApplications' | 'private'>
  & { configType: ConfigurationOutput['type'] }
  & { areaSummary?: Maybe<(
    { __typename?: 'ConfigurationDetails' }
    & Pick<ConfigurationDetails, 'configuredAreas' | 'configuredDevices'>
  )>, scenarioData?: Maybe<(
    { __typename?: 'ScenarioOutput' }
    & { latest?: Maybe<(
      { __typename?: 'AreaOutput' }
      & Pick<AreaOutput, 'serialized' | 'uuid'>
    )> }
  )>, settingsData?: Maybe<(
    { __typename?: 'SettingsOutput' }
    & SettingsDataFieldsFragment
  )>, project?: Maybe<(
    { __typename?: 'Project' }
    & Pick<Project, 'uuid' | 'name' | 'user'>
  )> }
);

export type SettingsDataFieldsFragment = (
  { __typename?: 'SettingsOutput' }
  & Pick<SettingsOutput, 'slotLengthMinutes' | 'tickLengthSeconds' | 'marketCount' | 'slotLengthRealtimeSeconds' | 'cloudCoverage' | 'pvUserProfile' | 'startDate' | 'endDate' | 'spotMarketType' | 'bidOfferMatchAlgo' | 'gridFeeType' | 'currency'>
);

export type ConfirmEmailMutationVariables = Exact<{
  confirmKey: Scalars['String'];
}>;


export type ConfirmEmailMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'confirmEmail'>
);

export type ConfirmPasswordResetMutationVariables = Exact<{
  uid: Scalars['String'];
  key: Scalars['String'];
  password: Scalars['String'];
  passwordRepeat: Scalars['String'];
}>;


export type ConfirmPasswordResetMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'confirmPasswordReset'>
);

export type SetUserRoleMutationVariables = Exact<{
  email: Scalars['String'];
  role: Scalars['Int'];
}>;


export type SetUserRoleMutation = (
  { __typename?: 'Mutations' }
  & { setUserRole?: Maybe<(
    { __typename?: 'UserRoleOutput' }
    & Pick<UserRoleOutput, 'roleName' | 'value'>
  )> }
);

export type SignupMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  organisation: Scalars['String'];
  password: Scalars['String'];
  passwordRepeat?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  interest?: Maybe<Scalars['String']>;
}>;


export type SignupMutation = (
  { __typename?: 'Mutations' }
  & { registerUser?: Maybe<(
    { __typename?: 'SignupResponse' }
    & Pick<SignupResponse, 'response' | 'message'>
    & { authToken?: Maybe<(
      { __typename?: 'AuthToken' }
      & AuthTokenFieldsFragment
    )> }
  )> }
);

export type TokenAuthMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type TokenAuthMutation = (
  { __typename?: 'Mutations' }
  & { tokenAuth?: Maybe<(
    { __typename?: 'AuthToken' }
    & AuthTokenFieldsFragment
  )> }
);

export type TokenRefreshMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type TokenRefreshMutation = (
  { __typename?: 'Mutations' }
  & { tokenRefresh?: Maybe<(
    { __typename?: 'Refresh' }
    & Pick<Refresh, 'token'>
  )> }
);

export type TokenVerifyMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type TokenVerifyMutation = (
  { __typename?: 'Mutations' }
  & { tokenVerify?: Maybe<(
    { __typename?: 'Verify' }
    & Pick<Verify, 'payload'>
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  interest?: Maybe<Scalars['String']>;
  interestedInCn?: Maybe<Scalars['Boolean']>;
  organisation?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutations' }
  & { updateUser?: Maybe<(
    { __typename?: 'UserInformationOutput' }
    & Pick<UserInformationOutput, 'organisation' | 'interest' | 'interestedInCn'>
  )> }
);

export type DuplicateCanaryNetworkMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  uuid: Scalars['String'];
  incorporateLiveEvents?: Maybe<Scalars['Boolean']>;
}>;


export type DuplicateCanaryNetworkMutation = (
  { __typename?: 'Mutations' }
  & { duplicateCanaryNetwork?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'name' | 'uuid' | 'description' | 'user' | 'simulationResults'>
    & { configType: ConfigurationOutput['type'] }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'uuid'>
    )>, scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { representation?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type BatchRegisterExternalConnectionMutationVariables = Exact<{
  configUuid: Scalars['String'];
  applicationMapping?: Maybe<Array<Maybe<AreaUuidApplyMapping>> | Maybe<AreaUuidApplyMapping>>;
}>;


export type BatchRegisterExternalConnectionMutation = (
  { __typename?: 'Mutations' }
  & { batchRegisterExternalConnection?: Maybe<(
    { __typename?: 'RegistrationResponse' }
    & Pick<RegistrationResponse, 'response' | 'message'>
  )> }
);

export type BatchResponseExternalConnectionRequestMutationVariables = Exact<{
  configUuid: Scalars['String'];
  responseList?: Maybe<Array<Maybe<InputRespondExternalConnectionRequest>> | Maybe<InputRespondExternalConnectionRequest>>;
}>;


export type BatchResponseExternalConnectionRequestMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'batchResponseExternalConnectionRequest'>
);

export type CreateCanaryNetworkMutationVariables = Exact<{
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  private?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
}>;


export type CreateCanaryNetworkMutation = (
  { __typename?: 'Mutations' }
  & { moveCollaborationToCanaryNetwork?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'name' | 'uuid' | 'type'>
  )> }
);

export type DuplicateCollaborationMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  uuid: Scalars['String'];
  incorporateLiveEvents?: Maybe<Scalars['Boolean']>;
}>;


export type DuplicateCollaborationMutation = (
  { __typename?: 'Mutations' }
  & { duplicateCollaboration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'name' | 'uuid' | 'description' | 'user' | 'simulationResults'>
    & { configType: ConfigurationOutput['type'] }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'uuid'>
    )>, scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { representation?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type RegExternalConnectionMutationVariables = Exact<{
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
  apply: Scalars['Boolean'];
}>;


export type RegExternalConnectionMutation = (
  { __typename?: 'Mutations' }
  & { registerExternalConnection?: Maybe<(
    { __typename?: 'RegistrationResponse' }
    & Pick<RegistrationResponse, 'response' | 'message'>
  )> }
);

export type RegGridConnectionMutationVariables = Exact<{
  configUuid: Scalars['String'];
  areaUuid: Scalars['String'];
  apply: Scalars['Boolean'];
}>;


export type RegGridConnectionMutation = (
  { __typename?: 'Mutations' }
  & { registerGridConnection?: Maybe<(
    { __typename?: 'RegistrationResponse' }
    & Pick<RegistrationResponse, 'response' | 'message'>
  )> }
);

export type RegisterCollaborationMutationVariables = Exact<{
  configUuid: Scalars['String'];
}>;


export type RegisterCollaborationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'registerCollaboration'>
);

export type RespondExternalConnectionRequestMutationVariables = Exact<{
  username: Scalars['String'];
  areaUuid: Scalars['String'];
  configUuid: Scalars['String'];
  accept: Scalars['Boolean'];
}>;


export type RespondExternalConnectionRequestMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'respondExternalConnectionRequest'>
);

export type CreateConfigurationMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  projectUuid: Scalars['String'];
  settingsData?: Maybe<SettingsInput>;
  scenarioData?: Maybe<ScenarioInput>;
}>;


export type CreateConfigurationMutation = (
  { __typename?: 'Mutations' }
  & { createConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type CreateConfigurationAreaMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  parentUuid: Scalars['String'];
  areaRepresentation: AreaInput;
}>;


export type CreateConfigurationAreaMutation = (
  { __typename?: 'Mutations' }
  & { createConfigurationArea?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type DeleteConfigurationMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
}>;


export type DeleteConfigurationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'deleteConfiguration'>
);

export type DuplicateConfigurationMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  configurationUuid: Scalars['String'];
  incorporateLiveEvents?: Maybe<Scalars['Boolean']>;
}>;


export type DuplicateConfigurationMutation = (
  { __typename?: 'Mutations' }
  & { duplicateConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'name' | 'uuid' | 'description' | 'user' | 'simulationResults'>
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'uuid'>
    )>, scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { representation?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type MoveConfigurationToCollaborationMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;


export type MoveConfigurationToCollaborationMutation = (
  { __typename?: 'Mutations' }
  & { moveConfigurationToCollaboration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'name' | 'uuid' | 'simulationResults' | 'description' | 'user' | 'timestamp' | 'readOnly' | 'warnings'>
    & { configType: ConfigurationOutput['type'] }
    & { project?: Maybe<(
      { __typename?: 'Project' }
      & Pick<Project, 'uuid'>
    )>, scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { representation?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type PartialUpdateConfigurationMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  partialScenario: AreaInput;
}>;


export type PartialUpdateConfigurationMutation = (
  { __typename?: 'Mutations' }
  & { partialUpdateConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type RemoveConfigurationAreaMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  areaUuid: Scalars['String'];
}>;


export type RemoveConfigurationAreaMutation = (
  { __typename?: 'Mutations' }
  & { removeConfigurationArea?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type UpdateConfigurationMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  configurationUuid: Scalars['String'];
  projectUuid: Scalars['String'];
  settingsData?: Maybe<SettingsInput>;
  scenarioData?: Maybe<ScenarioInput>;
}>;


export type UpdateConfigurationMutation = (
  { __typename?: 'Mutations' }
  & { updateConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type UpdateConfigurationAreaMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  areaUuid: Scalars['String'];
  areaParams: AreaInput;
}>;


export type UpdateConfigurationAreaMutation = (
  { __typename?: 'Mutations' }
  & { updateConfigurationArea?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type UpdateConfigurationTreeMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  scenarioData: ScenarioInput;
}>;


export type UpdateConfigurationTreeMutation = (
  { __typename?: 'Mutations' }
  & { updateConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type UserContactFormMutationVariables = Exact<{
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
}>;


export type UserContactFormMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'userContactForm'>
);

export type DeleteGlobalSimulationLocationMutationVariables = Exact<{
  configUuid: Scalars['String'];
}>;


export type DeleteGlobalSimulationLocationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'deleteGlobalSimulationLocation'>
);

export type SetGlobalSimulationLocationMutationVariables = Exact<{
  configUuid: Scalars['String'];
  centreCoordinates?: Maybe<Position>;
  boundaryId: Scalars['String'];
  visibility: Scalars['Boolean'];
}>;


export type SetGlobalSimulationLocationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'setGlobalSimulationLocation'>
);

export type ToggleGlobalSimulationVisibilityMutationVariables = Exact<{
  configUuid: Scalars['String'];
}>;


export type ToggleGlobalSimulationVisibilityMutation = (
  { __typename?: 'Mutations' }
  & { toggleGlobalSimulationVisibility?: Maybe<(
    { __typename?: 'SimulationLocationVisibilityOutput' }
    & Pick<SimulationLocationVisibilityOutput, 'configUuid' | 'boundaryId' | 'visibility'>
    & { configType: SimulationLocationVisibilityOutput['type'] }
  )> }
);

export type UpdateUserSimulationVisibilityMutationVariables = Exact<{
  visibility: Scalars['Boolean'];
}>;


export type UpdateUserSimulationVisibilityMutation = (
  { __typename?: 'Mutations' }
  & { updateUserSimulationVisibility?: Maybe<(
    { __typename?: 'UserSimulationLocationVisibility' }
    & Pick<UserSimulationLocationVisibility, 'username' | 'visibility'>
  )> }
);

export type CreateLibraryMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  scenarioData?: Maybe<ScenarioInput>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  configurationUuid?: Maybe<Scalars['String']>;
}>;


export type CreateLibraryMutation = (
  { __typename?: 'Mutations' }
  & { createLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & Pick<LibraryOutput, 'uuid'>
  )> }
);

export type DeleteLibraryMutationVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type DeleteLibraryMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'deleteLibrary'>
);

export type DuplicateLibraryMutationVariables = Exact<{
  uuid: Scalars['String'];
  isPrivate: Scalars['Boolean'];
}>;


export type DuplicateLibraryMutation = (
  { __typename?: 'Mutations' }
  & { duplicateLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & Pick<LibraryOutput, 'uuid' | 'name' | 'private'>
  )> }
);

export type PostDuplicationLibraryMutationVariables = Exact<{
  uuid: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;


export type PostDuplicationLibraryMutation = (
  { __typename?: 'Mutations' }
  & { updateLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & Pick<LibraryOutput, 'uuid' | 'name' | 'description'>
  )> }
);

export type UpdateLibraryMutationVariables = Exact<{
  uuid: Scalars['String'];
  scenarioData: ScenarioInput;
}>;


export type UpdateLibraryMutation = (
  { __typename?: 'Mutations' }
  & { updateLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & Pick<LibraryOutput, 'name' | 'readOnly'>
    & { scenarioData?: Maybe<(
      { __typename?: 'ScenarioLibraryOutput' }
      & Pick<ScenarioLibraryOutput, 'deviceCountNumber' | 'areaCountNumber'>
      & { representation?: Maybe<(
        { __typename?: 'PV' }
        & Pick<Pv, 'serialized'>
      ) | (
        { __typename?: 'Storage' }
        & Pick<Storage, 'serialized'>
      ) | (
        { __typename?: 'Load' }
        & Pick<Load, 'serialized'>
      ) | { __typename?: 'SmartMeter' } | (
        { __typename?: 'FiniteDieselGenerator' }
        & Pick<FiniteDieselGenerator, 'serialized'>
      ) | (
        { __typename?: 'MarketMaker' }
        & Pick<MarketMaker, 'serialized'>
      ) | (
        { __typename?: 'InfiniteBus' }
        & Pick<InfiniteBus, 'serialized'>
      ) | (
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type UpdateLibraryDataMutationVariables = Exact<{
  uuid: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;


export type UpdateLibraryDataMutation = (
  { __typename?: 'Mutations' }
  & { updateLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & Pick<LibraryOutput, 'uuid' | 'name' | 'description'>
  )> }
);

export type BulkAreaLiveEventMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  eventList?: Maybe<Array<Maybe<LiveEventInput>> | Maybe<LiveEventInput>>;
}>;


export type BulkAreaLiveEventMutation = (
  { __typename?: 'Mutations' }
  & { bulkAreaLiveEvent?: Maybe<(
    { __typename?: 'BulkLiveEventOutput' }
    & { latestConfig?: Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & ConfigurationFieldsFragment
    )>, eventList?: Maybe<Array<Maybe<(
      { __typename?: 'LiveEventListOutput' }
      & Pick<LiveEventListOutput, 'eventType' | 'parameters' | 'timeStamp' | 'diff'>
    )>>> }
  )> }
);

export type CreateAreaLiveEventMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  parentUuid: Scalars['String'];
  areaRepresentation?: Maybe<AreaInput>;
  libraryUuid?: Maybe<Scalars['String']>;
}>;


export type CreateAreaLiveEventMutation = (
  { __typename?: 'Mutations' }
  & { createAreaLiveEvent?: Maybe<(
    { __typename?: 'LiveEventResponse' }
    & { latestConfig?: Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & ConfigurationFieldsFragment
    )> }
  )> }
);

export type DeleteAreaLiveEventMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  areaUuid: Scalars['String'];
}>;


export type DeleteAreaLiveEventMutation = (
  { __typename?: 'Mutations' }
  & { deleteAreaLiveEvent?: Maybe<(
    { __typename?: 'LiveEventResponse' }
    & { latestConfig?: Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & ConfigurationFieldsFragment
    )> }
  )> }
);

export type UpdateAreaLiveEventMutationVariables = Exact<{
  configurationUuid: Scalars['String'];
  areaUuid: Scalars['String'];
  areaParams: AreaInput;
}>;


export type UpdateAreaLiveEventMutation = (
  { __typename?: 'Mutations' }
  & { updateAreaLiveEvent?: Maybe<(
    { __typename?: 'LiveEventResponse' }
    & { latestConfig?: Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & ConfigurationFieldsFragment
    )> }
  )> }
);

export type CreateProjectMutationVariables = Exact<{
  centreCoordinates?: Maybe<Position>;
  description?: Maybe<Scalars['String']>;
  locationVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  private?: Maybe<Scalars['Boolean']>;
}>;


export type CreateProjectMutation = (
  { __typename?: 'Mutations' }
  & { createProject?: Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'name' | 'uuid' | 'description' | 'private' | 'user'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid'>
    )>>> }
  )> }
);

export type DeleteProjectMutationVariables = Exact<{
  projectUuid: Scalars['String'];
}>;


export type DeleteProjectMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'deleteProject'>
);

export type UpdateProjectMutationVariables = Exact<{
  projectUuid: Scalars['String'];
  centreCoordinates?: Maybe<Position>;
  description?: Maybe<Scalars['String']>;
  locationVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateProjectMutation = (
  { __typename?: 'Mutations' }
  & { updateProject?: Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'name' | 'uuid' | 'user' | 'timestamp' | 'private' | 'latitude' | 'longitude'>
  )> }
);

export type LaunchSimulationMutationVariables = Exact<{
  uuid?: Maybe<Scalars['String']>;
}>;


export type LaunchSimulationMutation = (
  { __typename?: 'Mutations' }
  & { launchSimulation?: Maybe<(
    { __typename?: 'LaunchResponse' }
    & Pick<LaunchResponse, 'job' | 'status' | 'configUUID'>
  )> }
);

export type PauseSimulationMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type PauseSimulationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'pauseSimulation'>
);

export type ResumeSimulationMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type ResumeSimulationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'resumeSimulation'>
);

export type StopSimulationMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type StopSimulationMutation = (
  { __typename?: 'Mutations' }
  & Pick<Mutations, 'stopSimulation'>
);

export type AvailableRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableRolesQuery = (
  { __typename?: 'Queries' }
  & { availableUserRoles?: Maybe<(
    { __typename?: 'AvailableUserRolesOutput' }
    & { userRoles?: Maybe<Array<Maybe<(
      { __typename?: 'UserRoleOutput' }
      & Pick<UserRoleOutput, 'roleName' | 'value'>
    )>>> }
  )> }
);

export type ListAdminStatsQueryVariables = Exact<{
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  emailSearch?: Maybe<Scalars['String']>;
  userRoles?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type ListAdminStatsQuery = (
  { __typename?: 'Queries' }
  & { listAdminStats?: Maybe<(
    { __typename?: 'AdminStats' }
    & { userActivity?: Maybe<(
      { __typename?: 'ActivityDetailOutput' }
      & { newRegistration?: Maybe<Array<Maybe<(
        { __typename?: 'RegistrationOutput' }
        & Pick<RegistrationOutput, 'username' | 'timestamp'>
      )>>>, loginDetail?: Maybe<Array<Maybe<(
        { __typename?: 'ActivityOutput' }
        & Pick<ActivityOutput, 'timestamp' | 'durationMs' | 'username'>
      )>>> }
    )> }
  )> }
);

export type ListAdminStatsWithRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAdminStatsWithRolesQuery = (
  { __typename?: 'Queries' }
  & { listAdminStats?: Maybe<(
    { __typename?: 'AdminStats' }
    & { userDetails?: Maybe<Array<Maybe<(
      { __typename?: 'UserDetailOutput' }
      & Pick<UserDetailOutput, 'id' | 'username' | 'numberOfProjects' | 'numberOfSimulations' | 'activeTimeInSeconds' | 'numberOfConfiguredAgents' | 'numberOfLibraries' | 'userRole'>
      & { joined: UserDetailOutput['joinedDate'] }
    )>>> }
  )>, availableUserRoles?: Maybe<(
    { __typename?: 'AvailableUserRolesOutput' }
    & { userRoles?: Maybe<Array<Maybe<(
      { __typename?: 'UserRoleOutput' }
      & Pick<UserRoleOutput, 'roleName' | 'value'>
    )>>> }
  )> }
);

export type ReadUserRoleQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type ReadUserRoleQuery = (
  { __typename?: 'Queries' }
  & { readUserRole?: Maybe<(
    { __typename?: 'UserRoleOutput' }
    & Pick<UserRoleOutput, 'roleName' | 'value'>
  )> }
);

export type PasswordResetQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type PasswordResetQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'passwordResetEmail'>
);

export type ListCanaryNetworksQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ListCanaryNetworksQuery = (
  { __typename?: 'Queries' }
  & { listCanaryNetworks?: Maybe<(
    { __typename?: 'ListConfigurationOutput' }
    & Pick<ListConfigurationOutput, 'totalCount'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'name' | 'uuid' | 'simulationResults' | 'description' | 'user' | 'timestamp' | 'readOnly' | 'warnings' | 'openForExternalApplications' | 'resultsStatus' | 'private'>
      & { configType: ConfigurationOutput['type'] }
      & { scenarioData?: Maybe<(
        { __typename?: 'ScenarioOutput' }
        & Pick<ScenarioOutput, 'deviceCount'>
      )>, project?: Maybe<(
        { __typename?: 'Project' }
        & Pick<Project, 'uuid'>
      )>, areaSummary?: Maybe<(
        { __typename?: 'ConfigurationDetails' }
        & Pick<ConfigurationDetails, 'configuredAreas' | 'configuredDevices'>
      )> }
    )>>> }
  )> }
);

export type ListCanaryNetworksStatusesQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ListCanaryNetworksStatusesQuery = (
  { __typename?: 'Queries' }
  & { listCanaryNetworks?: Maybe<(
    { __typename?: 'ListConfigurationOutput' }
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid' | 'resultsStatus'>
      & { project?: Maybe<(
        { __typename?: 'Project' }
        & Pick<Project, 'uuid'>
      )> }
    )>>> }
  )> }
);

export type AvailableMarketsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type AvailableMarketsQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'availableMarkets'>
);

export type ListCollaborationsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ListCollaborationsQuery = (
  { __typename?: 'Queries' }
  & { listCollaborations?: Maybe<(
    { __typename?: 'ListConfigurationOutput' }
    & Pick<ListConfigurationOutput, 'totalCount'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid' | 'name' | 'description' | 'readOnly' | 'simulationResults' | 'resultsStatus' | 'timestamp' | 'user' | 'openForExternalApplications' | 'private'>
      & { configType: ConfigurationOutput['type'] }
      & { scenarioData?: Maybe<(
        { __typename?: 'ScenarioOutput' }
        & Pick<ScenarioOutput, 'deviceCount'>
      )>, areaSummary?: Maybe<(
        { __typename?: 'ConfigurationDetails' }
        & Pick<ConfigurationDetails, 'configuredAreas' | 'configuredDevices'>
      )>, project?: Maybe<(
        { __typename?: 'Project' }
        & Pick<Project, 'uuid'>
      )> }
    )>>> }
  )> }
);

export type ListCollaborationsStatusesQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type ListCollaborationsStatusesQuery = (
  { __typename?: 'Queries' }
  & { listCollaborations?: Maybe<(
    { __typename?: 'ListConfigurationOutput' }
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid' | 'resultsStatus'>
      & { project?: Maybe<(
        { __typename?: 'Project' }
        & Pick<Project, 'uuid'>
      )> }
    )>>> }
  )> }
);

export type MyApplicationsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type MyApplicationsQuery = (
  { __typename?: 'Queries' }
  & { listApplicationStatus?: Maybe<Array<Maybe<(
    { __typename?: 'ExternalConnectionApplicantOutput' }
    & Pick<ExternalConnectionApplicantOutput, 'areaUuid' | 'status'>
  )>>> }
);

export type ReadCollaborationConfigurationQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadCollaborationConfigurationQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type ReadConfigWithApplicationsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadConfigWithApplicationsQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'availableTargetMarketKpis' | 'availableTargetDeviceKpis'>
  & { listAvailableExternalApplication?: Maybe<Array<Maybe<(
    { __typename?: 'ExternalConnectionApplicantOutput' }
    & Pick<ExternalConnectionApplicantOutput, 'username' | 'configUuid' | 'areaUuid' | 'status'>
  )>>> }
);

export type ReadConfigWithMyApplicationsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadConfigWithMyApplicationsQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'availableTargetMarketKpis' | 'availableTargetDeviceKpis'>
  & { listApplicationStatus?: Maybe<Array<Maybe<(
    { __typename?: 'ExternalConnectionApplicantOutput' }
    & Pick<ExternalConnectionApplicantOutput, 'configUuid' | 'areaUuid' | 'status'>
  )>>>, listAvailableExternalConnection?: Maybe<Array<Maybe<(
    { __typename?: 'ExternalConnectionConfigurationsOutput' }
    & { configuration?: Maybe<Array<Maybe<(
      { __typename?: 'ExternalConnectionAreaOutput' }
      & Pick<ExternalConnectionAreaOutput, 'configUuid' | 'availableAreaUuids'>
    )>>> }
  )>>> }
);

export type ListCommunityInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCommunityInfoQuery = (
  { __typename?: 'Queries' }
  & { listCommunityInfo?: Maybe<(
    { __typename?: 'CommunityOutput' }
    & { projects?: Maybe<Array<Maybe<(
      { __typename?: 'CommunityProjectOutput' }
      & Pick<CommunityProjectOutput, 'name' | 'uuid' | 'user' | 'timestamp' | 'private' | 'latitude' | 'longitude' | 'locationVisible'>
      & { configurations?: Maybe<Array<Maybe<(
        { __typename?: 'CommunityConfigurationOutput' }
        & Pick<CommunityConfigurationOutput, 'name' | 'uuid' | 'globalCumulativeNetEnergyFlow' | 'latitude' | 'longitude'>
        & { configType: CommunityConfigurationOutput['type'] }
      )>>> }
    )>>> }
  )> }
);

export type ListPersonalCommunityInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPersonalCommunityInfoQuery = (
  { __typename?: 'Queries' }
  & { listPersonalCommunityInfo?: Maybe<(
    { __typename?: 'CommunityOutput' }
    & { projects?: Maybe<Array<Maybe<(
      { __typename?: 'CommunityProjectOutput' }
      & Pick<CommunityProjectOutput, 'name' | 'uuid' | 'user' | 'timestamp' | 'private' | 'latitude' | 'longitude' | 'locationVisible'>
      & { configurations?: Maybe<Array<Maybe<(
        { __typename?: 'CommunityConfigurationOutput' }
        & Pick<CommunityConfigurationOutput, 'name' | 'uuid' | 'globalCumulativeNetEnergyFlow' | 'latitude' | 'longitude'>
        & { configType: CommunityConfigurationOutput['type'] }
      )>>> }
    )>>> }
  )> }
);

export type AreaSummaryQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type AreaSummaryQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'areaSummary'>
);

export type ListConfigurationsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  projectUuid?: Maybe<Scalars['String']>;
}>;


export type ListConfigurationsQuery = (
  { __typename?: 'Queries' }
  & { listConfigurations?: Maybe<(
    { __typename?: 'ListConfigurationOutput' }
    & Pick<ListConfigurationOutput, 'totalCount'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid' | 'name' | 'user' | 'description' | 'readOnly' | 'simulationResults' | 'resultsStatus' | 'timestamp' | 'private'>
      & { configType: ConfigurationOutput['type'] }
      & { scenarioData?: Maybe<(
        { __typename?: 'ScenarioOutput' }
        & Pick<ScenarioOutput, 'deviceCount'>
      )>, areaSummary?: Maybe<(
        { __typename?: 'ConfigurationDetails' }
        & Pick<ConfigurationDetails, 'configuredAreas' | 'configuredDevices'>
      )>, project?: Maybe<(
        { __typename?: 'Project' }
        & Pick<Project, 'uuid'>
      )> }
    )>>> }
  )> }
);

export type LookForCommunityUuidQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type LookForCommunityUuidQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'name' | 'uuid' | 'simulationResults' | 'resultsStatus'>
    & { scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { latest?: Maybe<(
        { __typename?: 'AreaOutput' }
        & { children?: Maybe<Array<Maybe<{ __typename?: 'PV' } | { __typename?: 'Storage' } | { __typename?: 'Load' } | { __typename?: 'SmartMeter' } | { __typename?: 'FiniteDieselGenerator' } | { __typename?: 'MarketMaker' } | { __typename?: 'InfiniteBus' } | (
          { __typename?: 'AreaOutput' }
          & Pick<AreaOutput, 'name' | 'uuid'>
        )>>> }
      )> }
    )> }
  )> }
);

export type LookForSimulationResultsQueryVariables = Exact<{
  configurationUuid: Scalars['String'];
}>;


export type LookForSimulationResultsQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'uuid' | 'simulationResults' | 'resultsStatus'>
  )> }
);

export type ReadConfigRepresentationWithoutEventsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadConfigRepresentationWithoutEventsQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & { scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { representation?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type ReadConfigurationQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadConfigurationQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & ConfigurationFieldsFragment
  )> }
);

export type ReadConfigurationBaseInfoQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadConfigurationBaseInfoQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'uuid' | 'user' | 'private'>
    & { configType: ConfigurationOutput['type'] }
  )> }
);

export type ReadConfigurationSummaryQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadConfigurationSummaryQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & { areaSummary?: Maybe<(
      { __typename?: 'ConfigurationDetails' }
      & Pick<ConfigurationDetails, 'configuredAreas' | 'configuredDevices'>
    )> }
  )> }
);

export type ReadDataToDetermineUsedNodesNamesQueryVariables = Exact<{
  configurationUuid: Scalars['String'];
  skipReadConfiguration?: Maybe<Scalars['Boolean']>;
  skipReadLibrary?: Maybe<Scalars['Boolean']>;
}>;


export type ReadDataToDetermineUsedNodesNamesQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & { scenarioData?: Maybe<(
      { __typename?: 'ScenarioOutput' }
      & { representation?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )>, latest?: Maybe<(
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )>, readLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & { scenarioData?: Maybe<(
      { __typename?: 'ScenarioLibraryOutput' }
      & { representation?: Maybe<(
        { __typename?: 'PV' }
        & Pick<Pv, 'serialized'>
      ) | (
        { __typename?: 'Storage' }
        & Pick<Storage, 'serialized'>
      ) | (
        { __typename?: 'Load' }
        & Pick<Load, 'serialized'>
      ) | { __typename?: 'SmartMeter' } | (
        { __typename?: 'FiniteDieselGenerator' }
        & Pick<FiniteDieselGenerator, 'serialized'>
      ) | (
        { __typename?: 'MarketMaker' }
        & Pick<MarketMaker, 'serialized'>
      ) | (
        { __typename?: 'InfiniteBus' }
        & Pick<InfiniteBus, 'serialized'>
      ) | (
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )>, listLiveEvents?: Maybe<Array<Maybe<(
    { __typename?: 'LiveEventListOutput' }
    & Pick<LiveEventListOutput, 'diff'>
  )>>> }
);

export type GetUserGlobalLocationVisibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGlobalLocationVisibilityQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'getUserGlobalLocationVisibility'>
);

export type ListGlobalSimulationLocationQueryVariables = Exact<{
  minLat: Scalars['Float'];
  minLong: Scalars['Float'];
  maxLat: Scalars['Float'];
  maxLong: Scalars['Float'];
}>;


export type ListGlobalSimulationLocationQuery = (
  { __typename?: 'Queries' }
  & { listGlobalSimulationLocation?: Maybe<Array<Maybe<(
    { __typename?: 'LocationBoundaryOutput' }
    & Pick<LocationBoundaryOutput, 'boundaryId' | 'totalMarkets' | 'totalDevices' | 'simulationsInProgress'>
  )>>> }
);

export type ListUserGlobalSimulationVisibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserGlobalSimulationVisibilityQuery = (
  { __typename?: 'Queries' }
  & { listUserGlobalSimulationVisibility?: Maybe<Array<Maybe<(
    { __typename?: 'SimulationLocationVisibilityOutput' }
    & Pick<SimulationLocationVisibilityOutput, 'configUuid' | 'visibility' | 'boundaryId' | 'totalMarkets' | 'totalDevices' | 'simulationsInProgress' | 'projectUuid'>
    & { configType: SimulationLocationVisibilityOutput['type'] }
  )>>> }
);

export type ReadGlobalSimulationLocationQueryVariables = Exact<{
  configUuid: Scalars['String'];
}>;


export type ReadGlobalSimulationLocationQuery = (
  { __typename?: 'Queries' }
  & { readGlobalSimulationLocation?: Maybe<(
    { __typename?: 'SimulationLocationOutput' }
    & Pick<SimulationLocationOutput, 'longitude' | 'latitude' | 'boundaryId' | 'visibility'>
  )> }
);

export type ListLibrariesQueryVariables = Exact<{
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type ListLibrariesQuery = (
  { __typename?: 'Queries' }
  & { listLibraries?: Maybe<(
    { __typename?: 'ListLibraryOutput' }
    & Pick<ListLibraryOutput, 'totalCount'>
    & { libraries?: Maybe<Array<Maybe<(
      { __typename?: 'LibraryOutput' }
      & Pick<LibraryOutput, 'name' | 'uuid' | 'description' | 'user' | 'private' | 'readOnly'>
      & { scenarioData?: Maybe<(
        { __typename?: 'ScenarioLibraryOutput' }
        & Pick<ScenarioLibraryOutput, 'deviceCountNumber' | 'areaCountNumber'>
        & { representation?: Maybe<(
          { __typename?: 'PV' }
          & Pick<Pv, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'Storage' }
          & Pick<Storage, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'Load' }
          & Pick<Load, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'SmartMeter' }
          & Pick<SmartMeter, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'FiniteDieselGenerator' }
          & Pick<FiniteDieselGenerator, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'MarketMaker' }
          & Pick<MarketMaker, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'InfiniteBus' }
          & Pick<InfiniteBus, 'serialized' | 'type' | 'uuid'>
        ) | (
          { __typename?: 'AreaOutput' }
          & Pick<AreaOutput, 'serialized' | 'type' | 'uuid'>
        )> }
      )> }
    )>>> }
  )> }
);

export type ListLibrariesWithDataQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type ListLibrariesWithDataQuery = (
  { __typename?: 'Queries' }
  & { listLibraries?: Maybe<(
    { __typename?: 'ListLibraryOutput' }
    & Pick<ListLibraryOutput, 'totalCount'>
    & { libraries?: Maybe<Array<Maybe<(
      { __typename?: 'LibraryOutput' }
      & Pick<LibraryOutput, 'name' | 'uuid' | 'private'>
      & { scenarioData?: Maybe<(
        { __typename?: 'ScenarioLibraryOutput' }
        & Pick<ScenarioLibraryOutput, 'deviceCount' | 'deviceCountNumber' | 'areaCountNumber'>
        & { representation?: Maybe<(
          { __typename?: 'PV' }
          & Pick<Pv, 'serialized'>
        ) | (
          { __typename?: 'Storage' }
          & Pick<Storage, 'serialized'>
        ) | (
          { __typename?: 'Load' }
          & Pick<Load, 'serialized'>
        ) | { __typename?: 'SmartMeter' } | (
          { __typename?: 'FiniteDieselGenerator' }
          & Pick<FiniteDieselGenerator, 'serialized'>
        ) | (
          { __typename?: 'MarketMaker' }
          & Pick<MarketMaker, 'serialized' | 'energyRateProfileUuid'>
        ) | (
          { __typename?: 'InfiniteBus' }
          & Pick<InfiniteBus, 'serialized' | 'energyRateProfileUuid' | 'buyingRateProfileUuid'>
        ) | (
          { __typename?: 'AreaOutput' }
          & Pick<AreaOutput, 'serialized'>
        )> }
      )> }
    )>>> }
  )> }
);

export type ReadLibraryQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadLibraryQuery = (
  { __typename?: 'Queries' }
  & { readLibrary?: Maybe<(
    { __typename?: 'LibraryOutput' }
    & Pick<LibraryOutput, 'uuid' | 'name' | 'description' | 'readOnly'>
    & { scenarioData?: Maybe<(
      { __typename?: 'ScenarioLibraryOutput' }
      & Pick<ScenarioLibraryOutput, 'deviceCountNumber' | 'areaCountNumber'>
      & { representation?: Maybe<(
        { __typename?: 'PV' }
        & Pick<Pv, 'serialized'>
      ) | (
        { __typename?: 'Storage' }
        & Pick<Storage, 'serialized'>
      ) | (
        { __typename?: 'Load' }
        & Pick<Load, 'serialized'>
      ) | { __typename?: 'SmartMeter' } | (
        { __typename?: 'FiniteDieselGenerator' }
        & Pick<FiniteDieselGenerator, 'serialized'>
      ) | (
        { __typename?: 'MarketMaker' }
        & Pick<MarketMaker, 'serialized'>
      ) | (
        { __typename?: 'InfiniteBus' }
        & Pick<InfiniteBus, 'serialized'>
      ) | (
        { __typename?: 'AreaOutput' }
        & Pick<AreaOutput, 'serialized'>
      )> }
    )> }
  )> }
);

export type ListLiveEventsQueryVariables = Exact<{
  configUUID: Scalars['String'];
}>;


export type ListLiveEventsQuery = (
  { __typename?: 'Queries' }
  & { listLiveEvents?: Maybe<Array<Maybe<(
    { __typename?: 'LiveEventListOutput' }
    & Pick<LiveEventListOutput, 'eventType' | 'parameters' | 'timeStamp' | 'diff'>
  )>>> }
);

export type LiveEventsRepresentationQueryVariables = Exact<{
  configUuid: Scalars['String'];
  time: Scalars['DateTime'];
}>;


export type LiveEventsRepresentationQuery = (
  { __typename?: 'Queries' }
  & { liveEventsRepresentation?: Maybe<(
    { __typename?: 'LiveEventRepresentation' }
    & Pick<LiveEventRepresentation, 'timeStamp'>
    & { representation?: Maybe<(
      { __typename?: 'AreaOutput' }
      & Pick<AreaOutput, 'serialized'>
    )> }
  )> }
);

export type ListProjectStatusesQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  nrConfigs?: Maybe<Scalars['Int']>;
}>;


export type ListProjectStatusesQuery = (
  { __typename?: 'Queries' }
  & { listProjects?: Maybe<Array<Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'uuid'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid' | 'name' | 'resultsStatus'>
    )>>> }
  )>>> }
);

export type ListProjectsQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  nrConfigs?: Maybe<Scalars['Int']>;
}>;


export type ListProjectsQuery = (
  { __typename?: 'Queries' }
  & { listProjects?: Maybe<Array<Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'name' | 'uuid' | 'description' | 'user' | 'private'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid' | 'name' | 'resultsStatus'>
    )>>> }
  )>>> }
);

export type ReadProjectQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadProjectQuery = (
  { __typename?: 'Queries' }
  & { readProject?: Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'name' | 'uuid' | 'user' | 'description' | 'private'>
    & { configurations?: Maybe<Array<Maybe<(
      { __typename?: 'ConfigurationOutput' }
      & Pick<ConfigurationOutput, 'uuid'>
    )>>> }
  )> }
);

export type ReadProjectLocationVisibilityQueryVariables = Exact<{
  projectUuid: Scalars['String'];
}>;


export type ReadProjectLocationVisibilityQuery = (
  { __typename?: 'Queries' }
  & { readProject?: Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'locationVisible' | 'private'>
  )> }
);

export type ReadProjectTitleQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadProjectTitleQuery = (
  { __typename?: 'Queries' }
  & { readProject?: Maybe<(
    { __typename?: 'ProjectOutput' }
    & Pick<ProjectOutput, 'name'>
  )> }
);

export type CommunitySummaryResultsQueryVariables = Exact<{
  jobId: Scalars['String'];
  communityUuid: Scalars['String'];
}>;


export type CommunitySummaryResultsQuery = (
  { __typename?: 'Queries' }
  & { simulationResults?: Maybe<(
    { __typename?: 'SimulationResultsData' }
    & Pick<SimulationResultsData, 'priceEnergyAreaBalance' | 'cumulativeNetEnergyFlow'>
  )> }
);

export type HouseSummaryResultsQueryVariables = Exact<{
  jobId: Scalars['String'];
  assetUuid: Scalars['String'];
  timeResolutionHrs?: Maybe<Scalars['Int']>;
}>;


export type HouseSummaryResultsQuery = (
  { __typename?: 'Queries' }
  & { simulationResults?: Maybe<(
    { __typename?: 'SimulationResultsData' }
    & Pick<SimulationResultsData, 'currentMarket' | 'areaThroughput' | 'status'>
    & { marketSummary?: Maybe<Array<Maybe<(
      { __typename?: 'MarketSummary' }
      & Pick<MarketSummary, 'averageEnergyRate' | 'timestamp'>
    )>>> }
  )> }
);

export type ReadScoreboardResultsQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type ReadScoreboardResultsQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'simulationStatus' | 'scoreboardResults'>
);

export type ReadSimulationProgressQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ReadSimulationProgressQuery = (
  { __typename?: 'Queries' }
  & { readConfiguration?: Maybe<(
    { __typename?: 'ConfigurationOutput' }
    & Pick<ConfigurationOutput, 'resultsStatus'>
    & { resultsProgressInfo?: Maybe<(
      { __typename?: 'ProgressInfo' }
      & Pick<ProgressInfo, 'percentageCompleted'>
    )> }
  )> }
);

export type ReadSimulationResultsQueryVariables = Exact<{
  jobId: Scalars['String'];
  uuid: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
}>;


export type ReadSimulationResultsQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'simulationStatus'>
  & { simulationResults?: Maybe<(
    { __typename?: 'SimulationResultsData' }
    & Pick<SimulationResultsData, 'areaUuid' | 'cumulativeBills' | 'cumulativeGridTrades' | 'currentMarket' | 'cumulativeNetEnergyFlow' | 'deviceStatistics' | 'energyTradeProfileAreaThroughput' | 'kpi' | 'priceEnergyAreaBalance' | 'priceEnergyDay' | 'latestSavingsKpi' | 'savingsKpiProfile' | 'assetsInfo' | 'status'>
    & { marketSummary?: Maybe<Array<Maybe<(
      { __typename?: 'MarketSummary' }
      & Pick<MarketSummary, 'externalTradedVolume' | 'averageEnergyRate' | 'timestamp' | 'tradedVolume'>
    )>>>, progressInfo?: Maybe<(
      { __typename?: 'ProgressInfo' }
      & Pick<ProgressInfo, 'percentageCompleted' | 'etaSeconds' | 'elapsedTimeSeconds'>
    )> }
  )> }
);

export type ReadSimulationResultsBidTradeQueryVariables = Exact<{
  jobId: Scalars['String'];
  assetUuid: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
}>;


export type ReadSimulationResultsBidTradeQuery = (
  { __typename?: 'Queries' }
  & { simulationResults?: Maybe<(
    { __typename?: 'SimulationResultsData' }
    & Pick<SimulationResultsData, 'bidsOffersTrades'>
  )> }
);

export type ReadSimulationResultsEnergyHiResQueryVariables = Exact<{
  jobId: Scalars['String'];
  uuid: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
}>;


export type ReadSimulationResultsEnergyHiResQuery = (
  { __typename?: 'Queries' }
  & { simulationResults?: Maybe<(
    { __typename?: 'SimulationResultsData' }
    & Pick<SimulationResultsData, 'energyTradesHighResolution'>
  )> }
);

export type ReadSimulationStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type ReadSimulationStatusQuery = (
  { __typename?: 'Queries' }
  & Pick<Queries, 'simulationStatus'>
);

export type RegisteredUserQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisteredUserQuery = (
  { __typename?: 'Queries' }
  & { registeredUsers?: Maybe<Array<Maybe<(
    { __typename?: 'UserOutput' }
    & Pick<UserOutput, 'username' | 'superuser'>
  )>>> }
);

export const AuthTokenFieldsFragmentDoc = gql`
    fragment AuthTokenFields on AuthToken {
  email
  isAdmin
  userRole
  token
  username
  isSuperuser: isAdmin
  userRole
}
    `;
export const SettingsDataFieldsFragmentDoc = gql`
    fragment SettingsDataFields on SettingsOutput {
  slotLengthMinutes
  tickLengthSeconds
  marketCount
  slotLengthRealtimeSeconds
  cloudCoverage
  pvUserProfile
  startDate
  endDate
  spotMarketType
  bidOfferMatchAlgo
  gridFeeType
  currency
}
    `;
export const ConfigurationFieldsFragmentDoc = gql`
    fragment ConfigurationFields on ConfigurationOutput {
  uuid
  name
  description
  readOnly
  simulationResults
  resultsStatus
  timestamp
  warnings
  areaSummary {
    configuredAreas
    configuredDevices
  }
  scenarioData {
    latest {
      serialized
      uuid
    }
  }
  settingsData {
    ...SettingsDataFields
  }
  project {
    uuid
    name
    user
  }
  configType: type
  user
  openForExternalApplications
  private
}
    ${SettingsDataFieldsFragmentDoc}`;
export const ConfirmEmailDocument = gql`
    mutation confirmEmail($confirmKey: String!) {
  confirmEmail(confirmKey: $confirmKey)
}
    `;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      confirmKey: // value for 'confirmKey'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, baseOptions);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const ConfirmPasswordResetDocument = gql`
    mutation confirmPasswordReset($uid: String!, $key: String!, $password: String!, $passwordRepeat: String!) {
  confirmPasswordReset(
    uid: $uid
    key: $key
    password: $password
    passwordRepeat: $passwordRepeat
  )
}
    `;
export type ConfirmPasswordResetMutationFn = Apollo.MutationFunction<ConfirmPasswordResetMutation, ConfirmPasswordResetMutationVariables>;

/**
 * __useConfirmPasswordResetMutation__
 *
 * To run a mutation, you first call `useConfirmPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPasswordResetMutation, { data, loading, error }] = useConfirmPasswordResetMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      key: // value for 'key'
 *      password: // value for 'password'
 *      passwordRepeat: // value for 'passwordRepeat'
 *   },
 * });
 */
export function useConfirmPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPasswordResetMutation, ConfirmPasswordResetMutationVariables>) {
        return Apollo.useMutation<ConfirmPasswordResetMutation, ConfirmPasswordResetMutationVariables>(ConfirmPasswordResetDocument, baseOptions);
      }
export type ConfirmPasswordResetMutationHookResult = ReturnType<typeof useConfirmPasswordResetMutation>;
export type ConfirmPasswordResetMutationResult = Apollo.MutationResult<ConfirmPasswordResetMutation>;
export type ConfirmPasswordResetMutationOptions = Apollo.BaseMutationOptions<ConfirmPasswordResetMutation, ConfirmPasswordResetMutationVariables>;
export const SetUserRoleDocument = gql`
    mutation setUserRole($email: String!, $role: Int!) {
  setUserRole(email: $email, userRoleInt: $role) {
    roleName
    value
  }
}
    `;
export type SetUserRoleMutationFn = Apollo.MutationFunction<SetUserRoleMutation, SetUserRoleMutationVariables>;

/**
 * __useSetUserRoleMutation__
 *
 * To run a mutation, you first call `useSetUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleMutation, { data, loading, error }] = useSetUserRoleMutation({
 *   variables: {
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRoleMutation, SetUserRoleMutationVariables>) {
        return Apollo.useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument, baseOptions);
      }
export type SetUserRoleMutationHookResult = ReturnType<typeof useSetUserRoleMutation>;
export type SetUserRoleMutationResult = Apollo.MutationResult<SetUserRoleMutation>;
export type SetUserRoleMutationOptions = Apollo.BaseMutationOptions<SetUserRoleMutation, SetUserRoleMutationVariables>;
export const SignupDocument = gql`
    mutation signup($email: String!, $name: String!, $organisation: String!, $password: String!, $passwordRepeat: String, $username: String, $interest: String) {
  registerUser(
    email: $email
    name: $name
    organisation: $organisation
    password: $password
    passwordRepeat: $passwordRepeat
    username: $username
    interest: $interest
  ) {
    response
    message
    authToken {
      ...AuthTokenFields
    }
  }
}
    ${AuthTokenFieldsFragmentDoc}`;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      organisation: // value for 'organisation'
 *      password: // value for 'password'
 *      passwordRepeat: // value for 'passwordRepeat'
 *      username: // value for 'username'
 *      interest: // value for 'interest'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, baseOptions);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const TokenAuthDocument = gql`
    mutation tokenAuth($username: String!, $password: String!) {
  tokenAuth(username: $username, password: $password) {
    ...AuthTokenFields
  }
}
    ${AuthTokenFieldsFragmentDoc}`;
export type TokenAuthMutationFn = Apollo.MutationFunction<TokenAuthMutation, TokenAuthMutationVariables>;

/**
 * __useTokenAuthMutation__
 *
 * To run a mutation, you first call `useTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenAuthMutation, { data, loading, error }] = useTokenAuthMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useTokenAuthMutation(baseOptions?: Apollo.MutationHookOptions<TokenAuthMutation, TokenAuthMutationVariables>) {
        return Apollo.useMutation<TokenAuthMutation, TokenAuthMutationVariables>(TokenAuthDocument, baseOptions);
      }
export type TokenAuthMutationHookResult = ReturnType<typeof useTokenAuthMutation>;
export type TokenAuthMutationResult = Apollo.MutationResult<TokenAuthMutation>;
export type TokenAuthMutationOptions = Apollo.BaseMutationOptions<TokenAuthMutation, TokenAuthMutationVariables>;
export const TokenRefreshDocument = gql`
    mutation tokenRefresh($token: String!) {
  tokenRefresh(token: $token) {
    token
  }
}
    `;
export type TokenRefreshMutationFn = Apollo.MutationFunction<TokenRefreshMutation, TokenRefreshMutationVariables>;

/**
 * __useTokenRefreshMutation__
 *
 * To run a mutation, you first call `useTokenRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenRefreshMutation, { data, loading, error }] = useTokenRefreshMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useTokenRefreshMutation(baseOptions?: Apollo.MutationHookOptions<TokenRefreshMutation, TokenRefreshMutationVariables>) {
        return Apollo.useMutation<TokenRefreshMutation, TokenRefreshMutationVariables>(TokenRefreshDocument, baseOptions);
      }
export type TokenRefreshMutationHookResult = ReturnType<typeof useTokenRefreshMutation>;
export type TokenRefreshMutationResult = Apollo.MutationResult<TokenRefreshMutation>;
export type TokenRefreshMutationOptions = Apollo.BaseMutationOptions<TokenRefreshMutation, TokenRefreshMutationVariables>;
export const TokenVerifyDocument = gql`
    mutation tokenVerify($token: String!) {
  tokenVerify(token: $token) {
    payload
  }
}
    `;
export type TokenVerifyMutationFn = Apollo.MutationFunction<TokenVerifyMutation, TokenVerifyMutationVariables>;

/**
 * __useTokenVerifyMutation__
 *
 * To run a mutation, you first call `useTokenVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenVerifyMutation, { data, loading, error }] = useTokenVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useTokenVerifyMutation(baseOptions?: Apollo.MutationHookOptions<TokenVerifyMutation, TokenVerifyMutationVariables>) {
        return Apollo.useMutation<TokenVerifyMutation, TokenVerifyMutationVariables>(TokenVerifyDocument, baseOptions);
      }
export type TokenVerifyMutationHookResult = ReturnType<typeof useTokenVerifyMutation>;
export type TokenVerifyMutationResult = Apollo.MutationResult<TokenVerifyMutation>;
export type TokenVerifyMutationOptions = Apollo.BaseMutationOptions<TokenVerifyMutation, TokenVerifyMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($interest: String, $interestedInCn: Boolean, $organisation: String, $password: String, $passwordRepeat: String) {
  updateUser(
    interest: $interest
    interestedInCn: $interestedInCn
    organisation: $organisation
    password: $password
    passwordRepeat: $passwordRepeat
  ) {
    organisation
    interest
    interestedInCn
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      interest: // value for 'interest'
 *      interestedInCn: // value for 'interestedInCn'
 *      organisation: // value for 'organisation'
 *      password: // value for 'password'
 *      passwordRepeat: // value for 'passwordRepeat'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DuplicateCanaryNetworkDocument = gql`
    mutation duplicateCanaryNetwork($name: String!, $description: String!, $uuid: String!, $incorporateLiveEvents: Boolean) {
  duplicateCanaryNetwork(
    name: $name
    description: $description
    uuid: $uuid
    incorporateLiveEvents: $incorporateLiveEvents
  ) {
    name
    uuid
    description
    user
    simulationResults
    project {
      uuid
    }
    configType: type
    scenarioData {
      representation {
        serialized
      }
    }
  }
}
    `;
export type DuplicateCanaryNetworkMutationFn = Apollo.MutationFunction<DuplicateCanaryNetworkMutation, DuplicateCanaryNetworkMutationVariables>;

/**
 * __useDuplicateCanaryNetworkMutation__
 *
 * To run a mutation, you first call `useDuplicateCanaryNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCanaryNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCanaryNetworkMutation, { data, loading, error }] = useDuplicateCanaryNetworkMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      uuid: // value for 'uuid'
 *      incorporateLiveEvents: // value for 'incorporateLiveEvents'
 *   },
 * });
 */
export function useDuplicateCanaryNetworkMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCanaryNetworkMutation, DuplicateCanaryNetworkMutationVariables>) {
        return Apollo.useMutation<DuplicateCanaryNetworkMutation, DuplicateCanaryNetworkMutationVariables>(DuplicateCanaryNetworkDocument, baseOptions);
      }
export type DuplicateCanaryNetworkMutationHookResult = ReturnType<typeof useDuplicateCanaryNetworkMutation>;
export type DuplicateCanaryNetworkMutationResult = Apollo.MutationResult<DuplicateCanaryNetworkMutation>;
export type DuplicateCanaryNetworkMutationOptions = Apollo.BaseMutationOptions<DuplicateCanaryNetworkMutation, DuplicateCanaryNetworkMutationVariables>;
export const BatchRegisterExternalConnectionDocument = gql`
    mutation batchRegisterExternalConnection($configUuid: String!, $applicationMapping: [AreaUuidApplyMapping]) {
  batchRegisterExternalConnection(
    configUuid: $configUuid
    applicationMapping: $applicationMapping
  ) {
    response
    message
  }
}
    `;
export type BatchRegisterExternalConnectionMutationFn = Apollo.MutationFunction<BatchRegisterExternalConnectionMutation, BatchRegisterExternalConnectionMutationVariables>;

/**
 * __useBatchRegisterExternalConnectionMutation__
 *
 * To run a mutation, you first call `useBatchRegisterExternalConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchRegisterExternalConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchRegisterExternalConnectionMutation, { data, loading, error }] = useBatchRegisterExternalConnectionMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *      applicationMapping: // value for 'applicationMapping'
 *   },
 * });
 */
export function useBatchRegisterExternalConnectionMutation(baseOptions?: Apollo.MutationHookOptions<BatchRegisterExternalConnectionMutation, BatchRegisterExternalConnectionMutationVariables>) {
        return Apollo.useMutation<BatchRegisterExternalConnectionMutation, BatchRegisterExternalConnectionMutationVariables>(BatchRegisterExternalConnectionDocument, baseOptions);
      }
export type BatchRegisterExternalConnectionMutationHookResult = ReturnType<typeof useBatchRegisterExternalConnectionMutation>;
export type BatchRegisterExternalConnectionMutationResult = Apollo.MutationResult<BatchRegisterExternalConnectionMutation>;
export type BatchRegisterExternalConnectionMutationOptions = Apollo.BaseMutationOptions<BatchRegisterExternalConnectionMutation, BatchRegisterExternalConnectionMutationVariables>;
export const BatchResponseExternalConnectionRequestDocument = gql`
    mutation batchResponseExternalConnectionRequest($configUuid: String!, $responseList: [InputRespondExternalConnectionRequest]) {
  batchResponseExternalConnectionRequest(
    configUuid: $configUuid
    responseList: $responseList
  )
}
    `;
export type BatchResponseExternalConnectionRequestMutationFn = Apollo.MutationFunction<BatchResponseExternalConnectionRequestMutation, BatchResponseExternalConnectionRequestMutationVariables>;

/**
 * __useBatchResponseExternalConnectionRequestMutation__
 *
 * To run a mutation, you first call `useBatchResponseExternalConnectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchResponseExternalConnectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchResponseExternalConnectionRequestMutation, { data, loading, error }] = useBatchResponseExternalConnectionRequestMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *      responseList: // value for 'responseList'
 *   },
 * });
 */
export function useBatchResponseExternalConnectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<BatchResponseExternalConnectionRequestMutation, BatchResponseExternalConnectionRequestMutationVariables>) {
        return Apollo.useMutation<BatchResponseExternalConnectionRequestMutation, BatchResponseExternalConnectionRequestMutationVariables>(BatchResponseExternalConnectionRequestDocument, baseOptions);
      }
export type BatchResponseExternalConnectionRequestMutationHookResult = ReturnType<typeof useBatchResponseExternalConnectionRequestMutation>;
export type BatchResponseExternalConnectionRequestMutationResult = Apollo.MutationResult<BatchResponseExternalConnectionRequestMutation>;
export type BatchResponseExternalConnectionRequestMutationOptions = Apollo.BaseMutationOptions<BatchResponseExternalConnectionRequestMutation, BatchResponseExternalConnectionRequestMutationVariables>;
export const CreateCanaryNetworkDocument = gql`
    mutation createCanaryNetwork($description: String, $name: String!, $private: Boolean, $uuid: String!) {
  moveCollaborationToCanaryNetwork(
    name: $name
    description: $description
    uuid: $uuid
    private: $private
  ) {
    name
    uuid
    type
  }
}
    `;
export type CreateCanaryNetworkMutationFn = Apollo.MutationFunction<CreateCanaryNetworkMutation, CreateCanaryNetworkMutationVariables>;

/**
 * __useCreateCanaryNetworkMutation__
 *
 * To run a mutation, you first call `useCreateCanaryNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCanaryNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCanaryNetworkMutation, { data, loading, error }] = useCreateCanaryNetworkMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      private: // value for 'private'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCreateCanaryNetworkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCanaryNetworkMutation, CreateCanaryNetworkMutationVariables>) {
        return Apollo.useMutation<CreateCanaryNetworkMutation, CreateCanaryNetworkMutationVariables>(CreateCanaryNetworkDocument, baseOptions);
      }
export type CreateCanaryNetworkMutationHookResult = ReturnType<typeof useCreateCanaryNetworkMutation>;
export type CreateCanaryNetworkMutationResult = Apollo.MutationResult<CreateCanaryNetworkMutation>;
export type CreateCanaryNetworkMutationOptions = Apollo.BaseMutationOptions<CreateCanaryNetworkMutation, CreateCanaryNetworkMutationVariables>;
export const DuplicateCollaborationDocument = gql`
    mutation duplicateCollaboration($name: String!, $description: String!, $uuid: String!, $incorporateLiveEvents: Boolean) {
  duplicateCollaboration(
    name: $name
    description: $description
    uuid: $uuid
    incorporateLiveEvents: $incorporateLiveEvents
  ) {
    name
    uuid
    description
    user
    simulationResults
    project {
      uuid
    }
    configType: type
    scenarioData {
      representation {
        serialized
      }
    }
  }
}
    `;
export type DuplicateCollaborationMutationFn = Apollo.MutationFunction<DuplicateCollaborationMutation, DuplicateCollaborationMutationVariables>;

/**
 * __useDuplicateCollaborationMutation__
 *
 * To run a mutation, you first call `useDuplicateCollaborationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCollaborationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCollaborationMutation, { data, loading, error }] = useDuplicateCollaborationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      uuid: // value for 'uuid'
 *      incorporateLiveEvents: // value for 'incorporateLiveEvents'
 *   },
 * });
 */
export function useDuplicateCollaborationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCollaborationMutation, DuplicateCollaborationMutationVariables>) {
        return Apollo.useMutation<DuplicateCollaborationMutation, DuplicateCollaborationMutationVariables>(DuplicateCollaborationDocument, baseOptions);
      }
export type DuplicateCollaborationMutationHookResult = ReturnType<typeof useDuplicateCollaborationMutation>;
export type DuplicateCollaborationMutationResult = Apollo.MutationResult<DuplicateCollaborationMutation>;
export type DuplicateCollaborationMutationOptions = Apollo.BaseMutationOptions<DuplicateCollaborationMutation, DuplicateCollaborationMutationVariables>;
export const RegExternalConnectionDocument = gql`
    mutation regExternalConnection($areaUuid: String!, $configUuid: String!, $apply: Boolean!) {
  registerExternalConnection(
    areaUuid: $areaUuid
    configUuid: $configUuid
    apply: $apply
  ) {
    response
    message
  }
}
    `;
export type RegExternalConnectionMutationFn = Apollo.MutationFunction<RegExternalConnectionMutation, RegExternalConnectionMutationVariables>;

/**
 * __useRegExternalConnectionMutation__
 *
 * To run a mutation, you first call `useRegExternalConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegExternalConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regExternalConnectionMutation, { data, loading, error }] = useRegExternalConnectionMutation({
 *   variables: {
 *      areaUuid: // value for 'areaUuid'
 *      configUuid: // value for 'configUuid'
 *      apply: // value for 'apply'
 *   },
 * });
 */
export function useRegExternalConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RegExternalConnectionMutation, RegExternalConnectionMutationVariables>) {
        return Apollo.useMutation<RegExternalConnectionMutation, RegExternalConnectionMutationVariables>(RegExternalConnectionDocument, baseOptions);
      }
export type RegExternalConnectionMutationHookResult = ReturnType<typeof useRegExternalConnectionMutation>;
export type RegExternalConnectionMutationResult = Apollo.MutationResult<RegExternalConnectionMutation>;
export type RegExternalConnectionMutationOptions = Apollo.BaseMutationOptions<RegExternalConnectionMutation, RegExternalConnectionMutationVariables>;
export const RegGridConnectionDocument = gql`
    mutation regGridConnection($configUuid: String!, $areaUuid: String!, $apply: Boolean!) {
  registerGridConnection(
    configUuid: $configUuid
    areaUuid: $areaUuid
    apply: $apply
  ) {
    response
    message
  }
}
    `;
export type RegGridConnectionMutationFn = Apollo.MutationFunction<RegGridConnectionMutation, RegGridConnectionMutationVariables>;

/**
 * __useRegGridConnectionMutation__
 *
 * To run a mutation, you first call `useRegGridConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegGridConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regGridConnectionMutation, { data, loading, error }] = useRegGridConnectionMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *      areaUuid: // value for 'areaUuid'
 *      apply: // value for 'apply'
 *   },
 * });
 */
export function useRegGridConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RegGridConnectionMutation, RegGridConnectionMutationVariables>) {
        return Apollo.useMutation<RegGridConnectionMutation, RegGridConnectionMutationVariables>(RegGridConnectionDocument, baseOptions);
      }
export type RegGridConnectionMutationHookResult = ReturnType<typeof useRegGridConnectionMutation>;
export type RegGridConnectionMutationResult = Apollo.MutationResult<RegGridConnectionMutation>;
export type RegGridConnectionMutationOptions = Apollo.BaseMutationOptions<RegGridConnectionMutation, RegGridConnectionMutationVariables>;
export const RegisterCollaborationDocument = gql`
    mutation registerCollaboration($configUuid: String!) {
  registerCollaboration(
    configUuid: $configUuid
    openForExternalApplications: true
  )
}
    `;
export type RegisterCollaborationMutationFn = Apollo.MutationFunction<RegisterCollaborationMutation, RegisterCollaborationMutationVariables>;

/**
 * __useRegisterCollaborationMutation__
 *
 * To run a mutation, you first call `useRegisterCollaborationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCollaborationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCollaborationMutation, { data, loading, error }] = useRegisterCollaborationMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *   },
 * });
 */
export function useRegisterCollaborationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterCollaborationMutation, RegisterCollaborationMutationVariables>) {
        return Apollo.useMutation<RegisterCollaborationMutation, RegisterCollaborationMutationVariables>(RegisterCollaborationDocument, baseOptions);
      }
export type RegisterCollaborationMutationHookResult = ReturnType<typeof useRegisterCollaborationMutation>;
export type RegisterCollaborationMutationResult = Apollo.MutationResult<RegisterCollaborationMutation>;
export type RegisterCollaborationMutationOptions = Apollo.BaseMutationOptions<RegisterCollaborationMutation, RegisterCollaborationMutationVariables>;
export const RespondExternalConnectionRequestDocument = gql`
    mutation respondExternalConnectionRequest($username: String!, $areaUuid: String!, $configUuid: String!, $accept: Boolean!) {
  respondExternalConnectionRequest(
    username: $username
    areaUuid: $areaUuid
    configUuid: $configUuid
    accept: $accept
  )
}
    `;
export type RespondExternalConnectionRequestMutationFn = Apollo.MutationFunction<RespondExternalConnectionRequestMutation, RespondExternalConnectionRequestMutationVariables>;

/**
 * __useRespondExternalConnectionRequestMutation__
 *
 * To run a mutation, you first call `useRespondExternalConnectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondExternalConnectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondExternalConnectionRequestMutation, { data, loading, error }] = useRespondExternalConnectionRequestMutation({
 *   variables: {
 *      username: // value for 'username'
 *      areaUuid: // value for 'areaUuid'
 *      configUuid: // value for 'configUuid'
 *      accept: // value for 'accept'
 *   },
 * });
 */
export function useRespondExternalConnectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<RespondExternalConnectionRequestMutation, RespondExternalConnectionRequestMutationVariables>) {
        return Apollo.useMutation<RespondExternalConnectionRequestMutation, RespondExternalConnectionRequestMutationVariables>(RespondExternalConnectionRequestDocument, baseOptions);
      }
export type RespondExternalConnectionRequestMutationHookResult = ReturnType<typeof useRespondExternalConnectionRequestMutation>;
export type RespondExternalConnectionRequestMutationResult = Apollo.MutationResult<RespondExternalConnectionRequestMutation>;
export type RespondExternalConnectionRequestMutationOptions = Apollo.BaseMutationOptions<RespondExternalConnectionRequestMutation, RespondExternalConnectionRequestMutationVariables>;
export const CreateConfigurationDocument = gql`
    mutation createConfiguration($name: String, $description: String, $projectUuid: String!, $settingsData: SettingsInput, $scenarioData: ScenarioInput) {
  createConfiguration(
    name: $name
    description: $description
    projectUUID: $projectUuid
    settingsData: $settingsData
    scenarioData: $scenarioData
  ) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type CreateConfigurationMutationFn = Apollo.MutationFunction<CreateConfigurationMutation, CreateConfigurationMutationVariables>;

/**
 * __useCreateConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConfigurationMutation, { data, loading, error }] = useCreateConfigurationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      projectUuid: // value for 'projectUuid'
 *      settingsData: // value for 'settingsData'
 *      scenarioData: // value for 'scenarioData'
 *   },
 * });
 */
export function useCreateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConfigurationMutation, CreateConfigurationMutationVariables>) {
        return Apollo.useMutation<CreateConfigurationMutation, CreateConfigurationMutationVariables>(CreateConfigurationDocument, baseOptions);
      }
export type CreateConfigurationMutationHookResult = ReturnType<typeof useCreateConfigurationMutation>;
export type CreateConfigurationMutationResult = Apollo.MutationResult<CreateConfigurationMutation>;
export type CreateConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateConfigurationMutation, CreateConfigurationMutationVariables>;
export const CreateConfigurationAreaDocument = gql`
    mutation createConfigurationArea($configurationUuid: String!, $parentUuid: String!, $areaRepresentation: AreaInput!) {
  createConfigurationArea(
    configUuid: $configurationUuid
    parentUuid: $parentUuid
    areaRepresentation: $areaRepresentation
  ) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type CreateConfigurationAreaMutationFn = Apollo.MutationFunction<CreateConfigurationAreaMutation, CreateConfigurationAreaMutationVariables>;

/**
 * __useCreateConfigurationAreaMutation__
 *
 * To run a mutation, you first call `useCreateConfigurationAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConfigurationAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConfigurationAreaMutation, { data, loading, error }] = useCreateConfigurationAreaMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      parentUuid: // value for 'parentUuid'
 *      areaRepresentation: // value for 'areaRepresentation'
 *   },
 * });
 */
export function useCreateConfigurationAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateConfigurationAreaMutation, CreateConfigurationAreaMutationVariables>) {
        return Apollo.useMutation<CreateConfigurationAreaMutation, CreateConfigurationAreaMutationVariables>(CreateConfigurationAreaDocument, baseOptions);
      }
export type CreateConfigurationAreaMutationHookResult = ReturnType<typeof useCreateConfigurationAreaMutation>;
export type CreateConfigurationAreaMutationResult = Apollo.MutationResult<CreateConfigurationAreaMutation>;
export type CreateConfigurationAreaMutationOptions = Apollo.BaseMutationOptions<CreateConfigurationAreaMutation, CreateConfigurationAreaMutationVariables>;
export const DeleteConfigurationDocument = gql`
    mutation deleteConfiguration($configurationUuid: String!) {
  deleteConfiguration(uuid: $configurationUuid)
}
    `;
export type DeleteConfigurationMutationFn = Apollo.MutationFunction<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>;

/**
 * __useDeleteConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConfigurationMutation, { data, loading, error }] = useDeleteConfigurationMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *   },
 * });
 */
export function useDeleteConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>) {
        return Apollo.useMutation<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>(DeleteConfigurationDocument, baseOptions);
      }
export type DeleteConfigurationMutationHookResult = ReturnType<typeof useDeleteConfigurationMutation>;
export type DeleteConfigurationMutationResult = Apollo.MutationResult<DeleteConfigurationMutation>;
export type DeleteConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteConfigurationMutation, DeleteConfigurationMutationVariables>;
export const DuplicateConfigurationDocument = gql`
    mutation duplicateConfiguration($name: String!, $description: String!, $configurationUuid: String!, $incorporateLiveEvents: Boolean) {
  duplicateConfiguration(
    name: $name
    description: $description
    uuid: $configurationUuid
    incorporateLiveEvents: $incorporateLiveEvents
  ) {
    name
    uuid
    description
    user
    simulationResults
    project {
      uuid
    }
    scenarioData {
      representation {
        serialized
      }
    }
  }
}
    `;
export type DuplicateConfigurationMutationFn = Apollo.MutationFunction<DuplicateConfigurationMutation, DuplicateConfigurationMutationVariables>;

/**
 * __useDuplicateConfigurationMutation__
 *
 * To run a mutation, you first call `useDuplicateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateConfigurationMutation, { data, loading, error }] = useDuplicateConfigurationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      configurationUuid: // value for 'configurationUuid'
 *      incorporateLiveEvents: // value for 'incorporateLiveEvents'
 *   },
 * });
 */
export function useDuplicateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateConfigurationMutation, DuplicateConfigurationMutationVariables>) {
        return Apollo.useMutation<DuplicateConfigurationMutation, DuplicateConfigurationMutationVariables>(DuplicateConfigurationDocument, baseOptions);
      }
export type DuplicateConfigurationMutationHookResult = ReturnType<typeof useDuplicateConfigurationMutation>;
export type DuplicateConfigurationMutationResult = Apollo.MutationResult<DuplicateConfigurationMutation>;
export type DuplicateConfigurationMutationOptions = Apollo.BaseMutationOptions<DuplicateConfigurationMutation, DuplicateConfigurationMutationVariables>;
export const MoveConfigurationToCollaborationDocument = gql`
    mutation moveConfigurationToCollaboration($configurationUuid: String!, $name: String!, $description: String) {
  moveConfigurationToCollaboration(
    uuid: $configurationUuid
    name: $name
    description: $description
  ) {
    name
    uuid
    simulationResults
    description
    user
    timestamp
    readOnly
    warnings
    configType: type
    project {
      uuid
    }
    scenarioData {
      representation {
        serialized
      }
    }
  }
}
    `;
export type MoveConfigurationToCollaborationMutationFn = Apollo.MutationFunction<MoveConfigurationToCollaborationMutation, MoveConfigurationToCollaborationMutationVariables>;

/**
 * __useMoveConfigurationToCollaborationMutation__
 *
 * To run a mutation, you first call `useMoveConfigurationToCollaborationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveConfigurationToCollaborationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveConfigurationToCollaborationMutation, { data, loading, error }] = useMoveConfigurationToCollaborationMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useMoveConfigurationToCollaborationMutation(baseOptions?: Apollo.MutationHookOptions<MoveConfigurationToCollaborationMutation, MoveConfigurationToCollaborationMutationVariables>) {
        return Apollo.useMutation<MoveConfigurationToCollaborationMutation, MoveConfigurationToCollaborationMutationVariables>(MoveConfigurationToCollaborationDocument, baseOptions);
      }
export type MoveConfigurationToCollaborationMutationHookResult = ReturnType<typeof useMoveConfigurationToCollaborationMutation>;
export type MoveConfigurationToCollaborationMutationResult = Apollo.MutationResult<MoveConfigurationToCollaborationMutation>;
export type MoveConfigurationToCollaborationMutationOptions = Apollo.BaseMutationOptions<MoveConfigurationToCollaborationMutation, MoveConfigurationToCollaborationMutationVariables>;
export const PartialUpdateConfigurationDocument = gql`
    mutation partialUpdateConfiguration($configurationUuid: String!, $partialScenario: AreaInput!) {
  partialUpdateConfiguration(
    uuid: $configurationUuid
    partialScenario: $partialScenario
  ) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type PartialUpdateConfigurationMutationFn = Apollo.MutationFunction<PartialUpdateConfigurationMutation, PartialUpdateConfigurationMutationVariables>;

/**
 * __usePartialUpdateConfigurationMutation__
 *
 * To run a mutation, you first call `usePartialUpdateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartialUpdateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partialUpdateConfigurationMutation, { data, loading, error }] = usePartialUpdateConfigurationMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      partialScenario: // value for 'partialScenario'
 *   },
 * });
 */
export function usePartialUpdateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<PartialUpdateConfigurationMutation, PartialUpdateConfigurationMutationVariables>) {
        return Apollo.useMutation<PartialUpdateConfigurationMutation, PartialUpdateConfigurationMutationVariables>(PartialUpdateConfigurationDocument, baseOptions);
      }
export type PartialUpdateConfigurationMutationHookResult = ReturnType<typeof usePartialUpdateConfigurationMutation>;
export type PartialUpdateConfigurationMutationResult = Apollo.MutationResult<PartialUpdateConfigurationMutation>;
export type PartialUpdateConfigurationMutationOptions = Apollo.BaseMutationOptions<PartialUpdateConfigurationMutation, PartialUpdateConfigurationMutationVariables>;
export const RemoveConfigurationAreaDocument = gql`
    mutation removeConfigurationArea($configurationUuid: String!, $areaUuid: String!) {
  removeConfigurationArea(configUuid: $configurationUuid, areaUuid: $areaUuid) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type RemoveConfigurationAreaMutationFn = Apollo.MutationFunction<RemoveConfigurationAreaMutation, RemoveConfigurationAreaMutationVariables>;

/**
 * __useRemoveConfigurationAreaMutation__
 *
 * To run a mutation, you first call `useRemoveConfigurationAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConfigurationAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConfigurationAreaMutation, { data, loading, error }] = useRemoveConfigurationAreaMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      areaUuid: // value for 'areaUuid'
 *   },
 * });
 */
export function useRemoveConfigurationAreaMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConfigurationAreaMutation, RemoveConfigurationAreaMutationVariables>) {
        return Apollo.useMutation<RemoveConfigurationAreaMutation, RemoveConfigurationAreaMutationVariables>(RemoveConfigurationAreaDocument, baseOptions);
      }
export type RemoveConfigurationAreaMutationHookResult = ReturnType<typeof useRemoveConfigurationAreaMutation>;
export type RemoveConfigurationAreaMutationResult = Apollo.MutationResult<RemoveConfigurationAreaMutation>;
export type RemoveConfigurationAreaMutationOptions = Apollo.BaseMutationOptions<RemoveConfigurationAreaMutation, RemoveConfigurationAreaMutationVariables>;
export const UpdateConfigurationDocument = gql`
    mutation updateConfiguration($name: String, $description: String, $configurationUuid: String!, $projectUuid: String!, $settingsData: SettingsInput, $scenarioData: ScenarioInput) {
  updateConfiguration(
    uuid: $configurationUuid
    name: $name
    description: $description
    projectUUID: $projectUuid
    settingsData: $settingsData
    scenarioData: $scenarioData
  ) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type UpdateConfigurationMutationFn = Apollo.MutationFunction<UpdateConfigurationMutation, UpdateConfigurationMutationVariables>;

/**
 * __useUpdateConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigurationMutation, { data, loading, error }] = useUpdateConfigurationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      configurationUuid: // value for 'configurationUuid'
 *      projectUuid: // value for 'projectUuid'
 *      settingsData: // value for 'settingsData'
 *      scenarioData: // value for 'scenarioData'
 *   },
 * });
 */
export function useUpdateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfigurationMutation, UpdateConfigurationMutationVariables>) {
        return Apollo.useMutation<UpdateConfigurationMutation, UpdateConfigurationMutationVariables>(UpdateConfigurationDocument, baseOptions);
      }
export type UpdateConfigurationMutationHookResult = ReturnType<typeof useUpdateConfigurationMutation>;
export type UpdateConfigurationMutationResult = Apollo.MutationResult<UpdateConfigurationMutation>;
export type UpdateConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateConfigurationMutation, UpdateConfigurationMutationVariables>;
export const UpdateConfigurationAreaDocument = gql`
    mutation updateConfigurationArea($configurationUuid: String!, $areaUuid: String!, $areaParams: AreaInput!) {
  updateConfigurationArea(
    configUuid: $configurationUuid
    areaUuid: $areaUuid
    areaParams: $areaParams
  ) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type UpdateConfigurationAreaMutationFn = Apollo.MutationFunction<UpdateConfigurationAreaMutation, UpdateConfigurationAreaMutationVariables>;

/**
 * __useUpdateConfigurationAreaMutation__
 *
 * To run a mutation, you first call `useUpdateConfigurationAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigurationAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigurationAreaMutation, { data, loading, error }] = useUpdateConfigurationAreaMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      areaUuid: // value for 'areaUuid'
 *      areaParams: // value for 'areaParams'
 *   },
 * });
 */
export function useUpdateConfigurationAreaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfigurationAreaMutation, UpdateConfigurationAreaMutationVariables>) {
        return Apollo.useMutation<UpdateConfigurationAreaMutation, UpdateConfigurationAreaMutationVariables>(UpdateConfigurationAreaDocument, baseOptions);
      }
export type UpdateConfigurationAreaMutationHookResult = ReturnType<typeof useUpdateConfigurationAreaMutation>;
export type UpdateConfigurationAreaMutationResult = Apollo.MutationResult<UpdateConfigurationAreaMutation>;
export type UpdateConfigurationAreaMutationOptions = Apollo.BaseMutationOptions<UpdateConfigurationAreaMutation, UpdateConfigurationAreaMutationVariables>;
export const UpdateConfigurationTreeDocument = gql`
    mutation updateConfigurationTree($configurationUuid: String!, $scenarioData: ScenarioInput!) {
  updateConfiguration(uuid: $configurationUuid, scenarioData: $scenarioData) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type UpdateConfigurationTreeMutationFn = Apollo.MutationFunction<UpdateConfigurationTreeMutation, UpdateConfigurationTreeMutationVariables>;

/**
 * __useUpdateConfigurationTreeMutation__
 *
 * To run a mutation, you first call `useUpdateConfigurationTreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigurationTreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigurationTreeMutation, { data, loading, error }] = useUpdateConfigurationTreeMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      scenarioData: // value for 'scenarioData'
 *   },
 * });
 */
export function useUpdateConfigurationTreeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfigurationTreeMutation, UpdateConfigurationTreeMutationVariables>) {
        return Apollo.useMutation<UpdateConfigurationTreeMutation, UpdateConfigurationTreeMutationVariables>(UpdateConfigurationTreeDocument, baseOptions);
      }
export type UpdateConfigurationTreeMutationHookResult = ReturnType<typeof useUpdateConfigurationTreeMutation>;
export type UpdateConfigurationTreeMutationResult = Apollo.MutationResult<UpdateConfigurationTreeMutation>;
export type UpdateConfigurationTreeMutationOptions = Apollo.BaseMutationOptions<UpdateConfigurationTreeMutation, UpdateConfigurationTreeMutationVariables>;
export const UserContactFormDocument = gql`
    mutation userContactForm($firstName: String, $lastName: String, $email: String, $message: String) {
  userContactForm(
    firstName: $firstName
    lastName: $lastName
    email: $email
    message: $message
  )
}
    `;
export type UserContactFormMutationFn = Apollo.MutationFunction<UserContactFormMutation, UserContactFormMutationVariables>;

/**
 * __useUserContactFormMutation__
 *
 * To run a mutation, you first call `useUserContactFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserContactFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userContactFormMutation, { data, loading, error }] = useUserContactFormMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUserContactFormMutation(baseOptions?: Apollo.MutationHookOptions<UserContactFormMutation, UserContactFormMutationVariables>) {
        return Apollo.useMutation<UserContactFormMutation, UserContactFormMutationVariables>(UserContactFormDocument, baseOptions);
      }
export type UserContactFormMutationHookResult = ReturnType<typeof useUserContactFormMutation>;
export type UserContactFormMutationResult = Apollo.MutationResult<UserContactFormMutation>;
export type UserContactFormMutationOptions = Apollo.BaseMutationOptions<UserContactFormMutation, UserContactFormMutationVariables>;
export const DeleteGlobalSimulationLocationDocument = gql`
    mutation deleteGlobalSimulationLocation($configUuid: String!) {
  deleteGlobalSimulationLocation(configUuid: $configUuid)
}
    `;
export type DeleteGlobalSimulationLocationMutationFn = Apollo.MutationFunction<DeleteGlobalSimulationLocationMutation, DeleteGlobalSimulationLocationMutationVariables>;

/**
 * __useDeleteGlobalSimulationLocationMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalSimulationLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalSimulationLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalSimulationLocationMutation, { data, loading, error }] = useDeleteGlobalSimulationLocationMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *   },
 * });
 */
export function useDeleteGlobalSimulationLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGlobalSimulationLocationMutation, DeleteGlobalSimulationLocationMutationVariables>) {
        return Apollo.useMutation<DeleteGlobalSimulationLocationMutation, DeleteGlobalSimulationLocationMutationVariables>(DeleteGlobalSimulationLocationDocument, baseOptions);
      }
export type DeleteGlobalSimulationLocationMutationHookResult = ReturnType<typeof useDeleteGlobalSimulationLocationMutation>;
export type DeleteGlobalSimulationLocationMutationResult = Apollo.MutationResult<DeleteGlobalSimulationLocationMutation>;
export type DeleteGlobalSimulationLocationMutationOptions = Apollo.BaseMutationOptions<DeleteGlobalSimulationLocationMutation, DeleteGlobalSimulationLocationMutationVariables>;
export const SetGlobalSimulationLocationDocument = gql`
    mutation setGlobalSimulationLocation($configUuid: String!, $centreCoordinates: Position, $boundaryId: String!, $visibility: Boolean!) {
  setGlobalSimulationLocation(
    configUuid: $configUuid
    centreCoordinates: $centreCoordinates
    boundaryId: $boundaryId
    visibility: $visibility
  )
}
    `;
export type SetGlobalSimulationLocationMutationFn = Apollo.MutationFunction<SetGlobalSimulationLocationMutation, SetGlobalSimulationLocationMutationVariables>;

/**
 * __useSetGlobalSimulationLocationMutation__
 *
 * To run a mutation, you first call `useSetGlobalSimulationLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalSimulationLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalSimulationLocationMutation, { data, loading, error }] = useSetGlobalSimulationLocationMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *      centreCoordinates: // value for 'centreCoordinates'
 *      boundaryId: // value for 'boundaryId'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useSetGlobalSimulationLocationMutation(baseOptions?: Apollo.MutationHookOptions<SetGlobalSimulationLocationMutation, SetGlobalSimulationLocationMutationVariables>) {
        return Apollo.useMutation<SetGlobalSimulationLocationMutation, SetGlobalSimulationLocationMutationVariables>(SetGlobalSimulationLocationDocument, baseOptions);
      }
export type SetGlobalSimulationLocationMutationHookResult = ReturnType<typeof useSetGlobalSimulationLocationMutation>;
export type SetGlobalSimulationLocationMutationResult = Apollo.MutationResult<SetGlobalSimulationLocationMutation>;
export type SetGlobalSimulationLocationMutationOptions = Apollo.BaseMutationOptions<SetGlobalSimulationLocationMutation, SetGlobalSimulationLocationMutationVariables>;
export const ToggleGlobalSimulationVisibilityDocument = gql`
    mutation toggleGlobalSimulationVisibility($configUuid: String!) {
  toggleGlobalSimulationVisibility(configUuid: $configUuid) {
    configUuid
    boundaryId
    visibility
    configType: type
  }
}
    `;
export type ToggleGlobalSimulationVisibilityMutationFn = Apollo.MutationFunction<ToggleGlobalSimulationVisibilityMutation, ToggleGlobalSimulationVisibilityMutationVariables>;

/**
 * __useToggleGlobalSimulationVisibilityMutation__
 *
 * To run a mutation, you first call `useToggleGlobalSimulationVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGlobalSimulationVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGlobalSimulationVisibilityMutation, { data, loading, error }] = useToggleGlobalSimulationVisibilityMutation({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *   },
 * });
 */
export function useToggleGlobalSimulationVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGlobalSimulationVisibilityMutation, ToggleGlobalSimulationVisibilityMutationVariables>) {
        return Apollo.useMutation<ToggleGlobalSimulationVisibilityMutation, ToggleGlobalSimulationVisibilityMutationVariables>(ToggleGlobalSimulationVisibilityDocument, baseOptions);
      }
export type ToggleGlobalSimulationVisibilityMutationHookResult = ReturnType<typeof useToggleGlobalSimulationVisibilityMutation>;
export type ToggleGlobalSimulationVisibilityMutationResult = Apollo.MutationResult<ToggleGlobalSimulationVisibilityMutation>;
export type ToggleGlobalSimulationVisibilityMutationOptions = Apollo.BaseMutationOptions<ToggleGlobalSimulationVisibilityMutation, ToggleGlobalSimulationVisibilityMutationVariables>;
export const UpdateUserSimulationVisibilityDocument = gql`
    mutation updateUserSimulationVisibility($visibility: Boolean!) {
  updateUserSimulationVisibility(visibility: $visibility) {
    username
    visibility
  }
}
    `;
export type UpdateUserSimulationVisibilityMutationFn = Apollo.MutationFunction<UpdateUserSimulationVisibilityMutation, UpdateUserSimulationVisibilityMutationVariables>;

/**
 * __useUpdateUserSimulationVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateUserSimulationVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSimulationVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSimulationVisibilityMutation, { data, loading, error }] = useUpdateUserSimulationVisibilityMutation({
 *   variables: {
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useUpdateUserSimulationVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSimulationVisibilityMutation, UpdateUserSimulationVisibilityMutationVariables>) {
        return Apollo.useMutation<UpdateUserSimulationVisibilityMutation, UpdateUserSimulationVisibilityMutationVariables>(UpdateUserSimulationVisibilityDocument, baseOptions);
      }
export type UpdateUserSimulationVisibilityMutationHookResult = ReturnType<typeof useUpdateUserSimulationVisibilityMutation>;
export type UpdateUserSimulationVisibilityMutationResult = Apollo.MutationResult<UpdateUserSimulationVisibilityMutation>;
export type UpdateUserSimulationVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateUserSimulationVisibilityMutation, UpdateUserSimulationVisibilityMutationVariables>;
export const CreateLibraryDocument = gql`
    mutation createLibrary($name: String, $scenarioData: ScenarioInput, $isPrivate: Boolean, $description: String, $configurationUuid: String) {
  createLibrary(
    name: $name
    scenarioData: $scenarioData
    isPrivate: $isPrivate
    description: $description
    configUUID: $configurationUuid
  ) {
    uuid
  }
}
    `;
export type CreateLibraryMutationFn = Apollo.MutationFunction<CreateLibraryMutation, CreateLibraryMutationVariables>;

/**
 * __useCreateLibraryMutation__
 *
 * To run a mutation, you first call `useCreateLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryMutation, { data, loading, error }] = useCreateLibraryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      scenarioData: // value for 'scenarioData'
 *      isPrivate: // value for 'isPrivate'
 *      description: // value for 'description'
 *      configurationUuid: // value for 'configurationUuid'
 *   },
 * });
 */
export function useCreateLibraryMutation(baseOptions?: Apollo.MutationHookOptions<CreateLibraryMutation, CreateLibraryMutationVariables>) {
        return Apollo.useMutation<CreateLibraryMutation, CreateLibraryMutationVariables>(CreateLibraryDocument, baseOptions);
      }
export type CreateLibraryMutationHookResult = ReturnType<typeof useCreateLibraryMutation>;
export type CreateLibraryMutationResult = Apollo.MutationResult<CreateLibraryMutation>;
export type CreateLibraryMutationOptions = Apollo.BaseMutationOptions<CreateLibraryMutation, CreateLibraryMutationVariables>;
export const DeleteLibraryDocument = gql`
    mutation deleteLibrary($uuid: String!) {
  deleteLibrary(uuid: $uuid)
}
    `;
export type DeleteLibraryMutationFn = Apollo.MutationFunction<DeleteLibraryMutation, DeleteLibraryMutationVariables>;

/**
 * __useDeleteLibraryMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryMutation, { data, loading, error }] = useDeleteLibraryMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteLibraryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryMutation, DeleteLibraryMutationVariables>) {
        return Apollo.useMutation<DeleteLibraryMutation, DeleteLibraryMutationVariables>(DeleteLibraryDocument, baseOptions);
      }
export type DeleteLibraryMutationHookResult = ReturnType<typeof useDeleteLibraryMutation>;
export type DeleteLibraryMutationResult = Apollo.MutationResult<DeleteLibraryMutation>;
export type DeleteLibraryMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryMutation, DeleteLibraryMutationVariables>;
export const DuplicateLibraryDocument = gql`
    mutation duplicateLibrary($uuid: String!, $isPrivate: Boolean!) {
  duplicateLibrary(uuid: $uuid, isPrivate: $isPrivate) {
    uuid
    name
    private
  }
}
    `;
export type DuplicateLibraryMutationFn = Apollo.MutationFunction<DuplicateLibraryMutation, DuplicateLibraryMutationVariables>;

/**
 * __useDuplicateLibraryMutation__
 *
 * To run a mutation, you first call `useDuplicateLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateLibraryMutation, { data, loading, error }] = useDuplicateLibraryMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      isPrivate: // value for 'isPrivate'
 *   },
 * });
 */
export function useDuplicateLibraryMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateLibraryMutation, DuplicateLibraryMutationVariables>) {
        return Apollo.useMutation<DuplicateLibraryMutation, DuplicateLibraryMutationVariables>(DuplicateLibraryDocument, baseOptions);
      }
export type DuplicateLibraryMutationHookResult = ReturnType<typeof useDuplicateLibraryMutation>;
export type DuplicateLibraryMutationResult = Apollo.MutationResult<DuplicateLibraryMutation>;
export type DuplicateLibraryMutationOptions = Apollo.BaseMutationOptions<DuplicateLibraryMutation, DuplicateLibraryMutationVariables>;
export const PostDuplicationLibraryDocument = gql`
    mutation postDuplicationLibrary($uuid: String!, $name: String!, $description: String) {
  updateLibrary(uuid: $uuid, name: $name, description: $description) {
    uuid
    name
    description
  }
}
    `;
export type PostDuplicationLibraryMutationFn = Apollo.MutationFunction<PostDuplicationLibraryMutation, PostDuplicationLibraryMutationVariables>;

/**
 * __usePostDuplicationLibraryMutation__
 *
 * To run a mutation, you first call `usePostDuplicationLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostDuplicationLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postDuplicationLibraryMutation, { data, loading, error }] = usePostDuplicationLibraryMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function usePostDuplicationLibraryMutation(baseOptions?: Apollo.MutationHookOptions<PostDuplicationLibraryMutation, PostDuplicationLibraryMutationVariables>) {
        return Apollo.useMutation<PostDuplicationLibraryMutation, PostDuplicationLibraryMutationVariables>(PostDuplicationLibraryDocument, baseOptions);
      }
export type PostDuplicationLibraryMutationHookResult = ReturnType<typeof usePostDuplicationLibraryMutation>;
export type PostDuplicationLibraryMutationResult = Apollo.MutationResult<PostDuplicationLibraryMutation>;
export type PostDuplicationLibraryMutationOptions = Apollo.BaseMutationOptions<PostDuplicationLibraryMutation, PostDuplicationLibraryMutationVariables>;
export const UpdateLibraryDocument = gql`
    mutation updateLibrary($uuid: String!, $scenarioData: ScenarioInput!) {
  updateLibrary(uuid: $uuid, scenarioData: $scenarioData) {
    name
    readOnly
    scenarioData {
      deviceCountNumber
      areaCountNumber
      representation {
        ... on PV {
          serialized
        }
        ... on Storage {
          serialized
        }
        ... on Load {
          serialized
        }
        ... on FiniteDieselGenerator {
          serialized
        }
        ... on MarketMaker {
          serialized
        }
        ... on InfiniteBus {
          serialized
        }
        ... on AreaOutput {
          serialized
        }
      }
    }
  }
}
    `;
export type UpdateLibraryMutationFn = Apollo.MutationFunction<UpdateLibraryMutation, UpdateLibraryMutationVariables>;

/**
 * __useUpdateLibraryMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryMutation, { data, loading, error }] = useUpdateLibraryMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      scenarioData: // value for 'scenarioData'
 *   },
 * });
 */
export function useUpdateLibraryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryMutation, UpdateLibraryMutationVariables>) {
        return Apollo.useMutation<UpdateLibraryMutation, UpdateLibraryMutationVariables>(UpdateLibraryDocument, baseOptions);
      }
export type UpdateLibraryMutationHookResult = ReturnType<typeof useUpdateLibraryMutation>;
export type UpdateLibraryMutationResult = Apollo.MutationResult<UpdateLibraryMutation>;
export type UpdateLibraryMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryMutation, UpdateLibraryMutationVariables>;
export const UpdateLibraryDataDocument = gql`
    mutation updateLibraryData($uuid: String!, $name: String!, $description: String) {
  updateLibrary(uuid: $uuid, name: $name, description: $description) {
    uuid
    name
    description
  }
}
    `;
export type UpdateLibraryDataMutationFn = Apollo.MutationFunction<UpdateLibraryDataMutation, UpdateLibraryDataMutationVariables>;

/**
 * __useUpdateLibraryDataMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryDataMutation, { data, loading, error }] = useUpdateLibraryDataMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateLibraryDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryDataMutation, UpdateLibraryDataMutationVariables>) {
        return Apollo.useMutation<UpdateLibraryDataMutation, UpdateLibraryDataMutationVariables>(UpdateLibraryDataDocument, baseOptions);
      }
export type UpdateLibraryDataMutationHookResult = ReturnType<typeof useUpdateLibraryDataMutation>;
export type UpdateLibraryDataMutationResult = Apollo.MutationResult<UpdateLibraryDataMutation>;
export type UpdateLibraryDataMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryDataMutation, UpdateLibraryDataMutationVariables>;
export const BulkAreaLiveEventDocument = gql`
    mutation bulkAreaLiveEvent($configurationUuid: String!, $eventList: [LiveEventInput]) {
  bulkAreaLiveEvent(configUuid: $configurationUuid, eventList: $eventList) {
    latestConfig {
      ...ConfigurationFields
    }
    eventList {
      eventType
      parameters
      timeStamp
      diff
    }
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type BulkAreaLiveEventMutationFn = Apollo.MutationFunction<BulkAreaLiveEventMutation, BulkAreaLiveEventMutationVariables>;

/**
 * __useBulkAreaLiveEventMutation__
 *
 * To run a mutation, you first call `useBulkAreaLiveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAreaLiveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAreaLiveEventMutation, { data, loading, error }] = useBulkAreaLiveEventMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      eventList: // value for 'eventList'
 *   },
 * });
 */
export function useBulkAreaLiveEventMutation(baseOptions?: Apollo.MutationHookOptions<BulkAreaLiveEventMutation, BulkAreaLiveEventMutationVariables>) {
        return Apollo.useMutation<BulkAreaLiveEventMutation, BulkAreaLiveEventMutationVariables>(BulkAreaLiveEventDocument, baseOptions);
      }
export type BulkAreaLiveEventMutationHookResult = ReturnType<typeof useBulkAreaLiveEventMutation>;
export type BulkAreaLiveEventMutationResult = Apollo.MutationResult<BulkAreaLiveEventMutation>;
export type BulkAreaLiveEventMutationOptions = Apollo.BaseMutationOptions<BulkAreaLiveEventMutation, BulkAreaLiveEventMutationVariables>;
export const CreateAreaLiveEventDocument = gql`
    mutation createAreaLiveEvent($configurationUuid: String!, $parentUuid: String!, $areaRepresentation: AreaInput, $libraryUuid: String) {
  createAreaLiveEvent(
    configUuid: $configurationUuid
    parentUuid: $parentUuid
    areaRepresentation: $areaRepresentation
    libraryUuid: $libraryUuid
  ) {
    latestConfig {
      ...ConfigurationFields
    }
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type CreateAreaLiveEventMutationFn = Apollo.MutationFunction<CreateAreaLiveEventMutation, CreateAreaLiveEventMutationVariables>;

/**
 * __useCreateAreaLiveEventMutation__
 *
 * To run a mutation, you first call `useCreateAreaLiveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAreaLiveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAreaLiveEventMutation, { data, loading, error }] = useCreateAreaLiveEventMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      parentUuid: // value for 'parentUuid'
 *      areaRepresentation: // value for 'areaRepresentation'
 *      libraryUuid: // value for 'libraryUuid'
 *   },
 * });
 */
export function useCreateAreaLiveEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateAreaLiveEventMutation, CreateAreaLiveEventMutationVariables>) {
        return Apollo.useMutation<CreateAreaLiveEventMutation, CreateAreaLiveEventMutationVariables>(CreateAreaLiveEventDocument, baseOptions);
      }
export type CreateAreaLiveEventMutationHookResult = ReturnType<typeof useCreateAreaLiveEventMutation>;
export type CreateAreaLiveEventMutationResult = Apollo.MutationResult<CreateAreaLiveEventMutation>;
export type CreateAreaLiveEventMutationOptions = Apollo.BaseMutationOptions<CreateAreaLiveEventMutation, CreateAreaLiveEventMutationVariables>;
export const DeleteAreaLiveEventDocument = gql`
    mutation deleteAreaLiveEvent($configurationUuid: String!, $areaUuid: String!) {
  deleteAreaLiveEvent(configUuid: $configurationUuid, areaUuid: $areaUuid) {
    latestConfig {
      ...ConfigurationFields
    }
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type DeleteAreaLiveEventMutationFn = Apollo.MutationFunction<DeleteAreaLiveEventMutation, DeleteAreaLiveEventMutationVariables>;

/**
 * __useDeleteAreaLiveEventMutation__
 *
 * To run a mutation, you first call `useDeleteAreaLiveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAreaLiveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAreaLiveEventMutation, { data, loading, error }] = useDeleteAreaLiveEventMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      areaUuid: // value for 'areaUuid'
 *   },
 * });
 */
export function useDeleteAreaLiveEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAreaLiveEventMutation, DeleteAreaLiveEventMutationVariables>) {
        return Apollo.useMutation<DeleteAreaLiveEventMutation, DeleteAreaLiveEventMutationVariables>(DeleteAreaLiveEventDocument, baseOptions);
      }
export type DeleteAreaLiveEventMutationHookResult = ReturnType<typeof useDeleteAreaLiveEventMutation>;
export type DeleteAreaLiveEventMutationResult = Apollo.MutationResult<DeleteAreaLiveEventMutation>;
export type DeleteAreaLiveEventMutationOptions = Apollo.BaseMutationOptions<DeleteAreaLiveEventMutation, DeleteAreaLiveEventMutationVariables>;
export const UpdateAreaLiveEventDocument = gql`
    mutation updateAreaLiveEvent($configurationUuid: String!, $areaUuid: String!, $areaParams: AreaInput!) {
  updateAreaLiveEvent(
    configUuid: $configurationUuid
    areaUuid: $areaUuid
    areaParams: $areaParams
  ) {
    latestConfig {
      ...ConfigurationFields
    }
  }
}
    ${ConfigurationFieldsFragmentDoc}`;
export type UpdateAreaLiveEventMutationFn = Apollo.MutationFunction<UpdateAreaLiveEventMutation, UpdateAreaLiveEventMutationVariables>;

/**
 * __useUpdateAreaLiveEventMutation__
 *
 * To run a mutation, you first call `useUpdateAreaLiveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAreaLiveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAreaLiveEventMutation, { data, loading, error }] = useUpdateAreaLiveEventMutation({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      areaUuid: // value for 'areaUuid'
 *      areaParams: // value for 'areaParams'
 *   },
 * });
 */
export function useUpdateAreaLiveEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAreaLiveEventMutation, UpdateAreaLiveEventMutationVariables>) {
        return Apollo.useMutation<UpdateAreaLiveEventMutation, UpdateAreaLiveEventMutationVariables>(UpdateAreaLiveEventDocument, baseOptions);
      }
export type UpdateAreaLiveEventMutationHookResult = ReturnType<typeof useUpdateAreaLiveEventMutation>;
export type UpdateAreaLiveEventMutationResult = Apollo.MutationResult<UpdateAreaLiveEventMutation>;
export type UpdateAreaLiveEventMutationOptions = Apollo.BaseMutationOptions<UpdateAreaLiveEventMutation, UpdateAreaLiveEventMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($centreCoordinates: Position, $description: String, $locationVisible: Boolean, $name: String!, $private: Boolean) {
  createProject(
    centreCoordinates: $centreCoordinates
    description: $description
    locationVisible: $locationVisible
    name: $name
    private: $private
  ) {
    name
    uuid
    description
    private
    user
    configurations {
      uuid
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      centreCoordinates: // value for 'centreCoordinates'
 *      description: // value for 'description'
 *      locationVisible: // value for 'locationVisible'
 *      name: // value for 'name'
 *      private: // value for 'private'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, baseOptions);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation deleteProject($projectUuid: String!) {
  deleteProject(uuid: $projectUuid)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      projectUuid: // value for 'projectUuid'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, baseOptions);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($projectUuid: String!, $centreCoordinates: Position, $description: String, $locationVisible: Boolean, $name: String, $private: Boolean) {
  updateProject(
    uuid: $projectUuid
    centreCoordinates: $centreCoordinates
    description: $description
    locationVisible: $locationVisible
    name: $name
    private: $private
  ) {
    name
    uuid
    user
    timestamp
    private
    latitude
    longitude
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      projectUuid: // value for 'projectUuid'
 *      centreCoordinates: // value for 'centreCoordinates'
 *      description: // value for 'description'
 *      locationVisible: // value for 'locationVisible'
 *      name: // value for 'name'
 *      private: // value for 'private'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, baseOptions);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const LaunchSimulationDocument = gql`
    mutation launchSimulation($uuid: String) {
  launchSimulation(uuid: $uuid) {
    job
    status
    configUUID
  }
}
    `;
export type LaunchSimulationMutationFn = Apollo.MutationFunction<LaunchSimulationMutation, LaunchSimulationMutationVariables>;

/**
 * __useLaunchSimulationMutation__
 *
 * To run a mutation, you first call `useLaunchSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchSimulationMutation, { data, loading, error }] = useLaunchSimulationMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useLaunchSimulationMutation(baseOptions?: Apollo.MutationHookOptions<LaunchSimulationMutation, LaunchSimulationMutationVariables>) {
        return Apollo.useMutation<LaunchSimulationMutation, LaunchSimulationMutationVariables>(LaunchSimulationDocument, baseOptions);
      }
export type LaunchSimulationMutationHookResult = ReturnType<typeof useLaunchSimulationMutation>;
export type LaunchSimulationMutationResult = Apollo.MutationResult<LaunchSimulationMutation>;
export type LaunchSimulationMutationOptions = Apollo.BaseMutationOptions<LaunchSimulationMutation, LaunchSimulationMutationVariables>;
export const PauseSimulationDocument = gql`
    mutation pauseSimulation($jobId: String!) {
  pauseSimulation(jobId: $jobId)
}
    `;
export type PauseSimulationMutationFn = Apollo.MutationFunction<PauseSimulationMutation, PauseSimulationMutationVariables>;

/**
 * __usePauseSimulationMutation__
 *
 * To run a mutation, you first call `usePauseSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSimulationMutation, { data, loading, error }] = usePauseSimulationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function usePauseSimulationMutation(baseOptions?: Apollo.MutationHookOptions<PauseSimulationMutation, PauseSimulationMutationVariables>) {
        return Apollo.useMutation<PauseSimulationMutation, PauseSimulationMutationVariables>(PauseSimulationDocument, baseOptions);
      }
export type PauseSimulationMutationHookResult = ReturnType<typeof usePauseSimulationMutation>;
export type PauseSimulationMutationResult = Apollo.MutationResult<PauseSimulationMutation>;
export type PauseSimulationMutationOptions = Apollo.BaseMutationOptions<PauseSimulationMutation, PauseSimulationMutationVariables>;
export const ResumeSimulationDocument = gql`
    mutation resumeSimulation($jobId: String!) {
  resumeSimulation(jobId: $jobId)
}
    `;
export type ResumeSimulationMutationFn = Apollo.MutationFunction<ResumeSimulationMutation, ResumeSimulationMutationVariables>;

/**
 * __useResumeSimulationMutation__
 *
 * To run a mutation, you first call `useResumeSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSimulationMutation, { data, loading, error }] = useResumeSimulationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useResumeSimulationMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSimulationMutation, ResumeSimulationMutationVariables>) {
        return Apollo.useMutation<ResumeSimulationMutation, ResumeSimulationMutationVariables>(ResumeSimulationDocument, baseOptions);
      }
export type ResumeSimulationMutationHookResult = ReturnType<typeof useResumeSimulationMutation>;
export type ResumeSimulationMutationResult = Apollo.MutationResult<ResumeSimulationMutation>;
export type ResumeSimulationMutationOptions = Apollo.BaseMutationOptions<ResumeSimulationMutation, ResumeSimulationMutationVariables>;
export const StopSimulationDocument = gql`
    mutation stopSimulation($jobId: String!) {
  stopSimulation(jobId: $jobId)
}
    `;
export type StopSimulationMutationFn = Apollo.MutationFunction<StopSimulationMutation, StopSimulationMutationVariables>;

/**
 * __useStopSimulationMutation__
 *
 * To run a mutation, you first call `useStopSimulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSimulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSimulationMutation, { data, loading, error }] = useStopSimulationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useStopSimulationMutation(baseOptions?: Apollo.MutationHookOptions<StopSimulationMutation, StopSimulationMutationVariables>) {
        return Apollo.useMutation<StopSimulationMutation, StopSimulationMutationVariables>(StopSimulationDocument, baseOptions);
      }
export type StopSimulationMutationHookResult = ReturnType<typeof useStopSimulationMutation>;
export type StopSimulationMutationResult = Apollo.MutationResult<StopSimulationMutation>;
export type StopSimulationMutationOptions = Apollo.BaseMutationOptions<StopSimulationMutation, StopSimulationMutationVariables>;
export const AvailableRolesDocument = gql`
    query availableRoles {
  availableUserRoles {
    userRoles {
      roleName
      value
    }
  }
}
    `;

/**
 * __useAvailableRolesQuery__
 *
 * To run a query within a React component, call `useAvailableRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableRolesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableRolesQuery, AvailableRolesQueryVariables>) {
        return Apollo.useQuery<AvailableRolesQuery, AvailableRolesQueryVariables>(AvailableRolesDocument, baseOptions);
      }
export function useAvailableRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableRolesQuery, AvailableRolesQueryVariables>) {
          return Apollo.useLazyQuery<AvailableRolesQuery, AvailableRolesQueryVariables>(AvailableRolesDocument, baseOptions);
        }
export type AvailableRolesQueryHookResult = ReturnType<typeof useAvailableRolesQuery>;
export type AvailableRolesLazyQueryHookResult = ReturnType<typeof useAvailableRolesLazyQuery>;
export type AvailableRolesQueryResult = Apollo.QueryResult<AvailableRolesQuery, AvailableRolesQueryVariables>;
export const ListAdminStatsDocument = gql`
    query listAdminStats($startTime: DateTime, $endTime: DateTime, $emailSearch: String, $userRoles: [String]) {
  listAdminStats(
    startTime: $startTime
    endTime: $endTime
    emailSearch: $emailSearch
    userRoles: $userRoles
  ) {
    userActivity {
      newRegistration {
        username
        timestamp
      }
      loginDetail {
        timestamp
        durationMs
        username
      }
    }
  }
}
    `;

/**
 * __useListAdminStatsQuery__
 *
 * To run a query within a React component, call `useListAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminStatsQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      emailSearch: // value for 'emailSearch'
 *      userRoles: // value for 'userRoles'
 *   },
 * });
 */
export function useListAdminStatsQuery(baseOptions?: Apollo.QueryHookOptions<ListAdminStatsQuery, ListAdminStatsQueryVariables>) {
        return Apollo.useQuery<ListAdminStatsQuery, ListAdminStatsQueryVariables>(ListAdminStatsDocument, baseOptions);
      }
export function useListAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminStatsQuery, ListAdminStatsQueryVariables>) {
          return Apollo.useLazyQuery<ListAdminStatsQuery, ListAdminStatsQueryVariables>(ListAdminStatsDocument, baseOptions);
        }
export type ListAdminStatsQueryHookResult = ReturnType<typeof useListAdminStatsQuery>;
export type ListAdminStatsLazyQueryHookResult = ReturnType<typeof useListAdminStatsLazyQuery>;
export type ListAdminStatsQueryResult = Apollo.QueryResult<ListAdminStatsQuery, ListAdminStatsQueryVariables>;
export const ListAdminStatsWithRolesDocument = gql`
    query listAdminStatsWithRoles {
  listAdminStats {
    userDetails {
      id
      username
      joined: joinedDate
      numberOfProjects
      numberOfSimulations
      activeTimeInSeconds
      numberOfConfiguredAgents
      numberOfLibraries
      userRole
    }
  }
  availableUserRoles {
    userRoles {
      roleName
      value
    }
  }
}
    `;

/**
 * __useListAdminStatsWithRolesQuery__
 *
 * To run a query within a React component, call `useListAdminStatsWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminStatsWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminStatsWithRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAdminStatsWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<ListAdminStatsWithRolesQuery, ListAdminStatsWithRolesQueryVariables>) {
        return Apollo.useQuery<ListAdminStatsWithRolesQuery, ListAdminStatsWithRolesQueryVariables>(ListAdminStatsWithRolesDocument, baseOptions);
      }
export function useListAdminStatsWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAdminStatsWithRolesQuery, ListAdminStatsWithRolesQueryVariables>) {
          return Apollo.useLazyQuery<ListAdminStatsWithRolesQuery, ListAdminStatsWithRolesQueryVariables>(ListAdminStatsWithRolesDocument, baseOptions);
        }
export type ListAdminStatsWithRolesQueryHookResult = ReturnType<typeof useListAdminStatsWithRolesQuery>;
export type ListAdminStatsWithRolesLazyQueryHookResult = ReturnType<typeof useListAdminStatsWithRolesLazyQuery>;
export type ListAdminStatsWithRolesQueryResult = Apollo.QueryResult<ListAdminStatsWithRolesQuery, ListAdminStatsWithRolesQueryVariables>;
export const ReadUserRoleDocument = gql`
    query readUserRole($email: String!) {
  readUserRole(email: $email) {
    roleName
    value
  }
}
    `;

/**
 * __useReadUserRoleQuery__
 *
 * To run a query within a React component, call `useReadUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadUserRoleQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useReadUserRoleQuery(baseOptions: Apollo.QueryHookOptions<ReadUserRoleQuery, ReadUserRoleQueryVariables>) {
        return Apollo.useQuery<ReadUserRoleQuery, ReadUserRoleQueryVariables>(ReadUserRoleDocument, baseOptions);
      }
export function useReadUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadUserRoleQuery, ReadUserRoleQueryVariables>) {
          return Apollo.useLazyQuery<ReadUserRoleQuery, ReadUserRoleQueryVariables>(ReadUserRoleDocument, baseOptions);
        }
export type ReadUserRoleQueryHookResult = ReturnType<typeof useReadUserRoleQuery>;
export type ReadUserRoleLazyQueryHookResult = ReturnType<typeof useReadUserRoleLazyQuery>;
export type ReadUserRoleQueryResult = Apollo.QueryResult<ReadUserRoleQuery, ReadUserRoleQueryVariables>;
export const PasswordResetDocument = gql`
    query passwordReset($email: String!) {
  passwordResetEmail(email: $email)
}
    `;

/**
 * __usePasswordResetQuery__
 *
 * To run a query within a React component, call `usePasswordResetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordResetQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePasswordResetQuery(baseOptions: Apollo.QueryHookOptions<PasswordResetQuery, PasswordResetQueryVariables>) {
        return Apollo.useQuery<PasswordResetQuery, PasswordResetQueryVariables>(PasswordResetDocument, baseOptions);
      }
export function usePasswordResetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PasswordResetQuery, PasswordResetQueryVariables>) {
          return Apollo.useLazyQuery<PasswordResetQuery, PasswordResetQueryVariables>(PasswordResetDocument, baseOptions);
        }
export type PasswordResetQueryHookResult = ReturnType<typeof usePasswordResetQuery>;
export type PasswordResetLazyQueryHookResult = ReturnType<typeof usePasswordResetLazyQuery>;
export type PasswordResetQueryResult = Apollo.QueryResult<PasswordResetQuery, PasswordResetQueryVariables>;
export const ListCanaryNetworksDocument = gql`
    query listCanaryNetworks($search: String, $skip: Int, $first: Int) {
  listCanaryNetworks(search: $search, skip: $skip, first: $first) {
    totalCount
    configurations {
      name
      uuid
      scenarioData {
        deviceCount
      }
      project {
        uuid
      }
      configType: type
      simulationResults
      description
      user
      timestamp
      readOnly
      warnings
      openForExternalApplications
      resultsStatus
      private
      areaSummary {
        configuredAreas
        configuredDevices
      }
    }
  }
}
    `;

/**
 * __useListCanaryNetworksQuery__
 *
 * To run a query within a React component, call `useListCanaryNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCanaryNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCanaryNetworksQuery({
 *   variables: {
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListCanaryNetworksQuery(baseOptions?: Apollo.QueryHookOptions<ListCanaryNetworksQuery, ListCanaryNetworksQueryVariables>) {
        return Apollo.useQuery<ListCanaryNetworksQuery, ListCanaryNetworksQueryVariables>(ListCanaryNetworksDocument, baseOptions);
      }
export function useListCanaryNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCanaryNetworksQuery, ListCanaryNetworksQueryVariables>) {
          return Apollo.useLazyQuery<ListCanaryNetworksQuery, ListCanaryNetworksQueryVariables>(ListCanaryNetworksDocument, baseOptions);
        }
export type ListCanaryNetworksQueryHookResult = ReturnType<typeof useListCanaryNetworksQuery>;
export type ListCanaryNetworksLazyQueryHookResult = ReturnType<typeof useListCanaryNetworksLazyQuery>;
export type ListCanaryNetworksQueryResult = Apollo.QueryResult<ListCanaryNetworksQuery, ListCanaryNetworksQueryVariables>;
export const ListCanaryNetworksStatusesDocument = gql`
    query listCanaryNetworksStatuses($search: String, $skip: Int, $first: Int) {
  listCanaryNetworks(search: $search, skip: $skip, first: $first) {
    configurations {
      uuid
      resultsStatus
      project {
        uuid
      }
    }
  }
}
    `;

/**
 * __useListCanaryNetworksStatusesQuery__
 *
 * To run a query within a React component, call `useListCanaryNetworksStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCanaryNetworksStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCanaryNetworksStatusesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListCanaryNetworksStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ListCanaryNetworksStatusesQuery, ListCanaryNetworksStatusesQueryVariables>) {
        return Apollo.useQuery<ListCanaryNetworksStatusesQuery, ListCanaryNetworksStatusesQueryVariables>(ListCanaryNetworksStatusesDocument, baseOptions);
      }
export function useListCanaryNetworksStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCanaryNetworksStatusesQuery, ListCanaryNetworksStatusesQueryVariables>) {
          return Apollo.useLazyQuery<ListCanaryNetworksStatusesQuery, ListCanaryNetworksStatusesQueryVariables>(ListCanaryNetworksStatusesDocument, baseOptions);
        }
export type ListCanaryNetworksStatusesQueryHookResult = ReturnType<typeof useListCanaryNetworksStatusesQuery>;
export type ListCanaryNetworksStatusesLazyQueryHookResult = ReturnType<typeof useListCanaryNetworksStatusesLazyQuery>;
export type ListCanaryNetworksStatusesQueryResult = Apollo.QueryResult<ListCanaryNetworksStatusesQuery, ListCanaryNetworksStatusesQueryVariables>;
export const AvailableMarketsDocument = gql`
    query availableMarkets($uuid: String!) {
  availableMarkets(configUuid: $uuid)
}
    `;

/**
 * __useAvailableMarketsQuery__
 *
 * To run a query within a React component, call `useAvailableMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableMarketsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAvailableMarketsQuery(baseOptions: Apollo.QueryHookOptions<AvailableMarketsQuery, AvailableMarketsQueryVariables>) {
        return Apollo.useQuery<AvailableMarketsQuery, AvailableMarketsQueryVariables>(AvailableMarketsDocument, baseOptions);
      }
export function useAvailableMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableMarketsQuery, AvailableMarketsQueryVariables>) {
          return Apollo.useLazyQuery<AvailableMarketsQuery, AvailableMarketsQueryVariables>(AvailableMarketsDocument, baseOptions);
        }
export type AvailableMarketsQueryHookResult = ReturnType<typeof useAvailableMarketsQuery>;
export type AvailableMarketsLazyQueryHookResult = ReturnType<typeof useAvailableMarketsLazyQuery>;
export type AvailableMarketsQueryResult = Apollo.QueryResult<AvailableMarketsQuery, AvailableMarketsQueryVariables>;
export const ListCollaborationsDocument = gql`
    query listCollaborations($search: String, $skip: Int, $first: Int) {
  listCollaborations(search: $search, skip: $skip, first: $first) {
    totalCount
    configurations {
      uuid
      name
      description
      readOnly
      simulationResults
      resultsStatus
      timestamp
      scenarioData {
        deviceCount
      }
      areaSummary {
        configuredAreas
        configuredDevices
      }
      project {
        uuid
      }
      configType: type
      user
      openForExternalApplications
      private
    }
  }
}
    `;

/**
 * __useListCollaborationsQuery__
 *
 * To run a query within a React component, call `useListCollaborationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCollaborationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCollaborationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListCollaborationsQuery(baseOptions?: Apollo.QueryHookOptions<ListCollaborationsQuery, ListCollaborationsQueryVariables>) {
        return Apollo.useQuery<ListCollaborationsQuery, ListCollaborationsQueryVariables>(ListCollaborationsDocument, baseOptions);
      }
export function useListCollaborationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCollaborationsQuery, ListCollaborationsQueryVariables>) {
          return Apollo.useLazyQuery<ListCollaborationsQuery, ListCollaborationsQueryVariables>(ListCollaborationsDocument, baseOptions);
        }
export type ListCollaborationsQueryHookResult = ReturnType<typeof useListCollaborationsQuery>;
export type ListCollaborationsLazyQueryHookResult = ReturnType<typeof useListCollaborationsLazyQuery>;
export type ListCollaborationsQueryResult = Apollo.QueryResult<ListCollaborationsQuery, ListCollaborationsQueryVariables>;
export const ListCollaborationsStatusesDocument = gql`
    query listCollaborationsStatuses($search: String, $skip: Int, $first: Int) {
  listCollaborations(search: $search, skip: $skip, first: $first) {
    configurations {
      uuid
      resultsStatus
      project {
        uuid
      }
    }
  }
}
    `;

/**
 * __useListCollaborationsStatusesQuery__
 *
 * To run a query within a React component, call `useListCollaborationsStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCollaborationsStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCollaborationsStatusesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListCollaborationsStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ListCollaborationsStatusesQuery, ListCollaborationsStatusesQueryVariables>) {
        return Apollo.useQuery<ListCollaborationsStatusesQuery, ListCollaborationsStatusesQueryVariables>(ListCollaborationsStatusesDocument, baseOptions);
      }
export function useListCollaborationsStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCollaborationsStatusesQuery, ListCollaborationsStatusesQueryVariables>) {
          return Apollo.useLazyQuery<ListCollaborationsStatusesQuery, ListCollaborationsStatusesQueryVariables>(ListCollaborationsStatusesDocument, baseOptions);
        }
export type ListCollaborationsStatusesQueryHookResult = ReturnType<typeof useListCollaborationsStatusesQuery>;
export type ListCollaborationsStatusesLazyQueryHookResult = ReturnType<typeof useListCollaborationsStatusesLazyQuery>;
export type ListCollaborationsStatusesQueryResult = Apollo.QueryResult<ListCollaborationsStatusesQuery, ListCollaborationsStatusesQueryVariables>;
export const MyApplicationsDocument = gql`
    query myApplications($uuid: String!) {
  listApplicationStatus(configUuid: $uuid) {
    areaUuid
    status
  }
}
    `;

/**
 * __useMyApplicationsQuery__
 *
 * To run a query within a React component, call `useMyApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyApplicationsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useMyApplicationsQuery(baseOptions: Apollo.QueryHookOptions<MyApplicationsQuery, MyApplicationsQueryVariables>) {
        return Apollo.useQuery<MyApplicationsQuery, MyApplicationsQueryVariables>(MyApplicationsDocument, baseOptions);
      }
export function useMyApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyApplicationsQuery, MyApplicationsQueryVariables>) {
          return Apollo.useLazyQuery<MyApplicationsQuery, MyApplicationsQueryVariables>(MyApplicationsDocument, baseOptions);
        }
export type MyApplicationsQueryHookResult = ReturnType<typeof useMyApplicationsQuery>;
export type MyApplicationsLazyQueryHookResult = ReturnType<typeof useMyApplicationsLazyQuery>;
export type MyApplicationsQueryResult = Apollo.QueryResult<MyApplicationsQuery, MyApplicationsQueryVariables>;
export const ReadCollaborationConfigurationDocument = gql`
    query readCollaborationConfiguration($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;

/**
 * __useReadCollaborationConfigurationQuery__
 *
 * To run a query within a React component, call `useReadCollaborationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCollaborationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCollaborationConfigurationQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadCollaborationConfigurationQuery(baseOptions: Apollo.QueryHookOptions<ReadCollaborationConfigurationQuery, ReadCollaborationConfigurationQueryVariables>) {
        return Apollo.useQuery<ReadCollaborationConfigurationQuery, ReadCollaborationConfigurationQueryVariables>(ReadCollaborationConfigurationDocument, baseOptions);
      }
export function useReadCollaborationConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCollaborationConfigurationQuery, ReadCollaborationConfigurationQueryVariables>) {
          return Apollo.useLazyQuery<ReadCollaborationConfigurationQuery, ReadCollaborationConfigurationQueryVariables>(ReadCollaborationConfigurationDocument, baseOptions);
        }
export type ReadCollaborationConfigurationQueryHookResult = ReturnType<typeof useReadCollaborationConfigurationQuery>;
export type ReadCollaborationConfigurationLazyQueryHookResult = ReturnType<typeof useReadCollaborationConfigurationLazyQuery>;
export type ReadCollaborationConfigurationQueryResult = Apollo.QueryResult<ReadCollaborationConfigurationQuery, ReadCollaborationConfigurationQueryVariables>;
export const ReadConfigWithApplicationsDocument = gql`
    query readConfigWithApplications($uuid: String!) {
  availableTargetMarketKpis
  availableTargetDeviceKpis
  listAvailableExternalApplication(configUuid: $uuid) {
    username
    configUuid
    areaUuid
    status
  }
}
    `;

/**
 * __useReadConfigWithApplicationsQuery__
 *
 * To run a query within a React component, call `useReadConfigWithApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConfigWithApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConfigWithApplicationsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadConfigWithApplicationsQuery(baseOptions: Apollo.QueryHookOptions<ReadConfigWithApplicationsQuery, ReadConfigWithApplicationsQueryVariables>) {
        return Apollo.useQuery<ReadConfigWithApplicationsQuery, ReadConfigWithApplicationsQueryVariables>(ReadConfigWithApplicationsDocument, baseOptions);
      }
export function useReadConfigWithApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConfigWithApplicationsQuery, ReadConfigWithApplicationsQueryVariables>) {
          return Apollo.useLazyQuery<ReadConfigWithApplicationsQuery, ReadConfigWithApplicationsQueryVariables>(ReadConfigWithApplicationsDocument, baseOptions);
        }
export type ReadConfigWithApplicationsQueryHookResult = ReturnType<typeof useReadConfigWithApplicationsQuery>;
export type ReadConfigWithApplicationsLazyQueryHookResult = ReturnType<typeof useReadConfigWithApplicationsLazyQuery>;
export type ReadConfigWithApplicationsQueryResult = Apollo.QueryResult<ReadConfigWithApplicationsQuery, ReadConfigWithApplicationsQueryVariables>;
export const ReadConfigWithMyApplicationsDocument = gql`
    query readConfigWithMyApplications($uuid: String!) {
  availableTargetMarketKpis
  availableTargetDeviceKpis
  listApplicationStatus(configUuid: $uuid) {
    configUuid
    areaUuid
    status
  }
  listAvailableExternalConnection(configUuid: $uuid) {
    configuration {
      configUuid
      availableAreaUuids
    }
  }
}
    `;

/**
 * __useReadConfigWithMyApplicationsQuery__
 *
 * To run a query within a React component, call `useReadConfigWithMyApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConfigWithMyApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConfigWithMyApplicationsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadConfigWithMyApplicationsQuery(baseOptions: Apollo.QueryHookOptions<ReadConfigWithMyApplicationsQuery, ReadConfigWithMyApplicationsQueryVariables>) {
        return Apollo.useQuery<ReadConfigWithMyApplicationsQuery, ReadConfigWithMyApplicationsQueryVariables>(ReadConfigWithMyApplicationsDocument, baseOptions);
      }
export function useReadConfigWithMyApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConfigWithMyApplicationsQuery, ReadConfigWithMyApplicationsQueryVariables>) {
          return Apollo.useLazyQuery<ReadConfigWithMyApplicationsQuery, ReadConfigWithMyApplicationsQueryVariables>(ReadConfigWithMyApplicationsDocument, baseOptions);
        }
export type ReadConfigWithMyApplicationsQueryHookResult = ReturnType<typeof useReadConfigWithMyApplicationsQuery>;
export type ReadConfigWithMyApplicationsLazyQueryHookResult = ReturnType<typeof useReadConfigWithMyApplicationsLazyQuery>;
export type ReadConfigWithMyApplicationsQueryResult = Apollo.QueryResult<ReadConfigWithMyApplicationsQuery, ReadConfigWithMyApplicationsQueryVariables>;
export const ListCommunityInfoDocument = gql`
    query listCommunityInfo {
  listCommunityInfo {
    projects {
      name
      uuid
      user
      timestamp
      private
      latitude
      longitude
      locationVisible
      configurations {
        name
        uuid
        configType: type
        globalCumulativeNetEnergyFlow
        latitude
        longitude
      }
    }
  }
}
    `;

/**
 * __useListCommunityInfoQuery__
 *
 * To run a query within a React component, call `useListCommunityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCommunityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCommunityInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCommunityInfoQuery(baseOptions?: Apollo.QueryHookOptions<ListCommunityInfoQuery, ListCommunityInfoQueryVariables>) {
        return Apollo.useQuery<ListCommunityInfoQuery, ListCommunityInfoQueryVariables>(ListCommunityInfoDocument, baseOptions);
      }
export function useListCommunityInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCommunityInfoQuery, ListCommunityInfoQueryVariables>) {
          return Apollo.useLazyQuery<ListCommunityInfoQuery, ListCommunityInfoQueryVariables>(ListCommunityInfoDocument, baseOptions);
        }
export type ListCommunityInfoQueryHookResult = ReturnType<typeof useListCommunityInfoQuery>;
export type ListCommunityInfoLazyQueryHookResult = ReturnType<typeof useListCommunityInfoLazyQuery>;
export type ListCommunityInfoQueryResult = Apollo.QueryResult<ListCommunityInfoQuery, ListCommunityInfoQueryVariables>;
export const ListPersonalCommunityInfoDocument = gql`
    query listPersonalCommunityInfo {
  listPersonalCommunityInfo {
    projects {
      name
      uuid
      user
      timestamp
      private
      latitude
      longitude
      locationVisible
      configurations {
        name
        uuid
        configType: type
        globalCumulativeNetEnergyFlow
        latitude
        longitude
      }
    }
  }
}
    `;

/**
 * __useListPersonalCommunityInfoQuery__
 *
 * To run a query within a React component, call `useListPersonalCommunityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPersonalCommunityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPersonalCommunityInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPersonalCommunityInfoQuery(baseOptions?: Apollo.QueryHookOptions<ListPersonalCommunityInfoQuery, ListPersonalCommunityInfoQueryVariables>) {
        return Apollo.useQuery<ListPersonalCommunityInfoQuery, ListPersonalCommunityInfoQueryVariables>(ListPersonalCommunityInfoDocument, baseOptions);
      }
export function useListPersonalCommunityInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPersonalCommunityInfoQuery, ListPersonalCommunityInfoQueryVariables>) {
          return Apollo.useLazyQuery<ListPersonalCommunityInfoQuery, ListPersonalCommunityInfoQueryVariables>(ListPersonalCommunityInfoDocument, baseOptions);
        }
export type ListPersonalCommunityInfoQueryHookResult = ReturnType<typeof useListPersonalCommunityInfoQuery>;
export type ListPersonalCommunityInfoLazyQueryHookResult = ReturnType<typeof useListPersonalCommunityInfoLazyQuery>;
export type ListPersonalCommunityInfoQueryResult = Apollo.QueryResult<ListPersonalCommunityInfoQuery, ListPersonalCommunityInfoQueryVariables>;
export const AreaSummaryDocument = gql`
    query areaSummary($uuid: String!) {
  areaSummary(configUuid: $uuid)
}
    `;

/**
 * __useAreaSummaryQuery__
 *
 * To run a query within a React component, call `useAreaSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaSummaryQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useAreaSummaryQuery(baseOptions: Apollo.QueryHookOptions<AreaSummaryQuery, AreaSummaryQueryVariables>) {
        return Apollo.useQuery<AreaSummaryQuery, AreaSummaryQueryVariables>(AreaSummaryDocument, baseOptions);
      }
export function useAreaSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaSummaryQuery, AreaSummaryQueryVariables>) {
          return Apollo.useLazyQuery<AreaSummaryQuery, AreaSummaryQueryVariables>(AreaSummaryDocument, baseOptions);
        }
export type AreaSummaryQueryHookResult = ReturnType<typeof useAreaSummaryQuery>;
export type AreaSummaryLazyQueryHookResult = ReturnType<typeof useAreaSummaryLazyQuery>;
export type AreaSummaryQueryResult = Apollo.QueryResult<AreaSummaryQuery, AreaSummaryQueryVariables>;
export const ListConfigurationsDocument = gql`
    query listConfigurations($search: String, $skip: Int, $first: Int, $projectUuid: String) {
  listConfigurations(
    search: $search
    skip: $skip
    first: $first
    projectUUID: $projectUuid
  ) {
    totalCount
    configurations {
      uuid
      name
      user
      description
      readOnly
      simulationResults
      resultsStatus
      timestamp
      scenarioData {
        deviceCount
      }
      areaSummary {
        configuredAreas
        configuredDevices
      }
      project {
        uuid
      }
      configType: type
      private
    }
  }
}
    `;

/**
 * __useListConfigurationsQuery__
 *
 * To run a query within a React component, call `useListConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConfigurationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *      projectUuid: // value for 'projectUuid'
 *   },
 * });
 */
export function useListConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<ListConfigurationsQuery, ListConfigurationsQueryVariables>) {
        return Apollo.useQuery<ListConfigurationsQuery, ListConfigurationsQueryVariables>(ListConfigurationsDocument, baseOptions);
      }
export function useListConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConfigurationsQuery, ListConfigurationsQueryVariables>) {
          return Apollo.useLazyQuery<ListConfigurationsQuery, ListConfigurationsQueryVariables>(ListConfigurationsDocument, baseOptions);
        }
export type ListConfigurationsQueryHookResult = ReturnType<typeof useListConfigurationsQuery>;
export type ListConfigurationsLazyQueryHookResult = ReturnType<typeof useListConfigurationsLazyQuery>;
export type ListConfigurationsQueryResult = Apollo.QueryResult<ListConfigurationsQuery, ListConfigurationsQueryVariables>;
export const LookForCommunityUuidDocument = gql`
    query lookForCommunityUuid($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    name
    uuid
    simulationResults
    resultsStatus
    scenarioData {
      latest {
        children {
          ... on AreaOutput {
            name
            uuid
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLookForCommunityUuidQuery__
 *
 * To run a query within a React component, call `useLookForCommunityUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookForCommunityUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookForCommunityUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useLookForCommunityUuidQuery(baseOptions: Apollo.QueryHookOptions<LookForCommunityUuidQuery, LookForCommunityUuidQueryVariables>) {
        return Apollo.useQuery<LookForCommunityUuidQuery, LookForCommunityUuidQueryVariables>(LookForCommunityUuidDocument, baseOptions);
      }
export function useLookForCommunityUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookForCommunityUuidQuery, LookForCommunityUuidQueryVariables>) {
          return Apollo.useLazyQuery<LookForCommunityUuidQuery, LookForCommunityUuidQueryVariables>(LookForCommunityUuidDocument, baseOptions);
        }
export type LookForCommunityUuidQueryHookResult = ReturnType<typeof useLookForCommunityUuidQuery>;
export type LookForCommunityUuidLazyQueryHookResult = ReturnType<typeof useLookForCommunityUuidLazyQuery>;
export type LookForCommunityUuidQueryResult = Apollo.QueryResult<LookForCommunityUuidQuery, LookForCommunityUuidQueryVariables>;
export const LookForSimulationResultsDocument = gql`
    query lookForSimulationResults($configurationUuid: String!) {
  readConfiguration(uuid: $configurationUuid) {
    uuid
    simulationResults
    resultsStatus
  }
}
    `;

/**
 * __useLookForSimulationResultsQuery__
 *
 * To run a query within a React component, call `useLookForSimulationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookForSimulationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookForSimulationResultsQuery({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *   },
 * });
 */
export function useLookForSimulationResultsQuery(baseOptions: Apollo.QueryHookOptions<LookForSimulationResultsQuery, LookForSimulationResultsQueryVariables>) {
        return Apollo.useQuery<LookForSimulationResultsQuery, LookForSimulationResultsQueryVariables>(LookForSimulationResultsDocument, baseOptions);
      }
export function useLookForSimulationResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookForSimulationResultsQuery, LookForSimulationResultsQueryVariables>) {
          return Apollo.useLazyQuery<LookForSimulationResultsQuery, LookForSimulationResultsQueryVariables>(LookForSimulationResultsDocument, baseOptions);
        }
export type LookForSimulationResultsQueryHookResult = ReturnType<typeof useLookForSimulationResultsQuery>;
export type LookForSimulationResultsLazyQueryHookResult = ReturnType<typeof useLookForSimulationResultsLazyQuery>;
export type LookForSimulationResultsQueryResult = Apollo.QueryResult<LookForSimulationResultsQuery, LookForSimulationResultsQueryVariables>;
export const ReadConfigRepresentationWithoutEventsDocument = gql`
    query readConfigRepresentationWithoutEvents($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    scenarioData {
      representation {
        serialized
      }
    }
  }
}
    `;

/**
 * __useReadConfigRepresentationWithoutEventsQuery__
 *
 * To run a query within a React component, call `useReadConfigRepresentationWithoutEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConfigRepresentationWithoutEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConfigRepresentationWithoutEventsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadConfigRepresentationWithoutEventsQuery(baseOptions: Apollo.QueryHookOptions<ReadConfigRepresentationWithoutEventsQuery, ReadConfigRepresentationWithoutEventsQueryVariables>) {
        return Apollo.useQuery<ReadConfigRepresentationWithoutEventsQuery, ReadConfigRepresentationWithoutEventsQueryVariables>(ReadConfigRepresentationWithoutEventsDocument, baseOptions);
      }
export function useReadConfigRepresentationWithoutEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConfigRepresentationWithoutEventsQuery, ReadConfigRepresentationWithoutEventsQueryVariables>) {
          return Apollo.useLazyQuery<ReadConfigRepresentationWithoutEventsQuery, ReadConfigRepresentationWithoutEventsQueryVariables>(ReadConfigRepresentationWithoutEventsDocument, baseOptions);
        }
export type ReadConfigRepresentationWithoutEventsQueryHookResult = ReturnType<typeof useReadConfigRepresentationWithoutEventsQuery>;
export type ReadConfigRepresentationWithoutEventsLazyQueryHookResult = ReturnType<typeof useReadConfigRepresentationWithoutEventsLazyQuery>;
export type ReadConfigRepresentationWithoutEventsQueryResult = Apollo.QueryResult<ReadConfigRepresentationWithoutEventsQuery, ReadConfigRepresentationWithoutEventsQueryVariables>;
export const ReadConfigurationDocument = gql`
    query readConfiguration($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    ...ConfigurationFields
  }
}
    ${ConfigurationFieldsFragmentDoc}`;

/**
 * __useReadConfigurationQuery__
 *
 * To run a query within a React component, call `useReadConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConfigurationQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadConfigurationQuery(baseOptions: Apollo.QueryHookOptions<ReadConfigurationQuery, ReadConfigurationQueryVariables>) {
        return Apollo.useQuery<ReadConfigurationQuery, ReadConfigurationQueryVariables>(ReadConfigurationDocument, baseOptions);
      }
export function useReadConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConfigurationQuery, ReadConfigurationQueryVariables>) {
          return Apollo.useLazyQuery<ReadConfigurationQuery, ReadConfigurationQueryVariables>(ReadConfigurationDocument, baseOptions);
        }
export type ReadConfigurationQueryHookResult = ReturnType<typeof useReadConfigurationQuery>;
export type ReadConfigurationLazyQueryHookResult = ReturnType<typeof useReadConfigurationLazyQuery>;
export type ReadConfigurationQueryResult = Apollo.QueryResult<ReadConfigurationQuery, ReadConfigurationQueryVariables>;
export const ReadConfigurationBaseInfoDocument = gql`
    query readConfigurationBaseInfo($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    uuid
    user
    configType: type
    private
  }
}
    `;

/**
 * __useReadConfigurationBaseInfoQuery__
 *
 * To run a query within a React component, call `useReadConfigurationBaseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConfigurationBaseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConfigurationBaseInfoQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadConfigurationBaseInfoQuery(baseOptions: Apollo.QueryHookOptions<ReadConfigurationBaseInfoQuery, ReadConfigurationBaseInfoQueryVariables>) {
        return Apollo.useQuery<ReadConfigurationBaseInfoQuery, ReadConfigurationBaseInfoQueryVariables>(ReadConfigurationBaseInfoDocument, baseOptions);
      }
export function useReadConfigurationBaseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConfigurationBaseInfoQuery, ReadConfigurationBaseInfoQueryVariables>) {
          return Apollo.useLazyQuery<ReadConfigurationBaseInfoQuery, ReadConfigurationBaseInfoQueryVariables>(ReadConfigurationBaseInfoDocument, baseOptions);
        }
export type ReadConfigurationBaseInfoQueryHookResult = ReturnType<typeof useReadConfigurationBaseInfoQuery>;
export type ReadConfigurationBaseInfoLazyQueryHookResult = ReturnType<typeof useReadConfigurationBaseInfoLazyQuery>;
export type ReadConfigurationBaseInfoQueryResult = Apollo.QueryResult<ReadConfigurationBaseInfoQuery, ReadConfigurationBaseInfoQueryVariables>;
export const ReadConfigurationSummaryDocument = gql`
    query readConfigurationSummary($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    areaSummary {
      configuredAreas
      configuredDevices
    }
  }
}
    `;

/**
 * __useReadConfigurationSummaryQuery__
 *
 * To run a query within a React component, call `useReadConfigurationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConfigurationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConfigurationSummaryQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadConfigurationSummaryQuery(baseOptions: Apollo.QueryHookOptions<ReadConfigurationSummaryQuery, ReadConfigurationSummaryQueryVariables>) {
        return Apollo.useQuery<ReadConfigurationSummaryQuery, ReadConfigurationSummaryQueryVariables>(ReadConfigurationSummaryDocument, baseOptions);
      }
export function useReadConfigurationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConfigurationSummaryQuery, ReadConfigurationSummaryQueryVariables>) {
          return Apollo.useLazyQuery<ReadConfigurationSummaryQuery, ReadConfigurationSummaryQueryVariables>(ReadConfigurationSummaryDocument, baseOptions);
        }
export type ReadConfigurationSummaryQueryHookResult = ReturnType<typeof useReadConfigurationSummaryQuery>;
export type ReadConfigurationSummaryLazyQueryHookResult = ReturnType<typeof useReadConfigurationSummaryLazyQuery>;
export type ReadConfigurationSummaryQueryResult = Apollo.QueryResult<ReadConfigurationSummaryQuery, ReadConfigurationSummaryQueryVariables>;
export const ReadDataToDetermineUsedNodesNamesDocument = gql`
    query readDataToDetermineUsedNodesNames($configurationUuid: String!, $skipReadConfiguration: Boolean = false, $skipReadLibrary: Boolean = false) {
  readConfiguration(uuid: $configurationUuid) @skip(if: $skipReadConfiguration) {
    scenarioData {
      representation {
        serialized
      }
      latest {
        serialized
      }
    }
  }
  readLibrary(uuid: $configurationUuid) @skip(if: $skipReadLibrary) {
    scenarioData {
      representation {
        ... on PV {
          serialized
        }
        ... on Storage {
          serialized
        }
        ... on Load {
          serialized
        }
        ... on FiniteDieselGenerator {
          serialized
        }
        ... on MarketMaker {
          serialized
        }
        ... on InfiniteBus {
          serialized
        }
        ... on AreaOutput {
          serialized
        }
      }
    }
  }
  listLiveEvents(configUuid: $configurationUuid) {
    diff
  }
}
    `;

/**
 * __useReadDataToDetermineUsedNodesNamesQuery__
 *
 * To run a query within a React component, call `useReadDataToDetermineUsedNodesNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDataToDetermineUsedNodesNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDataToDetermineUsedNodesNamesQuery({
 *   variables: {
 *      configurationUuid: // value for 'configurationUuid'
 *      skipReadConfiguration: // value for 'skipReadConfiguration'
 *      skipReadLibrary: // value for 'skipReadLibrary'
 *   },
 * });
 */
export function useReadDataToDetermineUsedNodesNamesQuery(baseOptions: Apollo.QueryHookOptions<ReadDataToDetermineUsedNodesNamesQuery, ReadDataToDetermineUsedNodesNamesQueryVariables>) {
        return Apollo.useQuery<ReadDataToDetermineUsedNodesNamesQuery, ReadDataToDetermineUsedNodesNamesQueryVariables>(ReadDataToDetermineUsedNodesNamesDocument, baseOptions);
      }
export function useReadDataToDetermineUsedNodesNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDataToDetermineUsedNodesNamesQuery, ReadDataToDetermineUsedNodesNamesQueryVariables>) {
          return Apollo.useLazyQuery<ReadDataToDetermineUsedNodesNamesQuery, ReadDataToDetermineUsedNodesNamesQueryVariables>(ReadDataToDetermineUsedNodesNamesDocument, baseOptions);
        }
export type ReadDataToDetermineUsedNodesNamesQueryHookResult = ReturnType<typeof useReadDataToDetermineUsedNodesNamesQuery>;
export type ReadDataToDetermineUsedNodesNamesLazyQueryHookResult = ReturnType<typeof useReadDataToDetermineUsedNodesNamesLazyQuery>;
export type ReadDataToDetermineUsedNodesNamesQueryResult = Apollo.QueryResult<ReadDataToDetermineUsedNodesNamesQuery, ReadDataToDetermineUsedNodesNamesQueryVariables>;
export const GetUserGlobalLocationVisibilityDocument = gql`
    query getUserGlobalLocationVisibility {
  getUserGlobalLocationVisibility
}
    `;

/**
 * __useGetUserGlobalLocationVisibilityQuery__
 *
 * To run a query within a React component, call `useGetUserGlobalLocationVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGlobalLocationVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGlobalLocationVisibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGlobalLocationVisibilityQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGlobalLocationVisibilityQuery, GetUserGlobalLocationVisibilityQueryVariables>) {
        return Apollo.useQuery<GetUserGlobalLocationVisibilityQuery, GetUserGlobalLocationVisibilityQueryVariables>(GetUserGlobalLocationVisibilityDocument, baseOptions);
      }
export function useGetUserGlobalLocationVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGlobalLocationVisibilityQuery, GetUserGlobalLocationVisibilityQueryVariables>) {
          return Apollo.useLazyQuery<GetUserGlobalLocationVisibilityQuery, GetUserGlobalLocationVisibilityQueryVariables>(GetUserGlobalLocationVisibilityDocument, baseOptions);
        }
export type GetUserGlobalLocationVisibilityQueryHookResult = ReturnType<typeof useGetUserGlobalLocationVisibilityQuery>;
export type GetUserGlobalLocationVisibilityLazyQueryHookResult = ReturnType<typeof useGetUserGlobalLocationVisibilityLazyQuery>;
export type GetUserGlobalLocationVisibilityQueryResult = Apollo.QueryResult<GetUserGlobalLocationVisibilityQuery, GetUserGlobalLocationVisibilityQueryVariables>;
export const ListGlobalSimulationLocationDocument = gql`
    query listGlobalSimulationLocation($minLat: Float!, $minLong: Float!, $maxLat: Float!, $maxLong: Float!) {
  listGlobalSimulationLocation(
    minLat: $minLat
    maxLat: $maxLat
    minLong: $minLong
    maxLong: $maxLong
  ) {
    boundaryId
    totalMarkets
    totalDevices
    simulationsInProgress
  }
}
    `;

/**
 * __useListGlobalSimulationLocationQuery__
 *
 * To run a query within a React component, call `useListGlobalSimulationLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGlobalSimulationLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGlobalSimulationLocationQuery({
 *   variables: {
 *      minLat: // value for 'minLat'
 *      minLong: // value for 'minLong'
 *      maxLat: // value for 'maxLat'
 *      maxLong: // value for 'maxLong'
 *   },
 * });
 */
export function useListGlobalSimulationLocationQuery(baseOptions: Apollo.QueryHookOptions<ListGlobalSimulationLocationQuery, ListGlobalSimulationLocationQueryVariables>) {
        return Apollo.useQuery<ListGlobalSimulationLocationQuery, ListGlobalSimulationLocationQueryVariables>(ListGlobalSimulationLocationDocument, baseOptions);
      }
export function useListGlobalSimulationLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGlobalSimulationLocationQuery, ListGlobalSimulationLocationQueryVariables>) {
          return Apollo.useLazyQuery<ListGlobalSimulationLocationQuery, ListGlobalSimulationLocationQueryVariables>(ListGlobalSimulationLocationDocument, baseOptions);
        }
export type ListGlobalSimulationLocationQueryHookResult = ReturnType<typeof useListGlobalSimulationLocationQuery>;
export type ListGlobalSimulationLocationLazyQueryHookResult = ReturnType<typeof useListGlobalSimulationLocationLazyQuery>;
export type ListGlobalSimulationLocationQueryResult = Apollo.QueryResult<ListGlobalSimulationLocationQuery, ListGlobalSimulationLocationQueryVariables>;
export const ListUserGlobalSimulationVisibilityDocument = gql`
    query listUserGlobalSimulationVisibility {
  listUserGlobalSimulationVisibility {
    configUuid
    visibility
    boundaryId
    totalMarkets
    totalDevices
    simulationsInProgress
    configType: type
    projectUuid
  }
}
    `;

/**
 * __useListUserGlobalSimulationVisibilityQuery__
 *
 * To run a query within a React component, call `useListUserGlobalSimulationVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserGlobalSimulationVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserGlobalSimulationVisibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useListUserGlobalSimulationVisibilityQuery(baseOptions?: Apollo.QueryHookOptions<ListUserGlobalSimulationVisibilityQuery, ListUserGlobalSimulationVisibilityQueryVariables>) {
        return Apollo.useQuery<ListUserGlobalSimulationVisibilityQuery, ListUserGlobalSimulationVisibilityQueryVariables>(ListUserGlobalSimulationVisibilityDocument, baseOptions);
      }
export function useListUserGlobalSimulationVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserGlobalSimulationVisibilityQuery, ListUserGlobalSimulationVisibilityQueryVariables>) {
          return Apollo.useLazyQuery<ListUserGlobalSimulationVisibilityQuery, ListUserGlobalSimulationVisibilityQueryVariables>(ListUserGlobalSimulationVisibilityDocument, baseOptions);
        }
export type ListUserGlobalSimulationVisibilityQueryHookResult = ReturnType<typeof useListUserGlobalSimulationVisibilityQuery>;
export type ListUserGlobalSimulationVisibilityLazyQueryHookResult = ReturnType<typeof useListUserGlobalSimulationVisibilityLazyQuery>;
export type ListUserGlobalSimulationVisibilityQueryResult = Apollo.QueryResult<ListUserGlobalSimulationVisibilityQuery, ListUserGlobalSimulationVisibilityQueryVariables>;
export const ReadGlobalSimulationLocationDocument = gql`
    query readGlobalSimulationLocation($configUuid: String!) {
  readGlobalSimulationLocation(configUuid: $configUuid) {
    longitude
    latitude
    boundaryId
    visibility
  }
}
    `;

/**
 * __useReadGlobalSimulationLocationQuery__
 *
 * To run a query within a React component, call `useReadGlobalSimulationLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadGlobalSimulationLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadGlobalSimulationLocationQuery({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *   },
 * });
 */
export function useReadGlobalSimulationLocationQuery(baseOptions: Apollo.QueryHookOptions<ReadGlobalSimulationLocationQuery, ReadGlobalSimulationLocationQueryVariables>) {
        return Apollo.useQuery<ReadGlobalSimulationLocationQuery, ReadGlobalSimulationLocationQueryVariables>(ReadGlobalSimulationLocationDocument, baseOptions);
      }
export function useReadGlobalSimulationLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadGlobalSimulationLocationQuery, ReadGlobalSimulationLocationQueryVariables>) {
          return Apollo.useLazyQuery<ReadGlobalSimulationLocationQuery, ReadGlobalSimulationLocationQueryVariables>(ReadGlobalSimulationLocationDocument, baseOptions);
        }
export type ReadGlobalSimulationLocationQueryHookResult = ReturnType<typeof useReadGlobalSimulationLocationQuery>;
export type ReadGlobalSimulationLocationLazyQueryHookResult = ReturnType<typeof useReadGlobalSimulationLocationLazyQuery>;
export type ReadGlobalSimulationLocationQueryResult = Apollo.QueryResult<ReadGlobalSimulationLocationQuery, ReadGlobalSimulationLocationQueryVariables>;
export const ListLibrariesDocument = gql`
    query listLibraries($skip: Int, $first: Int, $search: String, $tags: [String]) {
  listLibraries(skip: $skip, first: $first, search: $search, tags: $tags) {
    totalCount
    libraries {
      name
      uuid
      description
      user
      private
      readOnly
      scenarioData {
        representation {
          ... on PV {
            serialized
            type
            uuid
          }
          ... on Storage {
            serialized
            type
            uuid
          }
          ... on Load {
            serialized
            type
            uuid
          }
          ... on FiniteDieselGenerator {
            serialized
            type
            uuid
          }
          ... on MarketMaker {
            serialized
            type
            uuid
          }
          ... on InfiniteBus {
            serialized
            type
            uuid
          }
          ... on AreaOutput {
            serialized
            type
            uuid
          }
          ... on SmartMeter {
            serialized
            type
            uuid
          }
        }
        deviceCountNumber
        areaCountNumber
      }
    }
  }
}
    `;

/**
 * __useListLibrariesQuery__
 *
 * To run a query within a React component, call `useListLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLibrariesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useListLibrariesQuery(baseOptions?: Apollo.QueryHookOptions<ListLibrariesQuery, ListLibrariesQueryVariables>) {
        return Apollo.useQuery<ListLibrariesQuery, ListLibrariesQueryVariables>(ListLibrariesDocument, baseOptions);
      }
export function useListLibrariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLibrariesQuery, ListLibrariesQueryVariables>) {
          return Apollo.useLazyQuery<ListLibrariesQuery, ListLibrariesQueryVariables>(ListLibrariesDocument, baseOptions);
        }
export type ListLibrariesQueryHookResult = ReturnType<typeof useListLibrariesQuery>;
export type ListLibrariesLazyQueryHookResult = ReturnType<typeof useListLibrariesLazyQuery>;
export type ListLibrariesQueryResult = Apollo.QueryResult<ListLibrariesQuery, ListLibrariesQueryVariables>;
export const ListLibrariesWithDataDocument = gql`
    query listLibrariesWithData($search: String, $tags: [String]) {
  listLibraries(tags: $tags, search: $search) {
    totalCount
    libraries {
      name
      uuid
      private
      scenarioData {
        deviceCount
        deviceCountNumber
        areaCountNumber
        representation {
          ... on PV {
            serialized
          }
          ... on Storage {
            serialized
          }
          ... on Load {
            serialized
          }
          ... on MarketMaker {
            serialized
            energyRateProfileUuid
          }
          ... on InfiniteBus {
            serialized
            energyRateProfileUuid
            buyingRateProfileUuid
          }
          ... on FiniteDieselGenerator {
            serialized
          }
          ... on AreaOutput {
            serialized
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListLibrariesWithDataQuery__
 *
 * To run a query within a React component, call `useListLibrariesWithDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLibrariesWithDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLibrariesWithDataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useListLibrariesWithDataQuery(baseOptions?: Apollo.QueryHookOptions<ListLibrariesWithDataQuery, ListLibrariesWithDataQueryVariables>) {
        return Apollo.useQuery<ListLibrariesWithDataQuery, ListLibrariesWithDataQueryVariables>(ListLibrariesWithDataDocument, baseOptions);
      }
export function useListLibrariesWithDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLibrariesWithDataQuery, ListLibrariesWithDataQueryVariables>) {
          return Apollo.useLazyQuery<ListLibrariesWithDataQuery, ListLibrariesWithDataQueryVariables>(ListLibrariesWithDataDocument, baseOptions);
        }
export type ListLibrariesWithDataQueryHookResult = ReturnType<typeof useListLibrariesWithDataQuery>;
export type ListLibrariesWithDataLazyQueryHookResult = ReturnType<typeof useListLibrariesWithDataLazyQuery>;
export type ListLibrariesWithDataQueryResult = Apollo.QueryResult<ListLibrariesWithDataQuery, ListLibrariesWithDataQueryVariables>;
export const ReadLibraryDocument = gql`
    query readLibrary($uuid: String!) {
  readLibrary(uuid: $uuid) {
    uuid
    name
    description
    readOnly
    scenarioData {
      deviceCountNumber
      areaCountNumber
      representation {
        ... on PV {
          serialized
        }
        ... on Storage {
          serialized
        }
        ... on Load {
          serialized
        }
        ... on FiniteDieselGenerator {
          serialized
        }
        ... on MarketMaker {
          serialized
        }
        ... on InfiniteBus {
          serialized
        }
        ... on AreaOutput {
          serialized
        }
      }
    }
  }
}
    `;

/**
 * __useReadLibraryQuery__
 *
 * To run a query within a React component, call `useReadLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLibraryQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadLibraryQuery(baseOptions: Apollo.QueryHookOptions<ReadLibraryQuery, ReadLibraryQueryVariables>) {
        return Apollo.useQuery<ReadLibraryQuery, ReadLibraryQueryVariables>(ReadLibraryDocument, baseOptions);
      }
export function useReadLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLibraryQuery, ReadLibraryQueryVariables>) {
          return Apollo.useLazyQuery<ReadLibraryQuery, ReadLibraryQueryVariables>(ReadLibraryDocument, baseOptions);
        }
export type ReadLibraryQueryHookResult = ReturnType<typeof useReadLibraryQuery>;
export type ReadLibraryLazyQueryHookResult = ReturnType<typeof useReadLibraryLazyQuery>;
export type ReadLibraryQueryResult = Apollo.QueryResult<ReadLibraryQuery, ReadLibraryQueryVariables>;
export const ListLiveEventsDocument = gql`
    query listLiveEvents($configUUID: String!) {
  listLiveEvents(configUuid: $configUUID) {
    eventType
    parameters
    timeStamp
    diff
  }
}
    `;

/**
 * __useListLiveEventsQuery__
 *
 * To run a query within a React component, call `useListLiveEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLiveEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLiveEventsQuery({
 *   variables: {
 *      configUUID: // value for 'configUUID'
 *   },
 * });
 */
export function useListLiveEventsQuery(baseOptions: Apollo.QueryHookOptions<ListLiveEventsQuery, ListLiveEventsQueryVariables>) {
        return Apollo.useQuery<ListLiveEventsQuery, ListLiveEventsQueryVariables>(ListLiveEventsDocument, baseOptions);
      }
export function useListLiveEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLiveEventsQuery, ListLiveEventsQueryVariables>) {
          return Apollo.useLazyQuery<ListLiveEventsQuery, ListLiveEventsQueryVariables>(ListLiveEventsDocument, baseOptions);
        }
export type ListLiveEventsQueryHookResult = ReturnType<typeof useListLiveEventsQuery>;
export type ListLiveEventsLazyQueryHookResult = ReturnType<typeof useListLiveEventsLazyQuery>;
export type ListLiveEventsQueryResult = Apollo.QueryResult<ListLiveEventsQuery, ListLiveEventsQueryVariables>;
export const LiveEventsRepresentationDocument = gql`
    query liveEventsRepresentation($configUuid: String!, $time: DateTime!) {
  liveEventsRepresentation(configUuid: $configUuid, time: $time) {
    timeStamp
    representation {
      serialized
    }
  }
}
    `;

/**
 * __useLiveEventsRepresentationQuery__
 *
 * To run a query within a React component, call `useLiveEventsRepresentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventsRepresentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventsRepresentationQuery({
 *   variables: {
 *      configUuid: // value for 'configUuid'
 *      time: // value for 'time'
 *   },
 * });
 */
export function useLiveEventsRepresentationQuery(baseOptions: Apollo.QueryHookOptions<LiveEventsRepresentationQuery, LiveEventsRepresentationQueryVariables>) {
        return Apollo.useQuery<LiveEventsRepresentationQuery, LiveEventsRepresentationQueryVariables>(LiveEventsRepresentationDocument, baseOptions);
      }
export function useLiveEventsRepresentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveEventsRepresentationQuery, LiveEventsRepresentationQueryVariables>) {
          return Apollo.useLazyQuery<LiveEventsRepresentationQuery, LiveEventsRepresentationQueryVariables>(LiveEventsRepresentationDocument, baseOptions);
        }
export type LiveEventsRepresentationQueryHookResult = ReturnType<typeof useLiveEventsRepresentationQuery>;
export type LiveEventsRepresentationLazyQueryHookResult = ReturnType<typeof useLiveEventsRepresentationLazyQuery>;
export type LiveEventsRepresentationQueryResult = Apollo.QueryResult<LiveEventsRepresentationQuery, LiveEventsRepresentationQueryVariables>;
export const ListProjectStatusesDocument = gql`
    query listProjectStatuses($search: String, $nrConfigs: Int) {
  listProjects(search: $search, nrConfigs: $nrConfigs) {
    uuid
    configurations {
      uuid
      name
      resultsStatus
    }
  }
}
    `;

/**
 * __useListProjectStatusesQuery__
 *
 * To run a query within a React component, call `useListProjectStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectStatusesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      nrConfigs: // value for 'nrConfigs'
 *   },
 * });
 */
export function useListProjectStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ListProjectStatusesQuery, ListProjectStatusesQueryVariables>) {
        return Apollo.useQuery<ListProjectStatusesQuery, ListProjectStatusesQueryVariables>(ListProjectStatusesDocument, baseOptions);
      }
export function useListProjectStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectStatusesQuery, ListProjectStatusesQueryVariables>) {
          return Apollo.useLazyQuery<ListProjectStatusesQuery, ListProjectStatusesQueryVariables>(ListProjectStatusesDocument, baseOptions);
        }
export type ListProjectStatusesQueryHookResult = ReturnType<typeof useListProjectStatusesQuery>;
export type ListProjectStatusesLazyQueryHookResult = ReturnType<typeof useListProjectStatusesLazyQuery>;
export type ListProjectStatusesQueryResult = Apollo.QueryResult<ListProjectStatusesQuery, ListProjectStatusesQueryVariables>;
export const ListProjectsDocument = gql`
    query listProjects($search: String, $nrConfigs: Int) {
  listProjects(search: $search, nrConfigs: $nrConfigs) {
    name
    uuid
    description
    user
    private
    configurations {
      uuid
      name
      resultsStatus
    }
  }
}
    `;

/**
 * __useListProjectsQuery__
 *
 * To run a query within a React component, call `useListProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      nrConfigs: // value for 'nrConfigs'
 *   },
 * });
 */
export function useListProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
        return Apollo.useQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, baseOptions);
      }
export function useListProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
          return Apollo.useLazyQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, baseOptions);
        }
export type ListProjectsQueryHookResult = ReturnType<typeof useListProjectsQuery>;
export type ListProjectsLazyQueryHookResult = ReturnType<typeof useListProjectsLazyQuery>;
export type ListProjectsQueryResult = Apollo.QueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export const ReadProjectDocument = gql`
    query readProject($uuid: String!) {
  readProject(uuid: $uuid) {
    name
    uuid
    user
    description
    private
    configurations {
      uuid
    }
  }
}
    `;

/**
 * __useReadProjectQuery__
 *
 * To run a query within a React component, call `useReadProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadProjectQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadProjectQuery(baseOptions: Apollo.QueryHookOptions<ReadProjectQuery, ReadProjectQueryVariables>) {
        return Apollo.useQuery<ReadProjectQuery, ReadProjectQueryVariables>(ReadProjectDocument, baseOptions);
      }
export function useReadProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadProjectQuery, ReadProjectQueryVariables>) {
          return Apollo.useLazyQuery<ReadProjectQuery, ReadProjectQueryVariables>(ReadProjectDocument, baseOptions);
        }
export type ReadProjectQueryHookResult = ReturnType<typeof useReadProjectQuery>;
export type ReadProjectLazyQueryHookResult = ReturnType<typeof useReadProjectLazyQuery>;
export type ReadProjectQueryResult = Apollo.QueryResult<ReadProjectQuery, ReadProjectQueryVariables>;
export const ReadProjectLocationVisibilityDocument = gql`
    query readProjectLocationVisibility($projectUuid: String!) {
  readProject(uuid: $projectUuid) {
    locationVisible
    private
  }
}
    `;

/**
 * __useReadProjectLocationVisibilityQuery__
 *
 * To run a query within a React component, call `useReadProjectLocationVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadProjectLocationVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadProjectLocationVisibilityQuery({
 *   variables: {
 *      projectUuid: // value for 'projectUuid'
 *   },
 * });
 */
export function useReadProjectLocationVisibilityQuery(baseOptions: Apollo.QueryHookOptions<ReadProjectLocationVisibilityQuery, ReadProjectLocationVisibilityQueryVariables>) {
        return Apollo.useQuery<ReadProjectLocationVisibilityQuery, ReadProjectLocationVisibilityQueryVariables>(ReadProjectLocationVisibilityDocument, baseOptions);
      }
export function useReadProjectLocationVisibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadProjectLocationVisibilityQuery, ReadProjectLocationVisibilityQueryVariables>) {
          return Apollo.useLazyQuery<ReadProjectLocationVisibilityQuery, ReadProjectLocationVisibilityQueryVariables>(ReadProjectLocationVisibilityDocument, baseOptions);
        }
export type ReadProjectLocationVisibilityQueryHookResult = ReturnType<typeof useReadProjectLocationVisibilityQuery>;
export type ReadProjectLocationVisibilityLazyQueryHookResult = ReturnType<typeof useReadProjectLocationVisibilityLazyQuery>;
export type ReadProjectLocationVisibilityQueryResult = Apollo.QueryResult<ReadProjectLocationVisibilityQuery, ReadProjectLocationVisibilityQueryVariables>;
export const ReadProjectTitleDocument = gql`
    query readProjectTitle($uuid: String!) {
  readProject(uuid: $uuid) {
    name
  }
}
    `;

/**
 * __useReadProjectTitleQuery__
 *
 * To run a query within a React component, call `useReadProjectTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadProjectTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadProjectTitleQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadProjectTitleQuery(baseOptions: Apollo.QueryHookOptions<ReadProjectTitleQuery, ReadProjectTitleQueryVariables>) {
        return Apollo.useQuery<ReadProjectTitleQuery, ReadProjectTitleQueryVariables>(ReadProjectTitleDocument, baseOptions);
      }
export function useReadProjectTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadProjectTitleQuery, ReadProjectTitleQueryVariables>) {
          return Apollo.useLazyQuery<ReadProjectTitleQuery, ReadProjectTitleQueryVariables>(ReadProjectTitleDocument, baseOptions);
        }
export type ReadProjectTitleQueryHookResult = ReturnType<typeof useReadProjectTitleQuery>;
export type ReadProjectTitleLazyQueryHookResult = ReturnType<typeof useReadProjectTitleLazyQuery>;
export type ReadProjectTitleQueryResult = Apollo.QueryResult<ReadProjectTitleQuery, ReadProjectTitleQueryVariables>;
export const CommunitySummaryResultsDocument = gql`
    query communitySummaryResults($jobId: String!, $communityUuid: String!) {
  simulationResults(jobId: $jobId, uuid: $communityUuid, timeResolutionHrs: 2) {
    priceEnergyAreaBalance
    cumulativeNetEnergyFlow
  }
}
    `;

/**
 * __useCommunitySummaryResultsQuery__
 *
 * To run a query within a React component, call `useCommunitySummaryResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySummaryResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySummaryResultsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      communityUuid: // value for 'communityUuid'
 *   },
 * });
 */
export function useCommunitySummaryResultsQuery(baseOptions: Apollo.QueryHookOptions<CommunitySummaryResultsQuery, CommunitySummaryResultsQueryVariables>) {
        return Apollo.useQuery<CommunitySummaryResultsQuery, CommunitySummaryResultsQueryVariables>(CommunitySummaryResultsDocument, baseOptions);
      }
export function useCommunitySummaryResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySummaryResultsQuery, CommunitySummaryResultsQueryVariables>) {
          return Apollo.useLazyQuery<CommunitySummaryResultsQuery, CommunitySummaryResultsQueryVariables>(CommunitySummaryResultsDocument, baseOptions);
        }
export type CommunitySummaryResultsQueryHookResult = ReturnType<typeof useCommunitySummaryResultsQuery>;
export type CommunitySummaryResultsLazyQueryHookResult = ReturnType<typeof useCommunitySummaryResultsLazyQuery>;
export type CommunitySummaryResultsQueryResult = Apollo.QueryResult<CommunitySummaryResultsQuery, CommunitySummaryResultsQueryVariables>;
export const HouseSummaryResultsDocument = gql`
    query houseSummaryResults($jobId: String!, $assetUuid: String!, $timeResolutionHrs: Int) {
  simulationResults(
    jobId: $jobId
    uuid: $assetUuid
    timeResolutionHrs: $timeResolutionHrs
  ) {
    currentMarket
    areaThroughput
    marketSummary {
      averageEnergyRate
      timestamp
    }
    status
  }
}
    `;

/**
 * __useHouseSummaryResultsQuery__
 *
 * To run a query within a React component, call `useHouseSummaryResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseSummaryResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseSummaryResultsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      assetUuid: // value for 'assetUuid'
 *      timeResolutionHrs: // value for 'timeResolutionHrs'
 *   },
 * });
 */
export function useHouseSummaryResultsQuery(baseOptions: Apollo.QueryHookOptions<HouseSummaryResultsQuery, HouseSummaryResultsQueryVariables>) {
        return Apollo.useQuery<HouseSummaryResultsQuery, HouseSummaryResultsQueryVariables>(HouseSummaryResultsDocument, baseOptions);
      }
export function useHouseSummaryResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HouseSummaryResultsQuery, HouseSummaryResultsQueryVariables>) {
          return Apollo.useLazyQuery<HouseSummaryResultsQuery, HouseSummaryResultsQueryVariables>(HouseSummaryResultsDocument, baseOptions);
        }
export type HouseSummaryResultsQueryHookResult = ReturnType<typeof useHouseSummaryResultsQuery>;
export type HouseSummaryResultsLazyQueryHookResult = ReturnType<typeof useHouseSummaryResultsLazyQuery>;
export type HouseSummaryResultsQueryResult = Apollo.QueryResult<HouseSummaryResultsQuery, HouseSummaryResultsQueryVariables>;
export const ReadScoreboardResultsDocument = gql`
    query readScoreboardResults($jobId: String!) {
  simulationStatus(jobId: $jobId)
  scoreboardResults(jobId: $jobId)
}
    `;

/**
 * __useReadScoreboardResultsQuery__
 *
 * To run a query within a React component, call `useReadScoreboardResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadScoreboardResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadScoreboardResultsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useReadScoreboardResultsQuery(baseOptions: Apollo.QueryHookOptions<ReadScoreboardResultsQuery, ReadScoreboardResultsQueryVariables>) {
        return Apollo.useQuery<ReadScoreboardResultsQuery, ReadScoreboardResultsQueryVariables>(ReadScoreboardResultsDocument, baseOptions);
      }
export function useReadScoreboardResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadScoreboardResultsQuery, ReadScoreboardResultsQueryVariables>) {
          return Apollo.useLazyQuery<ReadScoreboardResultsQuery, ReadScoreboardResultsQueryVariables>(ReadScoreboardResultsDocument, baseOptions);
        }
export type ReadScoreboardResultsQueryHookResult = ReturnType<typeof useReadScoreboardResultsQuery>;
export type ReadScoreboardResultsLazyQueryHookResult = ReturnType<typeof useReadScoreboardResultsLazyQuery>;
export type ReadScoreboardResultsQueryResult = Apollo.QueryResult<ReadScoreboardResultsQuery, ReadScoreboardResultsQueryVariables>;
export const ReadSimulationProgressDocument = gql`
    query readSimulationProgress($uuid: String!) {
  readConfiguration(uuid: $uuid) {
    resultsStatus
    resultsProgressInfo {
      percentageCompleted
    }
  }
}
    `;

/**
 * __useReadSimulationProgressQuery__
 *
 * To run a query within a React component, call `useReadSimulationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSimulationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSimulationProgressQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useReadSimulationProgressQuery(baseOptions: Apollo.QueryHookOptions<ReadSimulationProgressQuery, ReadSimulationProgressQueryVariables>) {
        return Apollo.useQuery<ReadSimulationProgressQuery, ReadSimulationProgressQueryVariables>(ReadSimulationProgressDocument, baseOptions);
      }
export function useReadSimulationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSimulationProgressQuery, ReadSimulationProgressQueryVariables>) {
          return Apollo.useLazyQuery<ReadSimulationProgressQuery, ReadSimulationProgressQueryVariables>(ReadSimulationProgressDocument, baseOptions);
        }
export type ReadSimulationProgressQueryHookResult = ReturnType<typeof useReadSimulationProgressQuery>;
export type ReadSimulationProgressLazyQueryHookResult = ReturnType<typeof useReadSimulationProgressLazyQuery>;
export type ReadSimulationProgressQueryResult = Apollo.QueryResult<ReadSimulationProgressQuery, ReadSimulationProgressQueryVariables>;
export const ReadSimulationResultsDocument = gql`
    query readSimulationResults($jobId: String!, $uuid: String!, $startTime: DateTime, $endTime: DateTime) {
  simulationStatus(jobId: $jobId)
  simulationResults(
    jobId: $jobId
    uuid: $uuid
    startTime: $startTime
    endTime: $endTime
  ) {
    areaUuid
    cumulativeBills
    cumulativeGridTrades
    currentMarket
    cumulativeNetEnergyFlow
    deviceStatistics
    energyTradeProfileAreaThroughput
    kpi
    marketSummary {
      externalTradedVolume
      averageEnergyRate
      timestamp
      tradedVolume
    }
    priceEnergyAreaBalance
    priceEnergyDay
    latestSavingsKpi(duration: DAILY)
    savingsKpiProfile(duration: DAILY)
    assetsInfo
    progressInfo {
      percentageCompleted
      etaSeconds
      elapsedTimeSeconds
    }
    status
  }
}
    `;

/**
 * __useReadSimulationResultsQuery__
 *
 * To run a query within a React component, call `useReadSimulationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSimulationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSimulationResultsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      uuid: // value for 'uuid'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useReadSimulationResultsQuery(baseOptions: Apollo.QueryHookOptions<ReadSimulationResultsQuery, ReadSimulationResultsQueryVariables>) {
        return Apollo.useQuery<ReadSimulationResultsQuery, ReadSimulationResultsQueryVariables>(ReadSimulationResultsDocument, baseOptions);
      }
export function useReadSimulationResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSimulationResultsQuery, ReadSimulationResultsQueryVariables>) {
          return Apollo.useLazyQuery<ReadSimulationResultsQuery, ReadSimulationResultsQueryVariables>(ReadSimulationResultsDocument, baseOptions);
        }
export type ReadSimulationResultsQueryHookResult = ReturnType<typeof useReadSimulationResultsQuery>;
export type ReadSimulationResultsLazyQueryHookResult = ReturnType<typeof useReadSimulationResultsLazyQuery>;
export type ReadSimulationResultsQueryResult = Apollo.QueryResult<ReadSimulationResultsQuery, ReadSimulationResultsQueryVariables>;
export const ReadSimulationResultsBidTradeDocument = gql`
    query readSimulationResultsBidTrade($jobId: String!, $assetUuid: String!, $startTime: DateTime, $endTime: DateTime) {
  simulationResults(
    jobId: $jobId
    uuid: $assetUuid
    startTime: $startTime
    endTime: $endTime
  ) {
    bidsOffersTrades
  }
}
    `;

/**
 * __useReadSimulationResultsBidTradeQuery__
 *
 * To run a query within a React component, call `useReadSimulationResultsBidTradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSimulationResultsBidTradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSimulationResultsBidTradeQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      assetUuid: // value for 'assetUuid'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useReadSimulationResultsBidTradeQuery(baseOptions: Apollo.QueryHookOptions<ReadSimulationResultsBidTradeQuery, ReadSimulationResultsBidTradeQueryVariables>) {
        return Apollo.useQuery<ReadSimulationResultsBidTradeQuery, ReadSimulationResultsBidTradeQueryVariables>(ReadSimulationResultsBidTradeDocument, baseOptions);
      }
export function useReadSimulationResultsBidTradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSimulationResultsBidTradeQuery, ReadSimulationResultsBidTradeQueryVariables>) {
          return Apollo.useLazyQuery<ReadSimulationResultsBidTradeQuery, ReadSimulationResultsBidTradeQueryVariables>(ReadSimulationResultsBidTradeDocument, baseOptions);
        }
export type ReadSimulationResultsBidTradeQueryHookResult = ReturnType<typeof useReadSimulationResultsBidTradeQuery>;
export type ReadSimulationResultsBidTradeLazyQueryHookResult = ReturnType<typeof useReadSimulationResultsBidTradeLazyQuery>;
export type ReadSimulationResultsBidTradeQueryResult = Apollo.QueryResult<ReadSimulationResultsBidTradeQuery, ReadSimulationResultsBidTradeQueryVariables>;
export const ReadSimulationResultsEnergyHiResDocument = gql`
    query readSimulationResultsEnergyHiRes($jobId: String!, $uuid: String!, $startTime: DateTime, $endTime: DateTime) {
  simulationResults(
    jobId: $jobId
    uuid: $uuid
    startTime: $startTime
    endTime: $endTime
  ) {
    energyTradesHighResolution
  }
}
    `;

/**
 * __useReadSimulationResultsEnergyHiResQuery__
 *
 * To run a query within a React component, call `useReadSimulationResultsEnergyHiResQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSimulationResultsEnergyHiResQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSimulationResultsEnergyHiResQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      uuid: // value for 'uuid'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useReadSimulationResultsEnergyHiResQuery(baseOptions: Apollo.QueryHookOptions<ReadSimulationResultsEnergyHiResQuery, ReadSimulationResultsEnergyHiResQueryVariables>) {
        return Apollo.useQuery<ReadSimulationResultsEnergyHiResQuery, ReadSimulationResultsEnergyHiResQueryVariables>(ReadSimulationResultsEnergyHiResDocument, baseOptions);
      }
export function useReadSimulationResultsEnergyHiResLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSimulationResultsEnergyHiResQuery, ReadSimulationResultsEnergyHiResQueryVariables>) {
          return Apollo.useLazyQuery<ReadSimulationResultsEnergyHiResQuery, ReadSimulationResultsEnergyHiResQueryVariables>(ReadSimulationResultsEnergyHiResDocument, baseOptions);
        }
export type ReadSimulationResultsEnergyHiResQueryHookResult = ReturnType<typeof useReadSimulationResultsEnergyHiResQuery>;
export type ReadSimulationResultsEnergyHiResLazyQueryHookResult = ReturnType<typeof useReadSimulationResultsEnergyHiResLazyQuery>;
export type ReadSimulationResultsEnergyHiResQueryResult = Apollo.QueryResult<ReadSimulationResultsEnergyHiResQuery, ReadSimulationResultsEnergyHiResQueryVariables>;
export const ReadSimulationStatusDocument = gql`
    query readSimulationStatus($jobId: String!) {
  simulationStatus(jobId: $jobId)
}
    `;

/**
 * __useReadSimulationStatusQuery__
 *
 * To run a query within a React component, call `useReadSimulationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSimulationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSimulationStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useReadSimulationStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadSimulationStatusQuery, ReadSimulationStatusQueryVariables>) {
        return Apollo.useQuery<ReadSimulationStatusQuery, ReadSimulationStatusQueryVariables>(ReadSimulationStatusDocument, baseOptions);
      }
export function useReadSimulationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSimulationStatusQuery, ReadSimulationStatusQueryVariables>) {
          return Apollo.useLazyQuery<ReadSimulationStatusQuery, ReadSimulationStatusQueryVariables>(ReadSimulationStatusDocument, baseOptions);
        }
export type ReadSimulationStatusQueryHookResult = ReturnType<typeof useReadSimulationStatusQuery>;
export type ReadSimulationStatusLazyQueryHookResult = ReturnType<typeof useReadSimulationStatusLazyQuery>;
export type ReadSimulationStatusQueryResult = Apollo.QueryResult<ReadSimulationStatusQuery, ReadSimulationStatusQueryVariables>;
export const RegisteredUserDocument = gql`
    query registeredUser {
  registeredUsers {
    username
    superuser
  }
}
    `;

/**
 * __useRegisteredUserQuery__
 *
 * To run a query within a React component, call `useRegisteredUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegisteredUserQuery(baseOptions?: Apollo.QueryHookOptions<RegisteredUserQuery, RegisteredUserQueryVariables>) {
        return Apollo.useQuery<RegisteredUserQuery, RegisteredUserQueryVariables>(RegisteredUserDocument, baseOptions);
      }
export function useRegisteredUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredUserQuery, RegisteredUserQueryVariables>) {
          return Apollo.useLazyQuery<RegisteredUserQuery, RegisteredUserQueryVariables>(RegisteredUserDocument, baseOptions);
        }
export type RegisteredUserQueryHookResult = ReturnType<typeof useRegisteredUserQuery>;
export type RegisteredUserLazyQueryHookResult = ReturnType<typeof useRegisteredUserLazyQuery>;
export type RegisteredUserQueryResult = Apollo.QueryResult<RegisteredUserQuery, RegisteredUserQueryVariables>;